import ServiceClass from "../../../services/service";
import validation from '../../../services/validation'; // Service Class
import Commons from '../../../resources/commons.js'; //Commons class
import PostsCo from '../../../components/mixins/postsco/script.js'

let service = new ServiceClass();
let validator = new validation();
export default {
    name: 'Settings',
    mixins: [Commons,PostsCo],
    // data () {
    //     return {
    //         disable_btn:false,
    //         loading:false,
    //         action_loading:false,
    //         data_error_message:"",
    //         data_processing_message:"",
    //         menu_tab_view:{},
    //         menu_tab_inner_view:{},
    //         product_details:{}
    //     }
    // },
    data () {
        return {
            //defaults
            header_name:service.app_name,
            kip:0,
            user: {},
            sellpoints:{},
            sellpoint:{},
            business:{}, //binds to sellpoints
            products:{},
            product:{},
            product_item_group:{},
            product_item:{},
            categories:{},
            category:{},
            main_category:{},
            sub_categories:[],
            category_type_1: false,
            category_type_2: false,
            category_type_3: false,
            sellpoint_gallery:{},
            galleria:{},
            lookbooks:{},
            lookbook:{},
            lookbook_post:{},
            menu_view:{},
            menu_tab_view:{},
            menu_tab_inner_view:{},
            is_view:"",
            is_viewing:"Account",
            is_viewed: "Account",
            is_view_type: "Account",
            img_url: service.imageURL,
            server_query_done:false,
            setPanel: false,
            loading:true,
            action_loading:false,
            disable_btn:false,
            data_processing_message:"",
            data_error_message:"",
            data_success_message:"",
            data_media_error_message:"",
            max_media_info:service.max_upload_image_info,
            max_plan_lookbooks:0,
            max_plan_lookbook_posts:0,
            total_lookbooks_added:0,
            can_add_more_lookbook:false,
            can_add_product_lookbook:false,
            img_sellpoint_url: service.imageSellpointsURL,
            img_product_url: service.imageProductsURL,
            setSettings:false,
            setting_details:{},
            //.../defaults

            //more settings
            states:{},
            cities:{},
            dvco_cities:{},
            delivery_partners:{},
            delivery_option:{},
            other_delivery_option:false,
            edit_other_delivery_option:false,
            custom_delivery_option:false,
            set_dvco_delivery_option:false,
            delivery_custom_options:{},
            component_view:{viewProducts:true,viewProduct:false,viewLookbooks:true,viewLookbook:false,viewLookbookPost:false,},
            business_details:{delivery_edit:false,delivery_add:false,delivery_option_edit:false,viewDiscounts:true,setDiscount:false},
            product_details:{},
            lookbook_details:{},
            manageList:["manageBusinesses","manageProducts","manageServices","manageLookbooks"],
            manage:["manageBusinesses","manageProducts","manageServices","manageLookbooks"],
            discount_coupon:{},
            discount_coupon_is_gift_card: false,
            discount_coupon_is_direct: false,
            managePanel:false,
            manageBusinesses:true, //default view
            manageProducts:false,
            manageServices:false,
            manageLookbooks:false,
            managePosts:false,
            manageOrders:false,
            manageBusinessDetails:false,
            businessComponents: ["BusinessEditing","BusinessDeliveryShipping","BusinessCoupons","BusinessPaymentGateway"],
            business_set_shipping_fee_status:9,
            addDeliveryInformation:false,
            editDeliveryInformation:false,
            product_set_shipping_fee_status:12,
            set_shipping_fee_status_track:false,

            //business settings
            business_agent:0,
            business_open_agents_products:{},
            business_product_categories:[],
            business_service_categories:[],
            business_category_type:0,
            validate_user_name_error:false,
            validate_user_name_message:"",
            
            //product settings
            product_display_image:{},
            product_item:{},
            file_info: {},
            files_info:[], //muttiple files
            imageForm: "",
            imagesFormArray: [], //multiple files
            is_product_service: "product",
            max_upload: service.max_media_upload,
            
            
            //productitems settings
            show_product_setting_box:false,
            // showProductItemGroups: true,
            showProductItemGroups:"",
            tap_01:0,
            //...more--settings

            //loobook settings
            viewing_lookbook: {}, //store viewing lookbook for product swich
            viewing_lookbook_post:{},
            is_viewing_lookbook: false,

            //posts settings
            post:{},
            posts:{},
            viewPost:false,

            //groups
            group:{},
            groups:{},
            group_member:{},
            view_group_members:false,
            share_group: false,

            //core confirmed settings
            current_sellpoint_id:0,
            market_groups: {},
            app_orders:{},
            order:{},
            orders:{},
            order_chart:{},
            order_additionals:{},
            viewOrder:false,
            viewPendingPayOrder:false,
            viewPendingPayOrders:false,
            sellpoint_orders:{},
            sellpoint_pending_orders:{},
            sellpoint_transactions:{},
            processing_fee:{},
            //payment gateways
            payment_gateways:{}, 
            ravepay_bank_list:{},
            ravepay_sba:{}, //ravepay_subaccount

            //
            set_reward_type_amount_type:"C", //default
            product_is_wholesale:false,
            prdItemPriceKey:0,
            prdItemWholesaleKey:0,
            //keys
            businessComponentKey:1,
            orderComponentKey:1,
            productVariationComponentKey:1,
            productOrdersComponentKey:1,
            attachProductsComponentKey:1,
            deliveryAddByDcoKey:1,

            //settings
            user_settings:{},

            //agentsco
            broker_deal:{},
            broker_request:{},
            broker_deals:{},
            broker_requests:{},

            //
            market_circle:{},
            subscriptions:{},
            subscribers:{},
            set_sub_view: 'subscriptions',

            //
            set_order_pending_payment_data:"",
            set_pending_payment_data:{},

            //services-more
            service_duration:"",
            service_offers:[],
            service_offer:{},

            //utilities
            data_call_to_actions:{},
            data_components_services:{},

            //
            component_loading:{},

            //
            set_menu:  false,
            menu_link:{},
            back_link_view: 1, //default
            prev_menu_link: '',
            current_menu_link: '',
            prev_menu_tab_view: '',
            current_menu_tab_view: '',
            customers: {},
            customer:{},
            reco_products:{},
            has_sellpoints: true,
            productAddView02ComponentKey:0,
            active_group:{},
            ///
            saved_shops:[],
            //
            business_app_subscription: {},
            business_app_subscription_offers: {},
            subscription_offer: {},
            //
            business_delivery_options_nodes:{},
            //
            componentKey:0,
            componentDeliveryKey:0,
            //
            sellpoint_categories:{},
            search_member:{},
            display_members:{},
            //
            set_reward_commission:0,
            business_open_to_agents:{},
            //
            getService:service, //return service class object
            //
            data_user: {},
            invoice_added_items: [],
            //
            set_product:{},
            set_products_as_addons: [],
            set_products_as_available:[],
            set_product_addons:{},
            set_order_product_addons:[],
            set_order_list:[],
            set_order_addons:[],
            set_order_data:{},
            set_order_total_amount:0,
            set_order_delivery_location:{},
            set_ordered_items:[],
            set_detail:{},
            set_payment_mode:0,
            business_bank_details:{},
            business_delivery_locations:[],
            setEditBankDetails:false,
            setAddDeliveryLocation:false,
            set_single_component_view:'',
            set_user_loggedIn: false,
            //
            data_processing_messages:{},
            data_loading: {
                businesses:false,
                business:false,
                categories:false,
                category:false,
                products:false,
                product:false,
            },
            // product_set_details:[
            //     {type:"",title:"",detail:""},
            //     {type:"",title:"",detail:""},
            //     {type:"",title:"",detail:""},
            //     {type:"",title:"",detail:""},
            //     {type:"",title:"",detail:""},
            //     {type:"",title:"",detail:""},
            // ]
            product_set_details:[],
            product_set_items:[],
            //
            general_goods:{},
            general_goods_category:{},
            general_goods_category_products:{},
            //
            //...totals
            total_sales_today:0,
            //
            add_general_products:0,
        }
    },

    methods: {
        back(){
            window.history.back(); 
        },
        activate_processing(){
            this.disable_btn = true;
            this.action_loading = true;
        },

        deactivate_processing(){
            this.disable_btn = false;
            this.action_loading = false;
        },
        setMenuTabViewLink(type,view,attr1,attr2){
            this.$router.push(attr2);
        },
        setMenuTabView(type,view,attr1,attr2){
            this.menu_tab_inner_view = {};
            this.menu_tab_view = {};
            this.menu_tab_view[view] = true;
        },
        setMenuTabInnerView(view,attr1,attr2){
            this.menu_tab_inner_view = {};
            this.menu_tab_inner_view[view] = true;
            //add below //also check if shoud remove //for conflicts //or performance
            this.data_processing_message = ""; //reset
            this.data_error_message = ""; //reset
        },
        
        toggleMenu(){
            if(this.set_menu == false){
                this.set_menu = true;
            }else if(this.set_menu == true){
                this.set_menu = false;
            }
        },

        openModal(id) {
            document.getElementById(id).style.display = "block";
        },
        
        closeModal(id) {
            document.getElementById(id).style.display = "none";
        },

        numStrip(){
            if(this.product.product_item_price && (this.product.product_item_price > 0)){
                this.product.product_item_price = this.product.product_item_price.replace( /[^0-9.,]/g, '' );
            }
            //
            if(this.product.product_item_set_moq_price && (this.product.product_item_set_moq_price > 0)){
                this.product.product_item_set_moq_price = this.product.product_item_set_moq_price.replace( /[^0-9.,]/g, '' );
            }
            this.prdItemPriceKey++;    
        },

        resetComponentView(view){
            if(view == 'business'){
                this.business_details = {};
                this.setCurrentBusiness();
            }else if(view == 'product'){
                this.product_details = {};
            }
            this.setMenuTabInnerView('','','')
            this.deactivate_processing();
        },
        //businesses
        //---set/reset active business
        setCurrentBusiness(){
            var payload = {
                username:this.sellpoint.business_username,
                redir:'',
            }
            this.$store.dispatch('account/setBusiness',payload);
        },
        //../businesses
        numStrip01(){
            if(this.product.product_items[0].product_item_price && (this.product.product_items[0].product_item_price > 0)){
                this.product.product_items[0].product_item_price = this.product.product_items[0].product_item_price.replace( /[^0-9.,]/g, '' );
            }
            //
            if(this.product.product_items[0].product_item_set_moq_price && (this.product.product_items[0].product_item_set_moq_price > 0)){
                this.product.product_items[0].product_item_set_moq_price = this.product.product_items[0].product_item_set_moq_price.replace( /[^0-9.,]/g, '' );
            }
            this.prdItemPriceKey++;    
        },

        toggleSingleComponent(component){
            let toggle = document.getElementById(component).style.display;
            if(toggle == "block"){
                document.getElementById(component).style.display = "none";
            }else{
                document.getElementById(component).style.display = "block";
            }
        },

        toggleDoubleComponent(component1,component2){
            let toggle1 = document.getElementById(component1).style.display;
            let toggle2 = document.getElementById(component2).style.display;
            if(toggle1 == "block"){
                document.getElementById(component1).style.display = "none";
                document.getElementById(component2).style.display = "block";
            }else{
                document.getElementById(component1).style.display = "block";
                document.getElementById(component2).style.display = "none";
            }
           
        },

        toggleTrippleComponent(component1,component2,component3){
            let toggle1 = document.getElementById(component1).style.display;
            let toggle2 = document.getElementById(component2).style.display;
            let toggle3 = document.getElementById(component3).style.display;
            if(toggle1 == "block"){
                document.getElementById(component1).style.display = "none";
            }else{
                document.getElementById(component1).style.display = "block";
            }
            if(toggle2 == "block"){
                document.getElementById(component2).style.display = "none";
            }else{
                document.getElementById(component2).style.display = "block";
            }
            if(toggle3 == "block"){
                document.getElementById(component3).style.display = "none";
            }else{
                document.getElementById(component3).style.display = "block";
            }
        },

        setMenuComponent(view,view_type,attr1,attr2){  
            this.setPanel = true;
            
            var top = document.getElementById("topPanel").offsetTop;
            window.scrollTo(0, top); 

            this.menu_view = {};
            this.menu_view[view] = true;
            
            if(this.is_viewing == ''){this.is_viewing = view;}
            
            //set view tree
            this.setViewTree(view,view_type,attr1,attr2);

            //scaler//activator
           this.resetPageSettings(view);
        },

        resetPageSettings(view){
            if((view == 'viewBusiness') || (view == 'viewBusinessCategory') || (view == 'viewBusinessCategoryProduct')){
                this.setPageHeaders(view);
                setTimeout(function(){ 
                    if(document.getElementById(view) != null){
                        document.getElementById(view).style.color = service.app_default_color;
                    }
                }, 50);
            }
        },

        activateMenuTabView(view){
            //unactivate
            var tabs = document.getElementsByClassName('tab-menu-link');
            for (var i = 0; i < tabs.length; i++) {
                tabs[i].style = "color:inherit;";
            } 
            //../unactivate

            //activate
            let tab_menu = document.getElementById(view);
            if(tab_menu != undefined){
                tab_menu.style.color = service.app_default_color;
            }
        },

        setComponentLoading(view,attr1,attr2){
            this.component_loading = {};
            this.component_loading[view] = true;
        },

        setComponent(attr1,attr2){
            // this.resetAll();
            this.data_processing_message = ""; //refresh
            this.deactivate_processing(); //first deactivate any active processing

            if(attr1 == 'set-settings-inner'){
                this.setSettings = true;
                this.setting_details = {};
                this.setting_details[attr2] = true;
            }

            if(attr1 == 'manage-panel'){
                this.setPanel = true;
                this.managePanel = true;
                this.manage[0] = true; //default
            }

            if(attr1 == 'set-business-card-details'){
                this.manageBusinessDetails = true;
                this.setBusinessComponent(attr2);
            }

            if(attr1 == 'set-business-details'){
                this.discount_coupon = {};
                this.business_details = {};
                this.business_details[attr2] = true;
            }

            if(attr1 == 'edit-delivery-option'){
                this.delivery_option.edit_set = false;
                this.business_details = {};
                this.delivery_option = attr2;
                this.delivery_option.edit_set = true;
                //prepare city data
                if(this.delivery_option.business_delivery_is_custom == 0)
                {
                    this.getCities(this.delivery_option.business_delivery_state,'edit'); //option edit
                }
                this.business_details["delivery_option_edit"] = true;
            }

            if(attr1 == 'edit-discount-coupon'){
                this.business_details = {};
                this.discount_coupon.edit = false;
                this.discount_coupon = attr2;
                this.discount_coupon.edit = true;
            }

            if(attr1 == 'manage-businesses'){
                this.manageBusinesses = true;
                this.manageProducts = false;
                this.manageServices = false;
                this.manageLookbooks = false;
                this.manageOrders = false;
            }

            if(attr1 == 'manage-products'){
                this.manageBusinesses = false;
                this.manageProducts = true;
                this.manageServices = false;
                this.manageLookbooks = false;
                this.manageOrders = false;
            }

            if(attr1 == 'manage-services'){
                this.manageBusinesses = false;
                this.manageProducts = false;
                this.manageServices = true;
                this.manageLookbooks = false;
                this.manageOrders = false;
            }

            if(attr1 == 'manage-lookbooks'){
                this.manageBusinesses = false;
                this.manageProducts = false;
                this.manageServices = false;
                this.manageLookbooks = true;
                this.managePosts = false;
                this.manageOrders = false;
                // this.component_view.viewLookbooks = true
            }

            if(attr1 == 'manage-posts'){
                this.manageBusinesses = false;
                this.manageProducts = false;
                this.manageServices = false;
                this.manageLookbooks = false;
                this.managePosts = true;
                this.manageOrders = false;
            }

            if(attr1 == 'manage-orders'){
                this.manageBusinesses = false;
                this.manageProducts = false;
                this.manageServices = false;
                this.manageLookbooks = false;
                this.managePosts = false;
                this.manageOrders = true;
            }

            

            if(attr1 == 'reset-edit'){ 
                // this.menu_tab_view = {};
                // this.menu_tab_inner_view = {};
                this.discount_coupon = {};
                this.business_details = {};
                this.product_details = {};
                this.lookbook_details = {};
                this.setting_details ={};
                this.main_category = {}; //recheck
                this.setSettings = false;
                this.viewOrder = false;
                this.viewPendingPayOrder = false;
                this.viewPost = false;
                this.data_success_message = "";
                this.data_error_message = "";
                this.data_processing_message= "";
                this.showProductItemGroups = "";
            }

            if(attr1 == 'reset-component-details'){
                this.manageBusinessDetails = false;
            }
            
            //more ///move up after app_clean
            if(attr1 == "orders"){
                this.order = attr2;
                this.viewOrder = true;
            }

            if(attr1 == "pending_pay_orders"){
                this.order = attr2;
                this.viewPendingPayOrder = true;
            }

            if(attr1 == "posts"){
                this.post = attr2;
                this.viewPost = true;
            }
            

        },

        setInnerComponent(attr1,attr2){
            //product-items--add--imports
            if(attr1 == 'set-product-item-group'){
                this.product.product_item_group = attr2.product_item_group_id;
                this.product.product_item_group_name = attr2.product_item_group_name;
                this.productAddView02ComponentKey++;
                //styling to show selecte active group
                var grps = document.getElementsByClassName('product-item-group');
                for (var i = 0; i < grps.length; i++) {
                    grps[i].style = "border:none;";
                } 
                // document.getElementById(attr2+"PRTGR").style.border = "1px solid #0000CC";
                document.getElementById(attr2.product_item_group_id+"PRTGR").style= "border:1px solid #0000CC;min-width:65px; max-width:65px;";
            }
            if(attr1 == 'set-product-item-group-image'){
                this.product.product_item_group_image = attr2;
                var imgs = document.getElementsByClassName('product-item-group-image');
                for (var i = 0; i < imgs.length; i++) {
                    imgs[i].style = "border:none;";
                //    imgs[i].style = "padding:20px;border:1px solid #bbb;";
                } 
                document.getElementById(attr2+"PRTG").style.border = "1px solid #0000CC";
            }
            //product-items--add-imports

        },

        //reset main substitute
        resetAll(){
            this.discount_coupon = {};
            this.business_details = {};
            this.product_details = {};
            this.data_success_message = "";
            this.data_error_message = "";
            this.data_processing_message= "";
        },

        resetMessages(){
            this.data_success_message = "";
            this.data_error_message = "";
            this.data_processing_message= "";
            this.deactivate_processing(); //hack in here
        },

        resetFormData(){
            this.file_info = {};
            this.files_info = [];
        },

        setViewTree(view,view_type,attr1,attr2){
            //config -- parent node configs
            if((view_type == "sellpoints") || (view_type == "business")){ //sellpoint has a special config
                this.is_view_type = "business";
            }else{
                this.is_view_type = view_type;
            }
            //other configs for parent nodes
            // if(view_type == "buypoints"){}
            //../config -- parent node configs
            //get menu view that is true, ie current
            if(this.is_view_type == "business"){
                //business
                //ist level
                let view_array_b1 = ["viewBusiness",];
                //2nd level
                let view_array_b2 = ["manageBusiness","viewBusinessCategory","newBusinessCategory"];
                //3rd level
                let view_array_b3 = ["setBusinessProfile","setBusinessOrders","setBusinessShippingInformation","setBusinessShippingLocations","setBusinessDiscountsCoupons","setBusinessPaymentInformation","setBusinessDeleteRequest"];

                //category
                let view_array_bc1 = ["manageBusinessCategory","viewBusinessCategoryProduct","newBusinessCategoryProduct"];
                //product
                let view_array_bcp1 = ["manageBusinessCategoryProduct"];
                let view_array_bcp2 = ["setBusinessCategoryProductDetails","setBusinessCategoryProductItems","setBusinessCategoryProductDiscountCoupons","setBusinessCategoryProductDeliveryAndReturanInformation","setBusinessCategoryProductShippingInformation"];
               
                //some  inner core settings befor view is set
                if(this.is_view == "newBusinessCategoryProduct"){this.product={};this.resetAll();}//reset
                //some  inner core settings befor view is set

                if(this.is_view == "viewBusiness"){
                    this.is_viewed = 'sellpoints';
                }else if(this.is_view == "sellpoints"){
                    this.is_viewed = "Account";
                }else{
                    if(view_array_b2.indexOf(this.is_view) != -1){
                        this.is_viewed = "viewBusiness"; 
                    }else if(view_array_b3.indexOf(this.is_view) != -1){
                        this.is_viewed = "manageBusiness";
                    }else if(view_array_bc1.indexOf(this.is_view) != -1){
                        this.is_viewed = "viewBusinessCategory"; this.businessComponentKey++;
                    }else if(view_array_bcp1.indexOf(this.is_view) != -1){
                        this.is_viewed = "viewBusinessCategoryProduct";
                    }else if(view_array_bcp2.indexOf(this.is_view) != -1){
                        this.is_viewed = "manageBusinessCategoryProduct";
                    }else{
                        this.is_viewed = "viewBusiness";
                    }
                    // this.is_viewed = "Account"; //store 
                    
                }
                this.is_view = this.is_viewed; //instantiate is_view prep if back btn is pressed 
                // if(view != "sellpoints"){
                //     this.is_viewed = "viewBusiness";
                // }else{
                //     this.is_viewed = "sellpoints";
                // }
                //more is viewed settings
                
    
            }
            // console.log("BB---is_view_type::"+this.is_view_type+"---is_view::"+this.is_view+"---is_viewed::"+this.is_viewed)
            //other view types
            
        },

        setBusinessComponent(view,attr1,attr2){
            if(view == "sellpoints"){
                this.sellpoint = this.sellpoints[0];// pick first sellpointattr1;
                //call all sellpoint get data
                this.setSellpoint();
            }
            this.resetMessages();
            // console.log(this.is_view+"---"+this.is_viewed)
            this.setPanel = true;
            this.resetPageSettings(view); //page headers and menus
            if(view != "sellpoints"){
                this.sellpoint = attr1;
                //call all sellpoint get data
                this.setSellpoint();
            }else{
                this.setMenuTabView('business','viewBusiness');
            }
            // this.is_viewed = this.is_view;
            this.is_view = view;
            this.is_view_type = "business";
            this.is_viewing = this.sellpoint.business_username;  //this.sellpoint.business_name

            //new entries check
            let entry_array = ["newBusiness","newBusinessCategory","newBusinessCategoryProduct","newBusinessAgentCategoryProduct"];
            
            if(entry_array.indexOf(view) != -1){
                if(view == 'newBusiness'){this.sellpoint = {}; this.business = {}; this.sellpoint = {}; this.business_agent = 0;}
                if(view == 'newBusinessCategory'){this.main_category = {}; this.category = {};}
                if(view == 'newBusinessCategoryProduct'){this.product = {};}
                if(view == 'newBusinessAgentCategoryProduct'){this.product = {};}
            }
            //sellpoint check
            //agent special
            if(view == 'viewBusiness'){
                this.setMenuTabView('business','viewBusiness');
                // this.setPageHeaders();
                // setTimeout(function(){ document.getElementById('viewBusiness').style.color = service.app_default_color }, 500); //wait for 3sec and call posts in gallery
            }
            this.main_category = {};
            //categories check
            let category_array = ["viewBusinessCategory","editBusinessCategory","removeBusinessCategory"];
            
            if(category_array.indexOf(view) != -1){
                this.category = attr2;
                
                //agent special
                if(view == 'viewBusinessCategory'){
                    this.getBusinessCategoryProducts();
                    if(this.sellpoint.business_agent == 1){
                        this.getBusinessAgentCategoryProducts();
                        this.getBusinessesIsOpenAgentCategoryProducts();
                    }
                    this.setMenuTabView('business','viewBusinessCategory');
                    // this.setPageHeaders();
                    // setTimeout(function(){ document.getElementById('viewBusinessCategory').style.color = service.app_default_color }, 1500); //wait for 3sec and call posts in gallery
                
                }
            }


            //products check
            let product_array = ["viewBusinessCategoryProduct","editBusinessCategoryProduct","removeBusinessCategoryProduct"];
            
            if(product_array.indexOf(view) != -1){
                // this.product = attr2;
                this.getSetProduct(attr2,'');
                //this two lines below is now called in the function above
                // this.product_display_image = this.product.product_images[0];
                // this.product_item = this.product.product_items[0];

                //restore settings
                this.is_viewed = "viewBusinessCategory";
                // this.category = 
                //agent special
                if(view == 'viewBusinessCategoryProduct'){
                    this.setMenuTabView('business','viewBusinessCategoryProduct');
                    // this.setPageHeaders();
                    // setTimeout(function(){ document.getElementById('viewBusinessCategoryProduct').style.color = service.app_default_color }, 500); //wait for 3sec and call posts in gallery
                }
            }


            
            this.menu_view = {};
            this.menu_view[view] = true;
            this.setViewTree(view,"sellpoints",attr1,attr2); 
        },

     
        getSetProduct(item,ref){
            this.loading = true; 
            let product_url_name = '';
            if(ref != ''){
                product_url_name = ref
            }else{
                product_url_name = item.product_url_name;
            }
            //
            if(product_url_name != ''){
                service.getProductSearch(this, product_url_name).then(response => {
                    if(response.body.status == 200) {
                        this.loading = false;
                        this.product = response.body.data;
                        this.product_display_image = this.product.product_images[0];
                        this.product_item = this.product.product_items[0];
                        // if(this.product.product_item_groups.length != 0){
                        //     this.product_item_group = this.product.product_item_groups[0];
                        // }else{
                        //     this.product_item_group = [];
                        // }

                        //commit here
                        this.$store.dispatch('account/setProduct',this.product);

                        //prep sets
                        if((!this.product.set_product_addons) || (Object.keys(this.product.set_product_addons).length == 0)){
                            this.product.set_product_addons = [];
                        }
                        
                        //new hack to make sure category is set for back options
                        if(Object.keys(this.category).length === 0){
                            //set this product's category
                            for(let category of this.sellpoint.business_categories){
                                if(this.product.product_category_id == category.business_category_id){
                                    this.category = category;
                                    //other settings
                                    this.getBusinessCategoryProducts();  /// try filter already sellpoint products for PERf
                                }
                            }
                        }
                        
                        //filter orders
                        this.product.product_orders = [];
                        for(let ord of this.sellpoint.orders){
                            for(let ord_item of ord.order_items){
                                if(this.product.product_id == ord_item.product_id){
                                    let ord_array = {};
                                    ord_array.order_product = ord_item.product_id; 
                                    ord_array.order_date = ord.order_date; 
                                    ord_array.order_time_ago = ord.order_time_ago; 
                                    ord_array.order_user = ord.order_user;
                                    ord_array.order_item_quantity = ord_item.order_item_quantity;
                                    ord_array.order_status_id = ord.order_status_id; 
                                    ord_array.order_status = ord.order_status;
                                    ord_array.order_status_color = ord.order_status_color; 
                                    ord_array.order_payment_status_id = ord.order_payment_status_id;
                                    ord_array.order_payment_status = ord.order_payment_status;
                                    ord_array.order_payment_status_color = ord.order_payment_status_color;
                                    this.product.product_orders.push(ord_array);
                                    this.productOrdersComponentKey++;
                                }
                            }
                        }
                        
                    }
                }).catch((err) => {})
            }
        },

        getSetProductDEPAC(item){
            // get from current category
            for(let prd of this.category.category_products){
                if(prd.product_url_name == item.product_url_name){
                    this.product = prd;
                    this.product_display_image = this.product.product_images[0];
                    this.product_item = this.product.product_items[0];
                }else{
                    // this.product = item;
                }
            }
        },
       
        setComponentView(attr1,attr2,attr3){
            this.resetAll();
            if(attr1 == 'switch-to-viewing-loobook'){ //a special toggle switch case
                //switcth to lookbook view
                this.setComponent('manage-lookbooks',''); //topmost layout
                this.lookbook = this.viewing_lookbook;
                this.setComponentView('loobooks',this.viewing_lookbook_post,'viewLookbookPost');

                //reset
                this.is_viewing_lookbook = false;
                this.viewing_lookbook = {};
                this.viewing_lookbook_post = {};

            }
            if(attr1 == 'products'){
                if(this.component_view.viewProducts){
                    this.component_view.viewProducts = false;
                    this.component_view.viewProduct = true;
                    this.product = attr2;
                    //some products settings
                    this.product_set_shipping_fee_status =  this.product.product_set_shipping_fee_status;
                    // localStorage.setItem("viewing-01", this.product.product_url_name);
                }
                else if(this.component_view.viewProduct){
                    this.component_view.viewProducts = true;
                    this.component_view.viewProduct = false;
                }
                
            }
            if(attr1 == 'lookbooks'){
                if(attr3 == 'viewLookbookPost'){ //setting post in lookbook
                    this.component_view.viewLookbooks = false;
                    this.component_view.viewLookbook = false;
                    this.component_view.viewLookbookPost = true;
                    this.lookbook_post = attr2;
                    //some lookbook_post settings
                    //localStorage.setItem("viewing-02", this.lookbook_post.post_url_name);
                }
                else if(attr3 == 'viewLookbook'){ //sets lookbook in lookbooks
                    this.component_view.viewLookbooks = false;
                    this.component_view.viewLookbookPost = false;
                    this.component_view.viewLookbook = true;
                    this.lookbook = attr2;
                }
                else if(attr3 == 'viewLookbooks'){ //sets lookbooks ../default
                    this.component_view.viewLookbooks = true;
                    this.component_view.viewLookbook = false;
                    this.component_view.viewLookbookPost = false;
                }
                
            }
        },

        toggleProductItemView(component,attr2,attr3,attr4){
            //close all existing
            var grps = document.getElementsByClassName('product-item-show-more-details');
            for (var i = 0; i < grps.length; i++) {
                grps[i].style = "display:none;";
            } 
            var grps = document.getElementsByClassName('product-item-more-details-hide-btn');
            for (var i = 0; i < grps.length; i++) {
                grps[i].style = "display:none;";
            } 
            var grps = document.getElementsByClassName('product-item-more-details-view-btn');
            for (var i = 0; i < grps.length; i++) {
                grps[i].style = "display:block;";
            } 
            //
            if(component == "showMoreProductItemDetails"){
                document.getElementById(attr2).style.display = "block";
                document.getElementById(attr3).style.display = "none"; //viewbtn
                document.getElementById(attr4).style.display = "block"; //hidebtn
                
            }
            if(component == "hideMoreProductItemDetails"){
                document.getElementById(attr3).style.display = "block"; //viewbtn
                document.getElementById(attr4).style.display = "none"; //hidebtn
            }
        },

        setProductComponent(component,attr2,attr3){
            this.deactivate_processing(); //first deactivate any active processing
            this.discount_coupon = {}; //reset

            if(component == "show-settings-box"){
                this.show_product_setting_box = true;
            }
            if(component == "hide-settings-box"){
                this.show_product_setting_box = false;
            }
            
            if(attr2 == 'productitemgroup'){
                this.product_item_group = attr3;
            }
            if(attr2 == 'productitem'){
                this.product_item = attr3;
            }

            //some settings
            // if(component == "hideMoreProductItemDetails"){
            //     this.menu_tab_view["showMoreProductItemDetails"] = false;
            // }
            if(component == "addProductItemPanel"){
                if(this.product.product_set_groups == 0){
                    this.showProductItemGroups = 'showfalse'; //no items found
                }
            }
            if(component == 'setProductDeliveryInformation'){
                this.delivery_option.edit_set = false;
                this.delivery_option = attr2;
                this.delivery_option.edit_set = true;
            }
            if(component == 'editDiscount'){
                this.discount_coupon = attr3;
            }
            if(component == 'deactivateDiscount'){
                this.product_item = attr2;
                this.deactivateDiscountsAndCoupons(attr3)
            }

            this.product_details = {};
            this.product_details[component] = true;
        },

        setLookbookComponent(component,attr2,attr3){
            this.deactivate_processing(); //first deactivate any active processing

            if(component == "viewProductLookbookPost"){//navigate to product lookbook page //store parent lookbook
                this.viewing_lookbook = this.lookbook; //store parent lookbook
                this.viewing_lookbook_post = attr3; //store the product post
                this.is_viewing_lookbook =  true; //save activity

                //switch to product view
                this.setComponent('manage-products',''); //topmost layout
                this.setComponentView('products',attr3.gallery_post_product_details,''); //set the product view
            }else{
                //other settings

                this.lookbook_details = {};
                this.lookbook_details[component] = true;    
            }

            


        },

        toggleSwitchBusiness(){
            var x = document.getElementById("businessList");
            if (x.style.display === "none") {
                x.style.display = "block";
            } else {
                x.style.display = "none";
            }
        },

        switchBusiness(sellpoint){
            this.sellpoint = sellpoint;
            this.galleria = {}; //a hack for refresh
            this.setSellpoint();
            //check if toggle effect
            this.toggleSwitchBusiness();
        },

        checkIfVideo(url){
            if(url != undefined){
                let ext = url.split('.').pop();
                if(service.video_exts.includes(ext)){
                    return true;
                }else{
                    return false;
                }
            }
        },

        reset(){
            this.setPanel = false;
            this.managePanel = false;
        },

        getStates(){
            service.getStates(this).then(response => {
                if(response.body.status == 200) {
                    this.states = response.body.data;
                }
            }).catch((err) => {})
        },

        getCities(state,option){
            this.activate_processing();
            if(option == "edit"){this.edit_city = true;}
            else{this.edit_city = false}
            service.getCities(this,state).then(response => {
                if(response.body.status == 200) {
                    if((this.set_dvco_delivery_option)){
                        this.dvco_cities = response.body.data;
                    }else{
                        this.cities = response.body.data;
                    }
                    this.deactivate_processing();
                }else{
                    this.deactivate_processing();
                }
            }).catch((err) => {
                this.deactivate_processing();
            })
        },

        
        getUserAppSettings(){
            service.getUserAppSettings(this, this.user.user_id).then(data => {
                if(data.body.status == 200) {
                    this.user_settings = data.body.data;
                    this.getAgentsCoData();
                }
            }).catch((err) => {
                if(err) {
                    // toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        getAgentsCoData(){
            if(this.user_settings.uis_broker && (this.user_settings.uis_broker == 1)){
                //get broker deals and data
                service.getBrokerData(this, this.user.user_id).then(data => {
                    if(data.body.status == 200) {
                        this.broker_deals = data.body.data_deals;
                        this.broker_requests = data.body.data_requests;
                    }
                }).catch((err) => { })
            }
        },

        syncset(request_page){
            //get auth key
            var credentials = {
                session_key: localStorage.getItem("sp_token"),
                request_url: service.app_url,
                request_from: service.app_name,
                request_status: "REQUESTING...",
                request: request_page,
            } 
            if(credentials.session_key != null) {
                //save session and request on server
                service.sessionSync(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        //redirect to sp with session ref
                        let ref = response.body.data;
                        window.location.href = service.sp_url+'/manage/'+ref;
                    }
                }).catch((err) => {
                    if(err) {
                       // console.log(err)
                       // this.$router.push('/login/');
                    }
                })
            }
        },

        //profile
        prepProfile(type){
            // this.error_messages = {};
            this.disable_btn = true;
            this.user.agree = true; ///change 
            //
            var credentials = {
                user_name: this.user.name,
                user_phone: this.user.phone || '',
                user_email: this.user.email || '',
                user_username: this.user.username || '',
                user_password: this.user.password || '',
            }
            
            let navi = this.$router;
            let validated = false;
            //this.validateEmail(this.user.email);
            //this.validatePhone(this.user.phone);
            //if(this.data_validated) {
                if(validator.validateString(this.user.name)){
                    //if email or phone
                    if((credentials.user_phone != '' || credentials.user_email != '')){
                        //validate email
                        if(credentials.user_email != '' && (!validator.validateEmail(this.user.email))){
                            this.error_messages.email = 'Email is not correct';
                        }else {
                            this.error_messages.email = '';
                            validated = true;
                        }
                        //
                        //validate phone number 
                        if(credentials.user_phone != '' && (!validator.validatePhoneNumber(this.user.phone))){ 
                            this.error_messages.phone = 'Phone is not correct';
                        }else{
                            this.error_messages.phone = '';
                            validated = true;
                        }
                        //validate username
                        if(credentials.user_username != '') {
                            if(validator.validateString(this.user.username)) {
                                this.error_messages.username = '';
                                validated = true; 
                            }else{
                                this.error_messages.username = "Username is not valid"; 
                                this.disable_btn = false;
                            }
                        }
                    }else {
                        this.error_messages.email = 'Please enter either email or phone number or both';
                        this.disable_btn = false;
                    }
                    if(validated){
                        if(this.user.agree) {
                            this.setProfile(type);
                            this.disable_btn = false;
                            this.data_validated = false;
                        }else {
                            this.error_messages.terms = 'Please agree to Terms';
                            this.disable_btn = false;
                        }
                    }else{
                        this.disable_btn = false;
                    }
                }else {
                    this.data_error_message = 'Kindly fill all fields';
                    this.disable_btn = false;
                }
            //}else {
                // this.data_error_message = 'Entries not validated, please check and try again';
                // this.disable_btn = false;
            //}
            this.formComponentKey++;
        },

        setProfile(type){

            this.terms_error_message = "";
            this.disable_btn = true;
            // this.user.agree = true; ///change 
            var payload = {
                user_name: this.user.name,
                user_username:this.user.username || '',
                user_phone: this.user.phone || '',
                user_email: this.user.email || '',
                user_address: this.user.address || '',
                user_state: this.user.state || '',
                user_city: this.user.city || '',
                user_password: this.user.password,
                user_ref_code: this.ref_code,
                user_group_ref_code: this.group_ref_code,
            }

            let navi = this.$router;
            //if((validator.validateString(this.user.username)) && (validator.validateString(this.user.password))) {
                //this.loading = true; //activate loading
                service.regUser(this, payload).then(function(data) {
                    if(data.body.status == 201) {
                        // toastr.success("Account Created", 'Success!');
                        this.data_processing_message= "Account Created";
                        //log user in
                        if(data.body.data.user_email != ''){
                            var credentials = {
                                user_email: data.body.data.user_email,
                                user_password: data.body.data.user_password
                            }
                        }else if(data.body.data.user_phone != ''){
                            var credentials = {
                                user_detail: data.body.data.user_phone,
                                user_password: data.body.data.user_password
                            }
                        }else{
                            this.data_error_message = "invalid login credentials";
                            this.disable_btn = false;
                            navi.push("login"); 
                        }
                        
                        service.loginUser(this, credentials).then(response => {
                            if(response.body.status == 200) {
                                let data = response.body.data;
                                //use forage instead
                                let self = this;
                                localStorage.setItem("sp_user", data.user_name); 
                                var user_data = {
                                    "user_name": data.user_name,
                                    "user_id": data.user_id,
                                    "sp_token": data.user_session_key,
                                    "sp_token_key": data.user_token_key
                                }
                                localforage.setItem(service.udb_name, user_data).then(function (value) {
                                    self.set_user_loggedIn = true;
                                    self.user.user_id = data.user_id;
                                    if(type == 2){
                                        //set business profile too
                                        self.business.business_name = data.user_name,
                                        self.setProfileAccount(2);
                                    }
                                }).catch(function(err) {});
                            }
                        }).catch((err) => {
                            if(err.status == 404) {
                                // toastr.warning("invalid login credentials", 'Warning!'); 
                                this.data_error_message = "invalid login credentials";
                                this.disable_btn = false;
                            }
                        })

                    }else if(data.body.status == 409) {
                        // toastr.warning("You already have a Sellpoint Account", 'Warning!');
                        this.data_error_message = "You already have a Sellpoint Account, please log in with this email or username";
                        // navi.push("login?u=connect");
                        setTimeout(function(){ navi.push("/login?u=connect"); }, 10000); 
                        this.disable_btn = false;
                    }
                }).catch((err) => {
                    if(err) {
                        this.data_error_message = "Something went wrong";
                        this.disable_btn = false;
                    }
                    this.disable_btn = false;
                })
            // }else {
            //     // toastr.error('Kindly fill all fields', 'Warning!');
            //     this.data_error_message = 'Kindly fill all fields';
            //     this.disable_btn = false;
            //     this.form2ComponentKey++;
            // }
        },

        editProfileDetails(){
            this.activate_processing();
            var payload = {
                user_name: this.user.user_name,
                user_phone: this.user.user_phone,
                user_email: this.user.user_email
            }

            //test data
            let data_test = false;
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            let email_test = re.test(String(this.user.user_email).toLowerCase());
            var re_phone = /^\d{4}\d{3}\d{4}$/;
            let phone_test = re_phone.test(String(this.user.user_phone).toLowerCase());
            if((email_test == false) || (this.user.user_name == " ") || (phone_test == false)){
                data_test = false;
                this.data_processing_message = "Some errors were found in your form, please fill correctly";
                this.deactivate_processing();
            }else{
                data_test = true;
                this.data_processing_message = "";
            }
            if(data_test){
                if(payload.user_name != null && payload.user_phone != null) {
                    service.editProfileDetails(this, payload).then(function(data) {
                        if(data.body.status == 200) {
                            this.data_processing_message = "Profile Updated";
                            this.user = data.body.data;
                            this.deactivate_processing();
                            this.setSettings = false;
                            this.setting_details={};
                        }else{
                            this.data_processing_message = "Could not edit details, something went wrong, please try again";
                            this.deactivate_processing();
                            this.setSettings = false;
                            this.setting_details={};
                        }
                        
                    }).catch((err) => {
                        //log it
                        this.data_processing_message = "Could not edit details, something went wrong, please try again";
                        this.deactivate_processing();
                        this.setSettings = false;
                        this.setting_details={};
                    })
                }
            }
        },

        setProfileAccount(type){
            if(type == 2){
                //business account
                var payload = {
                    business_name: this.business.business_name,
                    business_user_name: this.business.business_user_name || '',
                    business_category: this.business.business_category || service.app_default_business_category,
                    business_owner: this.user.user_id,
                    business_group: service.market_app_name,
                    // business_market_group: this.business.business_market_group, //market group in this market
                    // business_layout: 1, //shop
                    // business_agent: this.business_agent, //shop
                    // business_subscription: service.market_app_default_plan, //eshop-defalut / basic //no payment to register in this market 
                    // business_join_group: this.active_group.group_id || 0,  
                }
                let navi = this.$router;
                if(payload.business_name != '' && payload.business_category > 0) {
                    service.addNewBusiness(this, payload).then(function(data) {
                        if(data.body.status == 201) {
                            //save business ldb
                            this.sellpoint = data.body.data;
                            if((Object.keys(this.sellpoint).length > 0)){
                                localforage.setItem(service.bdb_name, this.sellpoint).then(function (value) {
                                }).catch(function(err) {});
                            }
                            //--set bank details
                            if((Object.keys(this.sellpoint).length > 0) && (Object.keys(this.business_bank_details).length > 0)){
                                console.log(this.sellpoint.business_bank_details);
                                this.sellpoint.business_bank_details = this.business_bank_details; //ini
                                //
                                this.setBankDetails();
                            }
                            //--add delivery locations
                            if((Object.keys(this.sellpoint).length > 0) && (Object.keys(this.delivery_option).length > 0)){
                                // this.addDeliveryOption();
                                //this.setAddDeliveryLocations();
                                for(let option of this.business_delivery_locations){
                                    this.delivery_option = option;
                                    this.addDeliveryOption();
                                }
                            }
                            //
                            this.data_boarding_message = "Account created"
                            setTimeout(function(){ navi.push("/create/order"); }, 10000); 
                        }
                    }).catch((err) => {})
                }
            }
        },
        //./profile

        //sellpoint

        setNewBusiness(){
            //some settts
            this.sellpoint = {}; this.business = {}; this.sellpoint = {}; this.business_agent = 0;
            this.setMenuComponent('newBusiness');
        },

        getSellpoints(user){
            // this.loading = true; //disable for now
            //this.loading = false;
            service.getAppBusinesses(this, user).then(data => {
                if(data.body.status == 200) {
                    this.sellpoints = data.body.data;
                    if(this.sellpoints.length > 0){
                        if(this.current_sellpoint_id != 0){
                            for(let sellpoint of this.sellpoints){
                                if(sellpoint.business_id == this.current_sellpoint_id){
                                    this.sellpoint = sellpoint;
                                }
                            }
                        }else{
                            this.sellpoint = this.sellpoints[0];
                        }
                        this.business_set_shipping_fee_status = this.sellpoint.business_set_shipping_fee_status;
                        //set sellpoint
                        this.setSellpoint();
                    }else{
                        this.has_sellpoints = false;
                        this.loading = false; //disable for now
                    }
                    this.loading = false;
                }else{
                    this.loading = false; //disable for now
                }
            }).catch((err) => {
                if(err) {
                   //log it
                  // console.log(err)
                  this.loading = false; //disable for now
                }
            })
        },

        setSellpoint(){
            if(this.sellpoint && (Object.keys(this.sellpoint).length > 0)){
                //ss--save
                localforage.setItem(service.bdb_name, this.sellpoint).then(function (value) {}).catch(function(err) { });
                //check if sellpoint is saved on forage
                // if(!this.getDBase(service.set_sellpoint_db)){
                //     //set a new sellpoint
                //     this.sellpoint = this.sellpoints[0];
                //     this.setDBase(service.set_sellpoint_db,this.sellpoint,'sellpoint_view')
                // }else{

                //use current sellpoint
                //some settings
                if(this.sellpoint.business_category_type == 1){
                    this.is_product_service = "product";
                }
                if(this.sellpoint.business_category_type == 2){
                    this.is_product_service = "service";
                }
                
                //get app business subscription
                this.getAppBusinessSubscription();
                //set sellpoint categories
                this.getSellpointCategories();
                //get Products
                //this.getSellpointProductsDEPRAC(); //hack here for  now for /// get requests like get posts
                this.getSellpointProducts(); 
                //delivery
                this.getBusinessDeliveryOptions();
                //discounts
                this.getBusinessDiscountsAndCoupons();
                //get full sellpoint 
                this.getSellpointDetails();
                
                //route calls
                if(this.$route.path == '/manage/orders'){
                    this.setPage();
                }
                
                //---CALLS NOT NEEDED ATM, WOULD BE CALLED FROM SEPERATE XTENDING SRCs
                /*
                //get Orders
                this.getAppBusinessOrders();
                //get prnding order payments
                this.getAppBusinessOrdersPendingPayments();
                //get transactions
                this.getAppBusinessTransactions();
                //get Customers
                this.getAppBusinessCustomers();
                //get Market Circle
                this.getAppMarketCircle();
                //
                this.getAppSubscribers();
                //
                // this.getAppSubscriptions();
                //
                this.getBusinessRewardSettings();
                //continue
                //new-get new categories
                this.getMainCategories(this.sellpoint.business_category_id);
                //get integrated services
                this.getIntegratedServices();
                //get posts
                this.getAppBusinessPosts();
                //../---CALLS 
                */
                
                //
                this.loading = false; //disable for now
           // }
            }else{
                this.loading = false; //disable for now
            }
        },

        getSellpointDetails(){
            service.getBusinessByUserName(this, this.sellpoint.business_username).then(response => {
                if(response.body.status == 200) {
                    this.sellpoint = response.body.data; 

                    //setts
                    //----------business-details
                    if((Object.keys(this.sellpoint).length > 0)){
                        localforage.setItem(service.bdb_name, this.sellpoint).then(function (value) {
                        }).catch(function(err) {});
                    }
                    //----------./business-details

                    //----------delivery-locations
                    this.business_delivery_locations = this.sellpoint.business_delivery_options;
                    if((Object.keys(this.business_delivery_locations).length > 0)){
                        localforage.setItem(service.bbdlsdb_name, this.business_delivery_locations).then(function (value) {
                        }).catch(function(err) {});
                    }
                    //----------./delivery-locations

                    //----------bank-details
                    this.business_bank_details = this.sellpoint.business_bank_details;
                    if((Object.keys(this.business_bank_details).length > 0)){
                        localforage.setItem(service.bbnksdb_name, this.sellpoint.business_bank_details).then(function (value) {
                        }).catch(function(err) {});
                    }
                    //----------./bank-details
                    //../setts
                    
                    //commit here
                    this.$store.dispatch('account/setBusiness',this.sellpoint);
                    //some call settings
                    if((this.$route.name == "BusinessRewards")){ //call page src
                        this.getBusinessRewardSettings();
                    }
                } 
            }).catch((err) => {})
        },

        setDBase(dbase,data,component_view){
            let self = this;
            if(Object.keys(dbase).length > 0){
                localforage.setItem(dbase.db_name, data).then(function (value) {
                    self.store_data_set = true;
                    if(component_view != ''){
                        self.setComponentView(component_view);
                    }
                }).catch(function(err) {});
            }
        },

        
        getDBase(dbase) {
            let self = this;
            localforage.getItem(dbase.db_name, function(err, value) { //quick with the callback version
                if(value != undefined) {
                    if(dbase.tag == "sellpoint"){
                        self.sellpoint = value;
                        self.setSellpoint();
                    }
                    //
                    return true;
                }else{
                    return false;
                }
            });
        },

        prepSetData(data,tag){
            if(tag == "sellpoint"){
                this.setDBase(service.set_sellpoint_db,data,tag);
            }
            //
            return true;
        },

        prepGetData(tag){
            if(tag == "sellpoint"){
                this.getDBase(service.set_sellpoint_db);
            }
            //
            return true;
        },

        setGallery(){
            service.getPointGalleryPosts(this, this.sellpoint.business_id,0,this.max_plan_lookbooks,0,this.max_plan_lookbook_posts).then(response => {
                this.galleria = response.body.data;
                //settings
                this.total_lookbooks_added = response.body.total_data;

                if(this.total_lookbooks_added < this.max_plan_lookbooks){
                    this.can_add_more_lookbook = true;
                }
                this.deactivate_processing();
            }).catch((err) => {})
        },

        getSellpointProducts(){
            this.data_loading.products = true; //use and set as true for now
            this.sellpoint.business_market_products_limit = 100; //1000; //hack in here
            service.getAppBusinessProducts(this, this.sellpoint.business_id, this.sellpoint.business_market_products_limit).then(response => {
                if(response.body.status == 200) {
                    this.products = response.body.data;
                    //commit here
                    this.$store.dispatch('account/setBusinessProducts',this.products);
                    // this.loading = false;
                }
                this.loading = false;
                this.data_loading.products = false; //if called
                //this.action_loading = false; //if called
            }).catch((err) => {})
        },
    
        getAppDeliveryPartners() {
            service.getAppDeliveryPartners(this).then(function(data) {
                this.delivery_partners = data.body.data;
            })
        },
        
        addDeliveryPartner(dp){
            this.activate_processing();
            //some checks
            var payload = {
                partner: dp.business_delivery_partner || 0,
                business: this.sellpoint.business_id,
            }
          
            let navi = this.$router;
            if((payload.partner != undefined) || (payload.partner == 0)) {
                service.addDeliveryPartner(this, payload).then(function(data) {
                    if(data.body.status == 201) {
                        this.data_processing_message = "added";
                        this.sellpoint.business_delivery_options = data.body.data;
                        this.setMenuTabInnerView('');
                        this.deactivate_processing();
                    }
                }).catch((err) => {
                    this.data_processing_message =  "Something went wrong";
                    this.deactivate_processing();
                })
            }else {
                this.data_processing_message = 'Kindly fill all fields';
                this.deactivate_processing();
            }
        },
        ////../default settings

        //agentsco
        acceptBrokerRequest(request){
            this.activate_processing();
            this.data_processing_message = "";
            //send request to broker
            var payload = {
                request_ref: request.broker_request_ref_no, //broker agent
            }
            service.acceptBrokerRequests(this,payload).then(response => {
                if(response.body.status == 201) {
                    //open up chat component
                }else{this.deactivate_processing();}
            }).catch((err) => {
                this.deactivate_processing();
                //console.log(err) //possibly a load payment error
            })
        },

        setBrokerRequestFee(){
            this.activate_processing();
            this.data_processing_message = "";
            //send request to broker
            var payload = {
                request_ref: this.broker_request.broker_request_ref_no, //broker agent
                request_fee: this.broker_request.broker_request_fee, //broker agent fee to pay
            }
            service.setBrokerRequestFee(this,payload).then(response => {
                if(response.body.status == 200) {
                    //refresh broker request params
                    this.broker_request.broker_request_fee_pay_status = 1;
                    this.data_processing_message = "Fee Set;";
                }else{
                    this.data_processing_message = "Sorry, could not update;";
                }
                this.deactivate_processing(); 
            }).catch((err) => {
                this.data_processing_message = "Sorry, could not update;";
                this.deactivate_processing();
                //console.log(err) //possibly a load payment error
            })
        },

        /*----------------------Adminboarding------------------------------------------*/
        //market settings
        getBusinessMarketGroups() {
            service.getBusinessMarketGroups(this).then(function(data) {
                this.market_groups = data.body.data;
            })
        },

        //business--settings
        getBusinessDeliveryOptions(){
            service.getBusinessDeliveryOptions(this, this.sellpoint.business_username).then(response => {
               if(response.body.status == 200) {
                    this.sellpoint.business_delivery_options = response.body.data;
                    this.sellpoint.business_delivery_options_nodes = response.body.data_business_delivery_options_nodes;
                    this.business_delivery_options_nodes = this.sellpoint.business_delivery_options_nodes;
                    //commit
                    this.$store.dispatch('account/setBusinessShipping',this.sellpoint.business_delivery_options_nodes);
                }
                this.loading = false;
            }).catch((err) => {this.loading = false;})
        },

        getCategories() {
            service.getCategories(this).then(function(data) {
                let categories = data.body.data;
                //seperate products and services categories
                categories.forEach(function(element) {
                    if(element.category_type == 1){
                        this.business_product_categories.push(element);
                    }
                    if(element.category_type == 2){
                        this.business_service_categories.push(element);
                    }
                }, this);
            })
        },

        getMainCategories(category){
            service.getMainCategories(this, category).then(response => {
               if(response.body.status == 200) {
                    this.categories = response.body.data;
                }
            }).catch((err) => {})
        },

        getSubCategories(category){
            if(category != undefined){
                this.sub_categories = category.sub_categories;
            }else{
                this.sub_categories = [];
            }
            
        },

        //categories settings
        getSellpointCategories(){
            service.getBusinessCategories(this, this.sellpoint.business_id).then(response => {
                if(response.body.status == 200) {
                    this.sellpoint_categories = response.body.data;
                    //also set for
                    this.sellpoint.business_categories =  response.body.data;
                    //commit here
                    this.$store.dispatch('account/setSellpointCategories',this.sellpoint.business_categories);
                }
            }).catch((err) => {})
        },

        getBusinessCategoryProducts(category_view){
            if(category_view != ''){
                this.setComponentLoading(category_view);
            }else{  
                this.loading = true;
            }
            service.getCategoryProducts(this, this.category.business_category_id).then(response => {
                if(response.body.status == 200) {
                    this.category.category_products = response.body.data;
                    this.attachProductsComponentKey++;
                    //commit here
                    this.$store.dispatch('account/setBusinessCategoryProducts',this.category.category_products);
                    //
                    this.loading = false;
                    this.setComponentLoading('');
                }
                this.businessComponentKey++;
                this.loading = false;
            }).catch((err) => {this.loading = false})
        },
        
        //RCPFX performance_recheck
        
        getBusinessesIsOpenAgentCategoryProducts(){
            var payload = {
                'business_category': this.category.business_category,
                'business_parent_category': this.category.business_parent_category_id,
                'business_category_type': this.category.business_category_type,
            }
            service.getBusinessesOpenAgentsCategoryProducts(this, payload).then(response => {
                if(response.body.status == 200) {
                  this.category.category_business_open_for_agent_products = response.body.data;
                  this.businessComponentKey++;
                }
            }).catch((err) => {})
        },

        getBusinessAgentCategoryProducts(){
            service.getAgentsBusinessCategoryProducts(this, this.category.business_category_id).then(response => {
                if(response.body.status == 200) {
                  this.category.category_products = response.body.data;
                  this.businessComponentKey++;
                }
            }).catch((err) => {})
        },

        getBusinessesOpenAgentsProducts(){
            service.getBusinessesOpenAgentsProducts(this).then(response => {
                if(response.body.status == 200) {
                  this.business_open_agents_products = response.body.data;
                }
            }).catch((err) => {})
        },

        resetCategoriesSelections(){
            if(this.category.new_listed_category != ''){
                this.main_category = {};
                this.category.new_category = 0;
            }
        },

        addCategory(){
            this.activate_processing();
            var payload = {
                category_new: this.category.new_category || 0,
                category_new_listed: this.category.new_listed_category || "nill",
                category_parent: this.main_category.category_id || 0,
                business_id: this.sellpoint.business_id
            }
            // if((payload.category_new == 0) && (payload.category_new_listed == "nill")){
            if((payload.category_parent == 0) && (payload.category_new == 0) && (payload.category_new_listed == "nill")){
                this.data_error_message = "You did not pick any category, Select or any enter the category name";
                this.deactivate_processing();
            }else{
                service.addCategory(this, payload).then(function(data) {
                    if(data.body.status == 201) {
                        this.data_processing_message = "Sellpoint Category Added Successfully";
                        this.sellpoint.business_categories = data.body.data;
                        //
                        this.$store.dispatch('account/setSellpointCategories',this.sellpoint.business_categories);
                        this.category = {};
                    }else{
                        this.data_error_message = "Sorry could not process request, try again";
                    }
                    //call get categories
                    let self = this;
                    setTimeout(function(){
                        self.$router.push("/account/business/categories");
                        self.deactivate_processing();
                    },1200)
                    //
                    //this.deactivate_processing();
                    //this.$router.push("/account/business/categories");
                    //this.setBusinessComponent("viewBusiness",this.sellpoint,''); //back
                    //this.setMenuTabView('business','viewBusiness',this.sellpoint,'');
                    //this.menu_view = {};//this.setMenuComponent('',this.sellpoint,'');

                    //re-get
                    this.getSellpointCategories();
                }).catch((err) => {
                    //log it
                    this.data_error_message = "Sorry could not process request, try again";
                    this.deactivate_processing();
                })
            }
            
        },

        editCategory(){
            this.activate_processing();
            this.category.business_id = this.sellpoint.business_id;
            service.editCategory(this, this.category).then(function(data) {
                if(data.body.status == 200) {
                    // toastr.success("Sellpoint Category edited", 'Success!');
                    this.data_processing_message = "Sellpoint Category edited";
                    this.sellpoint.business_categories = data.body.data;
                    //commit here
                    this.$store.dispatch('account/setSellpointCategories',this.sellpoint.business_categories);
                    //
                    this.setComponent('reset-edit','');
                    this.deactivate_processing();
                    // this.category = {};
                }
            }).catch((err) => {
                this.data_processing_message = "Sellpoint Category could not be edited";
                this.setComponent('reset-edit','');
            })
        },

        deleteCategory(){
            this.setComponent('reset-edit','');
            // this.category.business_id = this.sellpoint.business_id;
            // service.editCategory(this, this.category).then(function(data) {
            //     if(data.body.status == 200) {
            //         // toastr.success("Sellpoint Category edited", 'Success!');
            //         this.data_processing_message = "Sellpoint Category edited";
            //         this.sellpoint.business_categories = data.body.data;
            //         this.setComponent('reset-edit','');
            //         // this.category = {};
            //     }
            // }).catch((err) => {
            //     this.data_processing_message = "Sellpoint Category could not be edited";
            //     this.setComponent('reset-edit','');
            // })
        },

        //validate user name
        validateUserName(){
            service.validateBusinessUserName(this, this.business).then(response => {
                if(response.body.status != 200) {
                    this.validate_user_name_error = true;
                    this.validate_user_name_message = "This username already exist";
                    this.deactivate_processing();
                }else{this.validate_user_name_error = false;}
            }).catch((err) => {
                //log it
                this.validate_user_name_error = true;
                this.validate_user_name_message = "This username already exist";
                this.deactivate_processing();
            })
        },

        ///if payment for market plans exist for this marktet
        //.purchase plan
        //.marke purchase order
        //.set up business
        //.notify payment
        //.reroute //or stay in account
        //////./

        //add new business // //market business registration with basic free payment
        setUpNewBusiness(){
            this.resetAll();
            
            // this.disable_btn = true;
            this.activate_processing();
            var credentials = {
                business_name: this.business.business_name,
                business_user_name: this.business.business_user_name,
                business_category: this.business.business_category || 1,
                business_owner: this.user.user_id,
                business_group: service.market_app_name,
                business_market_group: this.business.business_market_group, //market group in this market
                business_layout: 1, //shop
                business_agent: this.business_agent, //shop
                business_subscription: service.market_app_default_plan, //eshop-defalut / basic //no payment to register in this market 
                business_join_group: this.active_group.group_id || 0,  
            }
            let navi = this.$router;
            if(this.validate_user_name_error){
                this.data_error_message = "This Username already exists..";
                this.deactivate_processing();
            }else{
                if(credentials.business_name != undefined && credentials.business_category != undefined) {
                    service.addNewBusiness(this, credentials).then(function(data) {
                        if(data.body.status == 201) {
                            // toastr.success("Sellpoint Creation Successfull", 'Success!');
                            this.business.business_user_name = data.body.data_business_username; //overide from server
                            this.data_processing_message = "Sellpoint Creation Successful.";

                            //notify server of Order-Delivered
                            // this.notifyPayments(16,this.payment_ref,this.business.business_user_name); //16--Subscription-Delivered
                            
                            this.sellpoint = data.body.data;
                            //navigate to business view
                            //this.$store.dispatch('account/userAccountBusiness',this.sellpoint);
                            this.storeSetBusiness(this.sellpoint.business_username,1);
                            // navi.push("/account/business");
                            setTimeout(function(){ navi.push("/account/business"); }, 2000); //wait for 2sec 
                            /*new-ups
                            this.setBusinessComponent('viewBusiness',this.sellpoint,'');
                            this.reloadToView();//core_reload
                            this.deactivate_processing();
                            this.resetAll();
                            */
                            
                            //
                            //location.reload(); //use for now till sort business component
                            
                            //

                        }else{
                            this.data_error_message = "This Username already exists";
                            this.deactivate_processing();
                        }
                    }).catch((err) => {
                        if(err) {console.log(err)
                            this.data_error_message = "Something went wrong";
                            this.deactivate_processing();
                        }
                    })
                }else {
                    this.data_error_message = "Kindly fill all fields";
                    this.deactivate_processing();
                }
            }
        },

        //editbusiness
        editBusinessDetails(attr){
            this.activate_processing();
            if(attr == "delivery"){
                var payload = {
                    business_id: this.sellpoint.business_id,
                    business_delivery_information: this.sellpoint.business_delivery_information
                }
            }else{
                var payload = {
                    business_main_details:true,
                    business_id: this.sellpoint.business_id,
                    business_name: this.sellpoint.business_name,
                    business_tagline: this.sellpoint.business_tagline || '',
                    business_profile: this.sellpoint.business_profile || '',
                    business_emails: this.sellpoint.business_emails || '',
                    business_address: this.sellpoint.business_address || '',
                    business_phones: this.sellpoint.business_phones || '',
                }
            }
            service.editBusinessDetails(this, payload).then(function(data) {
                if((data.body.status == 200) || (data.body.status == 400)) {
                    this.getSellpointDetails(this.sellpoint.business_username);
                    this.data_processing_message = "Updated";
                    this.toggleSingleComponent('editBusinessDetails');
                }else{
                    this.data_processing_message = "Could not edit details, something went wrong, please try again";
                    this.deactivate_processing();
                }
                
            }).catch((err) => {
                //log it
                this.data_processing_message = "Could not update details, something went wrong, please try again";
                this.deactivate_processing();
            })
        },

        //delivery
        setOtherOptions(v,o){
            if(v != undefined){
                if(v == "other"){
                    this.other_delivery_option = true;
                    if(o == "edit"){this.edit_other_delivery_option = true;}//for edit
                }
                if(v == "all"){
                    this.delivery_option.business_delivery_other_option = "nill";
                    if(o == "edit"){this.edit_other_delivery_option = false;}//for edit
                    this.other_delivery_option = false;
                }
            }
            if(this.business_details.delivery_add_by_dco){
                this.deliveryAddByDcoKey++;
            }
        },

        //set a delivery option to accept new delivery-from-points
        setDeliveryOptionParams(option,attr){
            this.delivery_option = option;
            if(attr == 'add-new-from'){
                this.delivery_option.addNewDeliveryFromPoint = true;
            }
        },

        setFreeDelivery(n){
            if(n == 1){
                if(this.delivery_option.delivery_option_free){
                    this.delivery_option.delivery_option_free = 1; 
                    this.delivery_option.delivery_option_price = 0;
                }else{
                    this.delivery_option.delivery_option_free = 0; 
                }
            }else if(n == 2){
                //business_delivery_option_free
                if(this.delivery_option.business_delivery_option_free){
                    this.delivery_option.delivery_option_free = 1; 
                    this.delivery_option.business_delivery_option_price = 0;
                }else{
                    this.delivery_option.business_delivery_option_free = 0; 
                }
            }
            this.componentDeliveryKey++;
        },
        addDeliveryOption(){
            this.activate_processing();
            //some new settings for logistics businesses
            let business_delivery_option_from_points = [];
            if(this.business_details.delivery_add_by_dco){
                //check if the cities location_froms are loaded
                if(this.dvco_cities.length > 0){
                    for(let dvc of this.dvco_cities){
                        //if they are get those with set price
                        if(dvc.delivery_option_price > 0){
                            //prep array
                            var prepload = {
                                business_delivery_option_from_state: dvc.city_state,
                                business_delivery_option_from_location: dvc.city_id || 0,
                                business_delivery_option_from_other_delivery_location:  "nill",
                                business_delivery_option_from_is_custom: 0,
                                business_delivery_option_from_custom_option: "nill",
                                business_delivery_option_from_price: dvc.delivery_option_price || 0,
                            }
                            //push into bdo_from_points array
                            business_delivery_option_from_points.push(prepload);
                        }
                    }
                }
                //check if the other options array
                if(this.delivery_custom_options.length > 0){
                    for(let dvc of this.delivery_custom_options){
                        let is_custom_option = 0;
                        if(dvc.delivery_custom_option != ''){is_custom_option = 1;}
                        //if they are get those with set price
                        if(dvc.delivery_option_price > 0){
                            //prep array
                            var prepload = {
                                business_delivery_option_from_state: 0,
                                business_delivery_option_from_location: 0,
                                business_delivery_option_from_other_delivery_location: dvc.other_delivery_location || "nill",
                                business_delivery_option_from_is_custom: is_custom_option,
                                business_delivery_option_from_custom_option: dvc.delivery_custom_option || "nill",
                                business_delivery_option_from_price: dvc.delivery_option_price || 0,
                            }
                            //push into bdo_from_points array
                            business_delivery_option_from_points.push(prepload);
                        }
                    }
                }
                //setts -- //assign 1st price in the array as options main default price //if not set
                if((this.delivery_option.delivery_option_price == 0) || this.delivery_option.delivery_option_price == undefined){
                    this.delivery_option.delivery_option_price = business_delivery_option_from_points[0]["business_delivery_option_from_price"];
                }
            }
            //settings for adding from locations to an existing delivery option
            if(this.delivery_option.addNewDeliveryFromPoint){
                this.delivery_option.state = this.delivery_option.business_delivery_state_id;
                this.delivery_option.city = this.delivery_option.business_delivery_city;
                this.delivery_option.option = this.delivery_option.business_delivery_option_id;
            }
            //setts
            if((this.delivery_option.city) && (this.delivery_option.city != undefined)){
                if(!(this.delivery_option.city > 0)){
                    this.delivery_option.city = this.delivery_option.city.city_id;
                }
            }
            var payload = {
                business_delivery_state: this.delivery_option.state,
                business_delivery_city: this.delivery_option.city || 0,
                business_delivery_other_option: this.delivery_option.delivery_other_option || "nill",
                business_delivery_custom_option: this.delivery_option.delivery_custom_option || "nill",
                business_delivery_option_price: this.delivery_option.delivery_option_price || 0,
                business_delivery_option_free: this.delivery_option.delivery_option_free || 0,
                business_delivery_option_from_points: business_delivery_option_from_points || [],
                business_delivery_option_set_option: this.delivery_option.option || 0,
                business_id: this.sellpoint.business_id
            }
            if((payload.business_delivery_option_price == 0) && (payload.business_delivery_option_free == 0)){
                this.data_processing_message = "Delivery Charge not Added";
                this.deactivate_processing();
            }else{
                if((payload.business_delivery_option != 0) || (payload.business_delivery_other_option != "nill")){
                    service.addDeliveryOption(this, payload).then(function(data) {
                        if((data.body.status == 201) || (data.body.status == 200)) {
                            // toastr.success("Sellpoint Delivery Details Added Successfully", 'Success!');
                            //--updated
                            this.sellpoint.business_delivery_options = data.body.data;
                            //neue
                            this.sellpoint.business_delivery_locations = data.body.data;
                            this.business_delivery_locations = data.body.data;
                            //
                            if((Object.keys(this.sellpoint.business_delivery_options).length > 0)){
                                localforage.setItem(service.bbdlsdb_name, this.sellpoint.business_delivery_options).then(function (value) {
                                }).catch(function(err) {});
                            }
                            //--updated
                            //
                            this.sellpoint.business_delivery_options_nodes = data.body.data_delivery_options_nodes;
                            this.business_delivery_options_nodes = this.sellpoint.business_delivery_options_nodes;
                            this.custom_delivery_option = false;
                            this.delivery_option = {};
                            this.dvco_cities = {};
                            this.delivery_custom_options = {}
                            this.business_details = {};
                            this.deactivate_processing();
                            //if set
                            this.setAddDeliveryLocation = false;
                        }
                    }).catch((err) => {
                        //log it
                        this.delivery_option = {};
                        this.dvco_cities = {};
                        this.delivery_custom_options = {}
                        this.deactivate_processing();
                    })
                }else{
                    this.data_processing_message = "Select a delivery option";
                    this.deactivate_processing();
                }
            }
            
        },

        editDeliveryOption(){
            this.activate_processing();
            var payload = {
                business_id: this.sellpoint.business_id,
                // business_delivery_state: this.delivery_option.business_delivery_state || this.delivery_option.business_delivery_state_id,
                business_delivery_state: this.delivery_option.business_delivery_state_id,
                business_delivery_city: this.delivery_option.city || 0,
                business_delivery_other_option: this.delivery_option.business_delivery_other_option || "nill",
                business_delivery_custom_option: this.delivery_option.business_delivery_custom_option || "nill",
                business_delivery_option_price: this.delivery_option.business_delivery_option_price || 0,
                business_delivery_option_free: this.delivery_option.delivery_option_free || 0,
                business_delivery_option_id: this.delivery_option.business_delivery_option_id
            }
            //this.delivery_option.business_id = this.sellpoint.business_id;
            if((payload.business_delivery_option_price == 0) && (payload.business_delivery_option_free == 0)){
                this.data_processing_message = "Delivery Charge not Added";
                this.deactivate_processing();
            }else{
                if((payload.business_delivery_option != 0) || (payload.business_delivery_other_option != "nill")){
                    service.editDeliveryOption(this, payload).then(function(data) {
                    if(data.body.status == 200) {
                        // toastr.success("Sellpoint Delivery Details edited",'Success!');
                        this.sellpoint.business_delivery_options = data.body.data;
                        this.delivery_option.edit_set = false;
                        this.business_details = {};
                        //--updated
                        this.sellpoint.business_delivery_locations = data.body.data;
                        this.business_delivery_locations = data.body.data;
                        //
                        if((Object.keys(this.sellpoint.business_delivery_options).length > 0)){
                            localforage.setItem(service.bbdlsdb_name, this.sellpoint.business_delivery_options).then(function (value) {
                            }).catch(function(err) {});
                        }
                        //--updated
                        // this.editDeliveryInformation = false;
                        //this.delivery_option = {};
                        this.deactivate_processing();
                        this.toggleSingleComponent(this.set_single_component_view);
                    }
                    }).catch((err) => {
                        //log it
                        //this.delivery_option = {};
                        this.delivery_option.edit_set = false;
                        this.deactivate_processing();
                    })
                }else{
                   this.data_processing_message="Select a delivery option";
                   this.deactivate_processing();
                }
            }
        },
    
        deleteDeliveryOption(id){
            this.activate_processing();
            var payload = {
                business_id: this.sellpoint.business_id
            }
            service.deleteDeliveryOption(this, id, payload).then(function(data) {
                if(data.body.status == 200) {
                    // toastr.success("Sellpoint Delivery Details deleted",'Success!');
                    this.sellpoint.business_delivery_options = data.body.data;
                    this.delivery_option.edit_set = false;
                    this.delivery_option = {};
                    this.business_details = {};
                    //
                    //--updated
                    this.sellpoint.business_delivery_locations = data.body.data;
                    this.business_delivery_locations = data.body.data;
                    //
                    if((Object.keys(this.sellpoint.business_delivery_options).length > 0)){
                        localforage.setItem(service.bbdlsdb_name, this.sellpoint.business_delivery_options).then(function (value) {
                        }).catch(function(err) {});
                    }
                    //--updated
                    this.deactivate_processing();
                    this.toggleSingleComponent(this.set_single_component_view)
                }
            }).catch((err) => {
                //log it
                this.delivery_option = {};
                this.deactivate_processing();
            })
        },
        
        updateDeliveryFromOption(action,option){
            this.activate_processing();
            if(action == "edit-delivery-from"){
                var payload = {
                    business_id: this.sellpoint.business_id,
                    business_delivery_set_from_options: 1,
                    business_delivery_from_price: option.business_delivery_from_price || 0,
                    business_delivery_from_id: option.business_delivery_from_id
                }
                //this.delivery_option.business_id = this.sellpoint.business_id;
                if(payload.business_delivery_from_price == 0){
                    this.data_processing_message = "Delivery Charge not set";
                    this.deactivate_processing();
                }else{
                    if((payload.business_delivery_from_id != 0)){
                        service.editDeliveryOption(this, payload).then(function(data) {
                        if(data.body.status == 200) {
                            this.sellpoint.business_delivery_options = data.body.data;
                            this.delivery_option.edit_set = false;
                            this.business_details = {};
                            this.deactivate_processing();
                        }
                        }).catch((err) => {
                            //log it
                            this.delivery_option.edit_set = false;
                            this.deactivate_processing();
                        })
                    }else{
                       this.data_processing_message="Select a delivery option";
                       this.deactivate_processing();
                    }
                }
            }
            //delete
            if(action == "delete-delivery-from"){
                var payload = {
                    business_id: this.sellpoint.business_id
                }
                service.deleteDeliveryOption(this, option.business_delivery_from_id, payload).then(function(data) {
                    if(data.body.status == 200) {
                        // toastr.success("Sellpoint Delivery Details deleted",'Success!');
                        this.sellpoint.business_delivery_options = data.body.data;
                        this.delivery_option.edit_set = false;
                        this.delivery_option = {};
                        this.business_details = {};
                        this.deactivate_processing();
                    }
                }).catch((err) => {
                    //log it
                    this.delivery_option = {};
                    this.deactivate_processing();
                })
            }
        },

        addtoProcessingFee(){
            this.data_processing_message = "";
            this.data_error_message = ""
            this.activate_processing();
            //post order request
            var payload ={
                order_type: 1, //processing fee
                order_user: this.user.user_id,
                order_business:this.sellpoint.business_id,
                order_amount:this.processing_fee.amount,
                order_service:"Add to Processing Fee Balance",
            }
        
            service.postBusinessGeneralOrders(this, payload).then(function(data) {
                if(data.body.status == 201) {
                    this.app_orders = data.body.data;
                    this.data_processing_message = "Processing Request";
                    this.processPayment();
                }
            }).catch((err) => {
                //log it
            })
        },

        //after payment is received
        postBusinessProcessingFeeTransaction(payment_ref){
            this.data_processing_message = "Adding Processing Fee"
            //post order request
            var payload = {
                processing_fee_transaction_type: 1, //processing fee addto balance
                processing_fee_transaction_amount:this.processing_fee.amount,
                pay_ref:payment_ref,
                business:this.sellpoint.business_id,
            }
        
            service.postBusinessProcessingFeeTransactions(this, payload).then(function(data) {
                if((data.body.status == 200) || (data.body.status == 201)) {
                    this.processing_fee_transactions = data.body.data;
                    this.sellpoint.business_processing_fee_balance = data.body.data_processing_fee_balance;
                    this.sellpoint.business_processing_fee_debt = data.body.data_processing_fee_debt;
                    this.app_orders = {}; //empty
                    this.data_processing_message = "Processed";
                    this.setMenuTabInnerView('setProcessingFees');
                    this.deactivate_processing();
                    this.processing_fee = {};
                }
            }).catch((err) => {
                //log it
            })
        },

        //set bank details
        setBankDetails(){
            if(Object.keys(this.business_bank_details).length > 0){
                this.sellpoint.business_bank_details = this.business_bank_details;
            }
            this.activate_processing();
            var payload ={
                business_bank_name: this.sellpoint.business_bank_details.bank_name,
                business_bank_account_name: this.sellpoint.business_bank_details.bank_account_name,
                business_bank_account_number: this.sellpoint.business_bank_details.bank_account_number,
                business_id:this.sellpoint.business_id,
                //more bank settings
                business_bank_rvpay_sync:this.sellpoint.business_bank_details.bank_rvpay_sync || 0,
                business_bank_rvpay_subaccount_id:this.sellpoint.business_bank_details.bank_rvpay_subaccount_id || 0,
                business_bank_rvpay_id:this.sellpoint.business_bank_details.bank_rvpay_id || 0,
                business_bank_rvpay_date_created:this.sellpoint.business_bank_details.bank_rvpay_date_created || 0,
                //new for updates
                business_contact_email:this.sellpoint.business_contact_email || '',
                business_contact_phone:this.sellpoint.business_contact_phone || '',
            }
        
            service.setBusinessBankDetails(this, payload).then(function(data) {
                if(data.body.status == 200) {
                    this.data_processing_message = "Bank Details Set";
                    //--updated
                    // this.sellpoint.business_bank_details = data.body.data;
                    // if((Object.keys(this.sellpoint.business_bank_details).length > 0)){
                        localforage.setItem(service.bbnksdb_name, this.sellpoint.business_bank_details).then(function (value) {
                        }).catch(function(err) {});
                    // }
                    //--updated
                    //
                    this.deactivate_processing();
                    this.setEditBankDetails = false; //reset
                }
                // this.set_bank_details = false;
            }).catch((err) => {
                //log it
            })
        },

        setBankDetailsRavePay(){
            this.activate_processing();
            this.data_processing_message = "Verifying your bank details...";
            let payload = {
                "account_bank": this.ravepay_sba.account_bank,//,"044"
                "account_number": this.ravepay_sba.account_number,//"0690000023", //this.ravepay_sba.account_bank
                "business_name":  this.sellpoint.business_name,
                "business_email": this.sellpoint.business_contact_email,
                "business_contact": this.sellpoint.business_name,
                "business_contact_mobile": this.sellpoint.business_contact_phone,
                "business_mobile": this.sellpoint.business_contact_phone,
                "country": "NG",
                "meta": [{"metaname": "AFPID", "metavalue": ""}],
                "seckey": service.ravepay_secret_test
            }
            service.createRavepaySubaccount(payload).then(response => {
                if(response.status == 200) {
                    this.data_processing_message = "Bank Details Set";
                    //then set bank details
                    this.sellpoint.business_bank_details.bank_rvpay_sync = 1;
                    this.sellpoint.business_bank_details.bank_rvpay_subaccount_id = response.data.data.subaccount_id;
                    this.sellpoint.business_bank_details.bank_rvpay_id = response.data.data.account_bank;
                    this.sellpoint.business_bank_details.bank_rvpay_date_created = response.data.data.date_created;
                    this.sellpoint.business_bank_details.bank_name = response.data.data.bank_name;
                    this.sellpoint.business_bank_details.bank_account_name = response.data.data.fullname;
                    this.sellpoint.business_bank_details.bank_account_number = response.data.data.account_number;
                    
                    this.setBankDetails();
                    this.deactivate_processing();
                }else{
                    this.data_processing_message = "Could not verify your details, please confirm your details and try again";
                    this.deactivate_processing();
                }
            }).catch((err) => { 
                this.data_processing_message = "Could not verify your details, please confirm your details and try again";
                this.deactivate_processing();
            })
        },

        //set commissions
        setBusinessAgentCommissions(){
            this.activate_processing();
            if(!(this.sellpoint.business_agent_commission <= 100)){
                this.data_processing_message = "value inappropriate";
            }
            else{
                //post order request
                var payload = {
                    business_agent_commission:this.sellpoint.business_agent_commission || 0,
                    business:this.sellpoint.business_id,
                }
            
                service.setBusinessAgentCommissions(this, payload).then(function(data) {
                    // if(data.body.status == 200) {
                        this.data_processing_message = "Processed";
                        this.deactivate_processing();
                        this.setMenuTabInnerView('');
                        
                    // }
                }).catch((err) => {
                    //log it
                })
            }
        },

        //processing fee switch
        switchProcessingFee(to){
            this.activate_processing();
            var payload ={
                business_process_fee_pay: to,
                business_id:this.sellpoint.business_id
            }
        
            service.switchProcessingFeePay(this, payload).then(function(data) {
                if(data.body.status == 200) {
                    this.data_processing_message = "Processing Fee Set";
                    this.sellpoint.business_processing_fee_pay_status = to;
                    this.deactivate_processing();
                }
            }).catch((err) => {
                //log it
            })
        },
        

        //set shipping fee status
        setShippingFeeStatus(status_value){
            this.activate_processing();
            this.business_set_shipping_fee_status = status_value;
            var payload ={
                business_set_shipping_fee_status: this.business_set_shipping_fee_status,
                business_id:this.sellpoint.business_id
            }
        
            service.setShippingFeeStatus(this, payload).then(function(data) {
                // if(data.body.status == 200) {
                    // toastr.success("Shipping Fee Ordering Set", 'Reset!');
                    this.sellpoint.business_set_shipping_fee_status = this.business_set_shipping_fee_status;
                    this.deactivate_processing();
                // }
            }).catch((err) => {
                //log it
            })
        },
        //.../delivery

        //coupons and discounts
        getBusinessDiscountsAndCoupons(){
            service.getBusinessDiscountsCoupons(this, this.sellpoint.business_id).then(response => { //recheck
                let payload = {};
                if(response.body.status == 200) {
                    this.sellpoint.business_discounts_coupons = response.body.data; 
                    payload = this.sellpoint.business_discounts_coupons;
                }
                //commit
                this.$store.dispatch('account/setBusinessDiscounts',payload);
                
            }).catch((err) => {})
        },
        //set coupons and discount //--moved to commons
        setDiscountsAndCouponsXXXX(){
            this.activate_processing();
            this.data_processing_message = "";
            //settings for product and producitems
            if(this.product_details.setProductDiscount || this.product_details.setProductItemDiscount){
                this.discount_coupon.discount_category = 1;  //HACK..TO LET GO ../ASSIGNED 1 instead of 0.
            }
            
            //validate entry
            let entry_arr = [
                ["Discount or Coupon",this.discount_coupon.is_discount_coupon,"str"],
                ["Coupon Percentage",this.discount_coupon.discount_percentage,"num"],
                ["Discount Category",this.discount_coupon.discount_category,"num"],
                ["Start Date",this.discount_coupon.discount_start_date,"date"],
                ["End Date",this.discount_coupon.discount_end_date,"date"]
            ];
            let validated_arr = validator.validate_array(entry_arr,"Please fill in ");
            if(validated_arr.length == 0){
                //check if end date is greater than start date
                var start_date = new Date(this.discount_coupon.discount_start_date);
                var end_date = new Date(this.discount_coupon.discount_end_date)
                if(end_date <= start_date){
                    this.data_processing_message = "Please reset Dates, End Date should be greater than Start Date";
                    this.deactivate_processing();
                }else{
                    //set for business category
                    let discount_category  = 0;
                    if(this.business_details.setDiscount){
                        discount_category = this.discount_coupon.discount_category;
                    }

                    //set for product and product items
                    let product_id = 0;
                    let product_item_id = 0;
                    
                    if(this.product_details.setProductDiscount || this.product_details.setProductItemDiscount){
                        product_id = this.product.product_id;
                    }
                    if(this.product_details.setProductItemDiscount){
                        product_item_id = this.product_item.product_item_id;
                    }
                    //set for product and product items

                    //coupon style eg gift cards
                    let coupon_style_type = 0;
                    if(this.discount_coupon_is_gift_card){
                        coupon_style_type = 36; //default set value
                    }
                    var payload = {
                        business_id: this.sellpoint.business_id,
                        business_market: service.apiToken,
                        product_id: product_id,
                        product_item_id: product_item_id,
                        is_coupon_or_discount: this.discount_coupon.is_discount_coupon || 'C', //or coupon
                        coupon_business_category:discount_category,
                        coupon_style_type: coupon_style_type,
                        coupon_module_ref: discount_module_ref || '',
                        coupon_description: this.discount_coupon.discount_description || "NIL",
                        coupon_percentage: this.discount_coupon.discount_percentage,
                        coupon_min_amount: this.discount_coupon.discount_min_amount || 0,
                        coupon_min_quantity: this.discount_coupon.discount_min_quantity,
                        coupon_start_date: this.discount_coupon.discount_start_date,
                        coupon_end_date: this.discount_coupon.discount_end_date,
                    }
                    service.setDiscountsAndCoupons(this, payload).then(function(data) {
                        if(data.body.status == 201) {
                            // toastr.success("New Discount Set", 'Update!');
                            // this.sellpoint.business_discounts_coupons = data.body.data;
                            this.business_details.setDiscount = false;
                            this.business_details.viewDiscounts = true;
                            this.discount_coupon_is_gift_card = false;
                            if(this.product_details.setProductDiscount || this.product_details.setProductItemDiscount){
                                let res = data.body.data;
                                for(let item of this.product.product_items){
                                    for(let row of res){
                                        if(row.product_item_id == item.product_item_id){
                                            item.product_item_discounts = row.product_item_discounts;
                                        }
                                    }
                                    // item.product_item_discounts = res.filter(function(discount){ return discount.discount_product_item == item.product_item_id;});
                                }
                                if(this.product_details.setProductDiscount){
                                    this.product.product_only_coupon_discount_count++;
                                }
                                if(this.product_details.setProductItemDiscount){
                                    this.product_item.product_item_only_coupon_discount_count++;
                                }
                            }else{
                                this.sellpoint.business_discounts_coupons = data.body.data; 
                            }
                            this.deactivate_processing();
                            this.product_details = {};
                        }
                    }).catch((err) => {
                        //log it
                        this.deactivate_processing();
                    })
                }//date reset check
            }else{
                validated_arr.forEach(function(error) {
                    // toastr.error(error); 
                    this.data_processing_message =  this.data_processing_message + " . " +error;
                }, this);
                this.deactivate_processing();
            }
            
        },

        // edit coupons and discount
        editDiscountsAndCoupons(){
            this.data_processing_message = "";
            //validate entry
            let entry_arr = [
                ["Coupon Percentage",this.discount_coupon.discount_percentage,"num"],
                ["Discount Category",this.discount_coupon.discount_category,"num"],
                ["Start Date",this.discount_coupon.discount_start_date,"date"],
                ["End Date",this.discount_coupon.discount_end_date,"date"]
            ];
            let validated_arr = validator.validate_array(entry_arr,"Please fill in ");
            if(validated_arr.length == 0){
                //check if end date is greater than start date
                var start_date = new Date(this.discount_coupon.discount_start_date);
                var end_date = new Date(this.discount_coupon.discount_end_date);
                if(end_date <= start_date){
                    this.data_processing_message = "Please reset Dates, End Date should be pass Start Date";
                    this.deactivate_processing();
                }else{
                    this.activate_processing();
                    this.discount_coupon.business_id = this.sellpoint.business_id;
                    this.discount_coupon.business_market = service.apiToken;
                    service.editDiscountsAndCoupons(this, this.discount_coupon).then(function(data) {
                        if(data.body.status == 200) {
                            // toastr.success("Discount Set", 'Update!');
                           // this.sellpoint.business_discounts_coupons = data.body.data;
                            this.discount_coupon = {};
                            this.business_details.viewDiscounts = true;
                            if(this.product_details.setProductDiscount || this.product_details.setProductItemDiscount){
                                let res = data.body.data;
                                for(let item of this.product.product_items){
                                    for(let row of res){
                                        if(row.product_item_id == item.product_item_id){
                                            item.product_item_discounts = row.product_item_discounts;
                                        }
                                    }
                                    // item.product_item_discounts = res.filter(function(discount){ return discount.discount_product_item == item.product_item_id;});
                                }
                            }else{
                                this.sellpoint.business_discounts_coupons = data.body.data; 
                            }
                            this.deactivate_processing();
                            this.product_details = {};
                        }
                    }).catch((err) => {
                        //log it
                        this.deactivate_processing();
                    })
                }
            }else{
                validated_arr.forEach(function(error) {
                    // toastr.error(error); 
                    this.data_processing_message =  this.data_processing_message + " . " +error;
                }, this);
                this.deactivate_processing();
            }
        },

        
        // edit coupons and discount
        deactivateDiscountsAndCoupons(payload){
            this.activate_processing();
            payload.business_id = this.sellpoint.business_id;
            payload.business_market = service.apiToken;
            service.deactivateDiscountsAndCoupons(this, payload).then(function(data) {
                if(data.body.status == 200) {
                    // toastr.success("Discount Set", 'Update!');
                    // this.sellpoint.business_discounts_coupons = data.body.data;
                    this.business_details.viewDiscounts = true;
                    if(this.product.product_id){
                        let res = data.body.data;
                        for(let item of this.product.product_items){
                            for(let row of res){
                                if(row.product_item_id == item.product_item_id){
                                    item.product_item_discounts = row.product_item_discounts;
                                }
                            }
                            // item.product_item_discounts = res.filter(function(discount){ return discount.discount_product_item == item.product_item_id;});
                        }
                    }else{
                        this.sellpoint.business_discounts_coupons = data.body.data; 
                    }
                    this.deactivate_processing();
                    this.product_details = {};
                }
            }).catch((err) => {
                //log it
                this.deactivate_processing();
            })
        },

        //../coupons and discounts

        //business rewards
        getBusinessRewardSettings(){
            service.getBusinessRewardSettings(this, this.sellpoint.business_id).then(response => {
                if(response.body.status == 200) {
                    this.sellpoint.reward_settings = response.body.data;
                    this.setRewardCommission();
                }
                this.componentKey++;
                this.loading = false;
            }).catch((err) => {
                //console.log(err)
            })
        },

        postBusinessRewardSettings(reward_type){
            this.activate_processing();
            var payload = {
                reward_type_business: this.sellpoint.business_id,
                reward_type_type: reward_type.reward_type_id,
                reward_type_amount_type: this.set_reward_type_amount_type || C, //default cash
                reward_type_amount: this.business_details.set_reward_type_amount || 5,
                reward_type_duration: this.business_details.set_reward_type_duration || 0,
            }
            if(payload.reward_type_amount == 0){
                this.data_processing_message = "Amount should be more than 0";
                this.deactivate_processing();
            }else{
                service.postBusinessRewardSettings(this, payload).then(function(data) {
                    if((data.body.status == 201) || (data.body.status == 200)) {
                        this.sellpoint.reward_settings = data.body.data;
                        this.data_processing_message = "Set";
                        this.business_details = {};
                        this.deactivate_processing();
                        this.setMenuTabInnerView('');
                    }
                    this.setRewardCommission();
                }).catch((err) => {
                    //log it
                    this.business_details = {};
                    this.deactivate_processing();
                })
            }
            
        },

        updateBusinessRewardSettings(reward_type_setting){
            this.activate_processing();
            var payload = {
                reward_set: reward_type_setting.reward_set,
                reward_set_amount_type: reward_type_setting.reward_set_amount_type || C, //default cash
                reward_set_amount: reward_type_setting.reward_set_amount || 5,
                reward_set_duration: reward_type_setting.reward_set_duration || 0,
            }
            // if(payload.reward_set_amount == 0){
            //     this.data_processing_message = "Amount should be more than 0";
            //     this.deactivate_processing();
            // }else{
            if(payload.reward_set_amount){    
                service.updateBusinessRewardSettings(this, payload).then(function(data) {
                    if((data.body.status == 201) || (data.body.status == 200)) {
                        this.sellpoint.reward_settings = data.body.data;
                        this.data_processing_message = "Updated";
                        this.business_details = {};
                        this.deactivate_processing();
                        this.setMenuTabInnerView('');
                    }
                    this.setRewardCommission();
                }).catch((err) => {
                    //log it
                    this.business_details = {};
                    this.deactivate_processing();
                })
            }
        },

        setRewardCommission(){
            if((Object.keys(this.sellpoint.reward_settings).length) > 0){
                for(let rw of this.sellpoint.reward_settings){
                    if(rw.reward_type_id == 2){ 
                        if((rw.reward_type_setting.reward_set_amount) && (rw.reward_type_setting.reward_set_amount > 0)){
                            this.set_reward_commission = rw.reward_type_setting.reward_set_amount;console.log(this.set_reward_commission)
                            this.componentKey++;
                        }
                    }
                }
            }
        },

        updateBusinessGeneralSettings(update_no,data){
            this.activate_processing();
            var payload = {};
            if(update_no == 1){//set business open to agents
                this.business_details.business_open_agents = 0;//defaults
                if(this.sellpoint.business_is_agents_open && (this.sellpoint.business_is_agents_open == 0)){
                    this.sellpoint.business_is_agents_open = 1; //open
                }else{this.sellpoint.business_is_agents_open = 0;}
                payload = {
                    business_update_no: 1,
                    business_open_agents: this.sellpoint.business_is_agents_open,
                }
            }
            
            //change business agent type
            //data.business_agent_type = 19+9;
            if((update_no == 2)){
                if(data.business_agent_type == 20){
                    data.business_agent_type_name = "Advanced";
                }
                //
                if(data.business_agent_type == 19){
                    data.business_agent_type_name = "Basic";
                }
                //
                payload = {
                    business_agent_id: data.business_agent_id,
                    business_agent_type: data.business_agent_type,
                }
                if(this.sellpoint.business_agent == 1){//set change business agents type //agent
                    payload.business_update_no = 2;
                }else{//seler
                    payload.business_update_no = 3;
                }
               
            }
            //defaults
            payload.business = this.sellpoint.business_id;
            if(payload.length != 0){
                service.updateBusinessGeneralSettings(this, payload).then(function(data) {
                    if((data.body.status == 201) || (data.body.status == 200)) {
                        this.data_processing_message = "Updated";
                        this.business_details = {};
                        this.getSellpointDetails(); //re-get here //
                        this.deactivate_processing();
                        this.setMenuTabInnerView('');
                    }
                }).catch((err) => {
                    //log it
                    this.business_details = {};
                    this.deactivate_processing();
                })
            }
        },

        getBusinessesOpenToAgents(){
            var payload = {
                business_category: 0,
            }
            service.getBusinessesOpenToAgents(this, payload).then(response => {
                if(response.body.status == 200) {
                    this.business_open_to_agents = response.body.data;
                }
            }).catch((err) => {})
        },
        

        onFileChangeBannerImage(e,type) {
            this.activate_processing();
            let files = e.target.files || e.dataTransfer.files;
            if (files.length)
            {
                let formData = new FormData();
                formData.append('photo', files[0]);
                formData.append('data_id', this.sellpoint.business_id); 
                formData.append('data_type', type); 
                service.uploadBusinessDataPhoto(this, formData).then(data => {
                    if(data.body.status == 200){
                        if(type == "business_banner_image"){
                            this.sellpoint.business_banner_image = data.body.data;
                            this.set_gallery_banner_image = this.sellpoint.business_banner_image;
                        }
                        if(type == "business_brand_image"){
                            this.sellpoint.business_brand_image = data.body.data;
                        }
                        //wait and reset
                        let self = this;
                        setTimeout(function(){ 
                            //close the sidebar after one sec
                            self.deactivate_processing();
                            //load a bit more to set the image
                            self.loading = true;
                            setTimeout(function(){ 
                                self.loading = false;
                                self.setCurrentBusiness();
                            }, 1200);
                        }, 1000);
                        // this.deactivate_processing();
                    }else{
                        this.data_error_message = "Could not update, something went wrong. Please try again";
                        this.deactivate_processing();
                    }
                }).catch((err) => {
                    this.data_error_message = "Could not update, something went wrong. Please try again";
                    this.deactivate_processing();
                })
            }   
                
        },
        //../...business--settings
        
        //.....product--settings------/
        addToServiceOffers(offer){
            //check
            // this.service_offers.push(offer)
            if((offer.offer_set != undefined) || (offer.offer_new_offer != undefined)){
                if((offer.offer_set != undefined) && (offer.offer_limit != undefined)){
                    //some settings for displays
                    offer.offer = offer.offer_set.business_service_offer_id;
                    offer.offer_name = offer.offer_set.business_service_offer;
                    offer.offer_type_name = offer.offer_set.business_service_offer_type_name;
                    offer.offer_limit = offer.offer_limit;
                    offer.offer_set_actions = {};
                    offer.offer_set_actions.data_action_name = offer.offer_set.business_service_offer_action_name;
                    this.service_offers.push(offer);
                }
                if(offer.offer_new_offer != undefined){
                    offer.offer_type = offer.offer_type_set.data_service_id;
                    offer.offer_type_name = offer.offer_type_set.data_service_name;
                    if((offer.offer_type != undefined) && (offer.offer_limit != undefined) && (offer.offer_set_actions != undefined)){
                        offer.offer_action = offer.offer_set_actions.data_action_id;//reset
                        this.service_offers.push(offer);
                    }
                }
                this.service_offer = {}; //refresh
            }
        },

        setAddProductMedia(product){
            //add image
            if(Object.keys(product).length > 0){
                this.imageForm.append("data_id", product.product_id);
                this.imageForm.append("data_type","products");
                service.uploadDataPhoto(this, this.imageForm).then(data => {
                    if(data.body.status == 200){
                        //
                    }else{
                        this.data_processing_message = service.upload_media_error_msg;
                    }
                }).catch((err) => {
                    if(err) {}
                    this.data_error_message = service.upload_media_error_msg;
                })
            }
        },
        
        addProduct(){
            this.resetMessages(); //reset
            this.activate_processing();
            let can_submit = true;
            //some checks
            if((this.service_offers.length == 0) && ((Object.keys(this.service_offer).length > 0))){ //if user forgot to click the add offer btn
                this.addToServiceOffers(this.service_offer);
            }
            if(this.product.product_is_subscribed_to){
                this.product.product_is_subscribed_to = 1;
            }else{
                this.product.product_is_subscribed_to = 0;
            }
            //wholesale settings
            if(this.product_is_wholesale){
                if((this.product.product_item_set_moq > 0) || (this.product.product_item_set_moq_price > 0)){
                    can_submit = true;
                }else{
                    can_submit = false;
                }
                if((this.product.product_item_price <= 0) || (this.product.product_item_price == '') || (this.product.product_item_price == undefined)){
                    this.product.product_item_price = this.product.product_item_set_moq_price;
                }
            }

            // this.loading = true;
            if(this.add_general_products == 0){
                var credentials = {
                    product_name: this.product.product_name,
                    product_is_product_or_service: this.is_product_service,
                    product_category_is_set: this.category.business_category_id || 0,
                    product_business: this.sellpoint.business_id || 0,
                    product_description: this.product.product_description || "nill",
                    // product_item_price: this.product.product_item_price.replace(/\D+/g, ''),/^[0-9.,]+$/
                    product_item_price: this.product.product_item_price,
                    product_item_weight: this.product.product_item_weight || 1,
                    product_item_quantity: this.product.product_item_quantity || 100,
                    product_is_subscribed_to: this.product.product_is_subscribed_to,
                    product_service_offers: this.service_offers,
                }
            }else if(this.add_general_products == 1){
                var credentials = {
                    product_custom_app: 1,
                    product_custom_app_data_id:this.product.product_id,
                    product_custom_app_set_category:this.general_goods_category,
                    product_name: this.product.product_name,
                    product_category_is_set: 0,
                    product_business: this.sellpoint.business_id,
                    product_description: "nill",
                    product_item_price: this.product.product_items[0].product_item_price,//this.product.product_item_price,
                    product_item_weight: this.product.product_item_weight || 1,
                    product_item_quantity: this.product.product_item_quantity || 100,
                    product_is_subscribed_to: this.product.product_is_subscribed_to,
                    product_service_offers: this.service_offers,
                }
            }
            
            let navi = this.$router;
            if(can_submit && ((credentials.product_name != undefined) && (credentials.product_item_price > 0))) {
                service.addProduct(this, credentials).then(function(data) {
                    if(data.body.status == 201) {
                        this.data_success_message = "Processing, please wait ...";
                        
                        // this.product = data.body.data; //to avoid force form input resets
                        let product = data.body.data;

                        //add product details
                        if((this.product_set_details).length > 0){
                            this.addProductDetails(product);
                        }
                        
                        //add image
                        // this.imageForm.append("data_id", this.product.product_id);
                        this.imageForm.append("data_id", product.product_id);
                        // this.imageForm.append("data_type","product_items"); //refac
                        this.imageForm.append("data_type","products");
                        service.uploadDataPhoto(this, this.imageForm).then(data => {
                            if(data.body.status == 200){
                                this.back();
                                //this.setBusinessComponent('viewBusinessCategory',this.sellpoint,this.category);
                                this.deactivate_processing();
                                this.resetFormData()
                            }else{
                                this.data_processing_message = service.upload_media_error_msg;
                                // this.deactivate_processing();
                                //reset after timed out warning
                                setTimeout(function(){
                                    self.back();
                                    //self.setBusinessComponent('viewBusinessCategory',self.sellpoint,self.category);
                                    self.deactivate_processing();
                                    self.resetFormData();
                                }, service.timeout_msg_wait_period); 
                            }
                            //
                            //this.getBusinessCategoryProducts();
                        }).catch((err) => {
                            if(err) {}
                            this.data_error_message = service.upload_media_error_msg;
                            //this.getBusinessCategoryProducts();
                            this.back();
                            //this.deactivate_processing();
                           // this.resetFormData();
                        })

                        ///
                        //if uploading takes time continue with calls in the kipper
                        let self = this;
                        setTimeout(function(){  
                            self.setBusinessComponent('viewBusinessCategory',self.sellpoint,self.category);
                            self.deactivate_processing();
                            self.resetFormData();
                        }, service.upload_wait_period); //wait and call posts in gallery

                        //refershs
                        this.service_offers = {};

                    }
                }).catch((err) => {
                    if(err) {
                        console.log(err);
                        this.data_error_message = "Something went wrong, preparing report ...";
                        this.setBusinessComponent('viewBusinessCategory',this.sellpoint,this.category);
                        this.deactivate_processing();
                        this.resetFormData()
                    }
                })
            }else {
                // toastr.error('Kindly fill all fields', 'Warning!');
                this.data_error_message = "Kindly fill all fields ...";
                this.deactivate_processing();
            }
        },

        addNewAgentProduct(product,add_to_agent_category_type){ 
            this.product = product;
            this.activate_processing(); 
            //add more product attributes before  sending across
            product.product_agent_business = this.sellpoint.business_id;
            product.product_agent_category_type = add_to_agent_category_type;
            product.product_agent_category = this.category.business_category_id;
            product.product_agent_category_name = this.category.business_category_name;
           
            let navi = this.$router;
            // if(credentials.product_name != undefined) {
                service.addAgentProduct(this, product).then(function(data) {
                    if(data.body.status == 201) {
                        //this.menu_view.newBusinessAgentCategoryProduct = false; //switch off view
                        //do somstuff
                        this.sellpoint.business_categories = data.body.data_business_categories;
                        //commit here
                        this.$store.dispatch('account/setSellpointCategories',this.sellpoint.business_categories);
                        //
                        this.setBusinessComponent('viewBusinessCategory',this.sellpoint,data.body.data_active_business_category);
                        this.data_success_message = "Processing, please wait ...";
                        this.deactivate_processing ();
                    }
                    this.setBusinessComponent('viewBusinessCategory',this.sellpoint,this.category);
                }).catch((err) => {this.setBusinessComponent('viewBusinessCategory',this.sellpoint,this.category);
                })
            // }
        },
        
        //add wholesale moq
        setProductItemsMOQ(action,moq){
            this.resetMessages(); //reset
            this.activate_processing();
            let can_submit = false;
            let product_item_moq = {};
            //some checks
            if(action == 'delete_moq'){
                can_submit = true;
                product_item_moq = moq;
            }
            if(action == 'edit_moq'){
                if((moq.product_item_moq > 0) || (moq.product_item_moq_price > 0)){
                    can_submit = true;
                    product_item_moq = moq;
                }
            }
            if(action == 'add_moq'){
                if((this.product_item.product_item_set_moq > 0) || (this.product_item.product_item_set_moq_price > 0)){
                    can_submit = true;
                    product_item_moq.product_item_moq_product_item = this.product_item.product_item_id,
                    product_item_moq.product_item_moq = this.product_item.product_item_set_moq;
                    product_item_moq.product_item_moq_price = this.product_item.product_item_set_moq_price;
                }
            }

            // this.loading = true;3  
            var credentials = {
                data_action: action,
                data_moq: product_item_moq,
            }
            
            let navi = this.$router;
            if(can_submit) {
                service.setProductITemMOQs(this, credentials).then(function(data) {
                    if(data.body.status == 200) {
                        this.product_item.product_item_moqs = data.body.data;
                        this.data_success_message = "Processing, please wait ...";
                        this.deactivate_processing();
                        this.setMenuTabInnerView('');
                    }
                }).catch((err) => {
                    if(err) {
                        this.data_error_message = "Something went wrong, preparing report ...";
                        this.deactivate_processing();
                    }
                })
            }else {
                // toastr.error('Kindly fill all fields', 'Warning!');
                this.data_error_message = "Kindly fill all fields ...";
                this.deactivate_processing();
            }
        },

        //add product addons
        setAddToProductAddons(add_product){
            if(!this.product.set_product_addons){
                this.product.set_product_addons = []; //create if does not exist
                this.product.set_product_addons.push(add_product.product_id); //add to addons
            }else{
                //check if exist
                if(!(this.product.set_product_addons.includes(add_product.product_id))){ //is not in array
                    this.product.set_product_addons.push(add_product.product_id); //add to addons
                }
            }
        },

        addToProductAddons(){
            if(Object.keys(this.product.set_product_addons).length > 0){
                var payload = {
                    product: this.product.product_id,
                    product_addons: this.product.set_product_addons,
                }
                //add at server
                service.addToProductAddons(this, payload).then(function(data) {
                    if(data.body.status == 201) {
                        this.product.product_addons = data.body.data;
                        this.data_success_message = "Processing, please wait ...";
                        this.componentKey++;
                        this.deactivate_processing();
                        //
                        if(document.getElementById('setAddProductAddons')){
                            this.toggleSingleComponent('setAddProductAddons');
                        }
                        // this.setMenuTabInnerView('');
                    }
                }).catch((err) => {
                    if(err) {console.log();console.log(err)
                        this.data_error_message = "Something went wrong, preparing report ...";
                        this.deactivate_processing();
                    }
                })
            }
        },

        removeProductAddons(){
            if(Object.keys(this.product.set_product_addons).length > 0){
                var payload = {
                    product: this.product.product_id,
                    product_addons: this.product.set_product_addons,
                }
                //add at server
                service.removeProductAddons(this, payload).then(function(data) {
                    if(data.body.status == 200) {
                        this.product.product_addons = data.body.data;
                        this.data_success_message = "Processing, please wait ...";
                        this.componentKey++;
                        this.deactivate_processing();
                    }
                }).catch((err) => {
                    if(err) {console.log();console.log(err)
                        this.data_error_message = "Something went wrong, preparing report ...";
                        this.deactivate_processing();
                    }
                })
            }
        },

        //get product addons
        getProductAddons(product){
            let set_addons = [];
            let product_id = product.product_id;

            //get the already exisiting addons
            let product_addons = [];
            if(product.product_addons && (Object.keys(product.product_addons).length > 0)){
                //
                product_addons = product.product_addons;
            }

            //loop through products and get products that are not addons or this product itself
            for(let prd of this.products){
                if(product_id != prd.product_id){
                    for(let addon of product_addons){
                        if(addon.product_id != prd.product_id){
                            set_addons.push(prd);
                        }
                    }
                }
            }

            //
            this.set_product_addons = set_addons;
        },

        addProductDetails(product){
            if((this.product_set_details).length > 0){
                for(let pd of this.product_set_details){
                    var payload = {
                        product_id: product.product_id,
                        product_info_type: pd.type,
                        product_info_title: pd.title,
                        product_info_detail: pd.detail,
                        product_info_set_name: pd.set_name || '',
                        product_info_set_cost: pd.set_cost || 0,
                    }
                    //add at server
                    service.addProductInformation(this, payload).then(function(data) {
                        if(data.body.status == 201) {
                            this.product.product_addons = data.body.data;
                            this.data_success_message = "Processing, please wait ...";
                            //--this.deactivate_processing();
                            //--this.toggleSingleComponent('setAddProductAddons');
                            // this.setMenuTabInnerView('');
                        }
                    }).catch((err) => {
                        if(err) {
                            this.data_error_message = "Something went wrong, preparing report ...";
                            this.deactivate_processing();
                        }
                    })
                }
            }
        },
        
        //images
        getProductImages(){
            service.getProductImages(this,this.product.product_id).then(response => {
                if(response.body.status == 200) {
                    this.product.product_images = response.body.data;
                    this.product_display_image = this.product.product_images[0];
                    //reset if set
                    this.data_media_error_message = "";
                    this.deactivate_processing();
                }
            }).catch((err) => {})
                
        },

        deleteProductImage(image){
            this.activate_processing();
            service.deleteProductImage(this, image).then(function(data) {
                if(data.body.status == 200) {
                    this.getProductImages();
                }
                this.deactivate_processing();
            }).catch((err) => {this.deactivate_processing();})
        },
        //images
        //edit product
        editProduct(){
            this.activate_processing();
            //this.business.agree = true;
            //some settings
            let set_product_category = this.product.product_category_id;
            if((this.product.product_sub_category != undefined) || (this.product.product_listed_category != undefined)){ //if either of 2 where selected
                set_product_category = 0; //make product_category 0
            }else{
                if(this.product.product_category != undefined){ //if new product_category is selected
                    set_product_category = this.product.product_category;
                }else{
                    set_product_category = this.product.product_category_id; //current product_category
                }
            }
            var credentials = {
                product_id: this.product.product_id,
                product_name: this.product.product_name,
                // product_category: this.product.product_category || this.product.product_category_id, //before

                //new
                product_category: set_product_category,
                product_sub_category: this.product.product_sub_category || 0,
                product_listed_category: this.product.product_listed_category || "nill",
                //

                product_url_name: this.product.product_url_name,
                product_description: this.product.product_description || "nill",
                product_business: this.product.product_business_id, //new to help with category settings
            }
            
            let navi = this.$router;
            if(credentials.product_name != undefined) {
                service.editProduct(this, this.product.product_id, credentials).then(response => {
                    if(response.body.status == 200) {
                        //toastr.success("Product Updated", 'Success!');
                        this.product = response.body.data;
                        this.product_details = {};
                        // navi.push("/"+this.product.product_business_ownername+"/"+this.product.product_url_name);
                    }else{
                        this.product_details = {};
                        this.deactivate_processing();
                    }
                    //reset product item in a case price was changed
                    //console.log(3445677)
                    this.product_item.product_item_price = this.product.product_price;
                    this.editProductItem();
                    //re-get products
                    this.getSellpointProducts();
                }).catch((err) => {
                    if(err) {
                        //toastr.warning("Something went wrong", 'Warning!'); 
                        this.data_processing_message = "Something went wrong";
                        this.product_details = {}; //manage with this for now
                        this.deactivate_processing();
                    }
                })
            }else {
                // toastr.error('Kindly fill all fields', 'Warning!');
                this.data_processing_message = "Kindly fill all fields";
                this.disable_btn = false;
            }
        },

        editProductSingleProductItem(){
            this.activate_processing();
            //quick check for product item
            let set_product_item = 0;
            let current_set_product_item_actual_price = this.product.product_items[0].product_item_actual_price;
            if(this.product.product_items[0].product_item_actual_price != 0){
                set_product_item = this.product.product_items[0].product_item_actual_price;
            }else{
                set_product_item = this.product.product_items[0].product_item_price;
            }
            var credentials = {
                product_item_id: this.product.product_items[0].product_item_id,
                // product_item_price: this.product_item.product_item_price,
                product_item_price: set_product_item,
                product_item_weight: this.product.product_items[0].product_item_weight || 1,
                product_item_quantity: this.product.product_items[0].product_item_quantity || 100
            }
    
            let navi = this.$router;
            if(credentials.product_item_price != undefined) {
                service.editProductItemSingle(this, this.product.product_items[0].product_item_id, credentials).then(response => {
                    if(response.body.status == 200) {
                        this.product.product_items[0] = response.body.data;
                        this.product.product_items[0].product_item_actual_price = current_set_product_item_actual_price; //rehack later
                        this.deactivate_processing();
                        this.product_details = {};
                    }
                }).catch((err) => {
                        if(err) {
                            this.data_processing_message = "Update failed, Something went wrong";
                           this.deactivate_processing();
                        }
                    })
                }else {
                    this.data_processing_message = 'Kindly fill all fields';
                    this.deactivate_processing();
                }
        },

        //edit product
        editProductSettings(){
            this.activate_processing();
            var payload = {
                product_id: this.product.product_id,
                product_groups_set_name: this.product.product_groups_set_name || 'Group/Types',
                product_groups_items_set_name: this.product.product_groups_items_set_name || 'Select Item',
            }
            
            let navi = this.$router;
            service.editProductSettings(this, this.product.product_id, payload).then(response => {
                if(response.body.status == 200) {
                    this.product = response.body.data;
                    this.product_details = {};
                }else{
                    this.product_details = {};
                    this.deactivate_processing();
                }
            }).catch((err) => {
                if(err) {
                   this.data_processing_message = "Something went wrong";
                    this.product_details = {}; //manage with this for now
                    this.deactivate_processing();
                }
            })
        },

        addProductItem(){
            this.activate_processing();
            if(this.product_details.addProductItemToGroup){
                var credentials = {
                    product_item_group: this.product_item_group.product_item_group_id || 1, //default add to ist group
                    
                    product_id: this.product.product_id,
                    product_item_price: this.product.product_item_price,
                    product_item_weight: this.product.product_item_weight || 1,
                    product_item_quantity: this.product.product_item_quantity || 100,
                    product_item_size: this.product.product_item_size || "Nill",
                    product_item_service_tag: this.product.product_item_service_tag || "Nill",
                    product_item_service_duration: (this.product.product_item_service_duration + this.service_duration) || '1 year',
                }
            }else{
                let new_product_item_group = false;
                let product_item_group_is_color_image = 'IMG';
                if(this.product.product_item_group == undefined){
                    new_product_item_group = true;
                }
                if(this.product.product_item_group_color == undefined){
                    product_item_group_is_color_image = 'IMG';
                }else{
                    product_item_group_is_color_image = 'COL';
                    // this.product.product_item_group_color = '#000000';
                }
                var credentials = {
                    //new product_items_group_details
                    product_new_product_item_group: new_product_item_group,
                    product_item_group_product: this.product.product_id,
                    product_item_group_name: this.product.product_item_group_name || "Group/Type",
                    product_item_group_is_color_image: product_item_group_is_color_image,
                    product_item_group_color: this.product.product_item_group_color || "Nill",
                    product_item_group_image: this.product.product_item_group_image || 0,
                    //./..new .product_items_group_details
                    
                    product_item_group: this.product.product_item_group || 1, //default add to ist group
                    
                    product_id: this.product.product_id,
                    product_item_price: this.product.product_item_price,
                    product_item_weight: this.product.product_item_weight || 1,
                    product_item_quantity: this.product.product_item_quantity || 100,
                    product_item_size: this.product.product_item_size || "Nill",
                    product_item_service_tag: this.product.product_item_service_tag || "Nill",
                    product_item_service_duration: (this.product.product_item_service_duration + this.service_duration) || '1 year',
                }
            }
            let navi = this.$router;
            if(credentials.product_item_price != undefined) {
                service.addProductItem(this, credentials).then(function(data) {
                    if(data.body.status == 201) {
                        this.data_success_message = "Product Item Added Successfully";
                        this.product = data.body.data_product;
                        //this.reloadToView()
                        this.product_details.addProductItemPanel = false;
                        this.product_details = {};
                        this.setMenuTabView('product','setBusinessCategoryProductItems',this.sellpoint,'')
                        //this.setComponent('reset-edit','');
                    }
                }).catch((err) => {
                    if(err) {
                        this.data_error_message = "Something went wrong"; 
                        // toastr.warning("Something went wrong", 'Warning!'); 
                         console.log(err)
                        // this.disable_btn = false;
                        this.deactivate_processing();
                    }
                })
            }else {
                this.data_error_message = "Kindly fill all fields"; 
                // toastr.error('Kindly fill all fields', 'Warning!');
                // this.disable_btn = false;
                this.deactivate_processing();
            }
        },

        //edit product item
        editProductItem(){
           // console.log(109999)
            this.activate_processing();
            //quick check for product item
            let set_product_item_price = 0;
            if(this.product_item.product_item_actual_price != undefined){
                if(this.product_item.product_item_actual_price > 0){
                    set_product_item_price = this.product_item.product_item_actual_price;
                }else{
                    set_product_item_price = this.product_item.product_item_price;
                }
            }else{
                set_product_item_price = this.product_item.product_item_price;
            }
            var credentials = {
                product_item_id: this.product_item.product_item_id,
                // product_item_price: this.product_item.product_item_price,
                product_item_price: set_product_item_price,
                product_item_weight: this.product_item.product_item_weight || 1,
                product_item_size: this.product_item.product_item_size || "Nill",
                product_item_service_tag: this.product_item.product_item_service_tag || "Nill",
                product_item_quantity: this.product_item.product_item_quantity || 100
            }
    
            let navi = this.$router;
            if(credentials.product_item_price != undefined) {
                service.editProductItem(this, this.product_item.product_item_id, credentials).then(response => {
                    if(response.body.status == 200) {
                        this.product_item = response.body.data;
                        //setts
                        if(this.product.product_item[0].product_item_id == this.product_item.product_item_id){
                            this.product.product_price = this.product_item.product_item_price;
                        }
                        this.deactivate_processing();
                        this.product_details = {};
                        if(this.$route.params.ref && (this.$route.params.ref != '')){
                            navi.push('/manage/order/'+this.product.product_url_name);
                        }
                    }
                }).catch((err) => {
                        if(err) {
                        // toastr.warning("Something went wrong", 'Warning!'); 
                           // console.log(err)
                           this.data_processing_message = "Update failed, Something went wrong";
                           this.deactivate_processing();
                        }
                    })
                }else {
                    //toastr.error('Kindly fill all fields', 'Warning!');
                    this.data_processing_message = 'Kindly fill all fields';
                    this.deactivate_processing();
                }
        },

        //edit product item group
        editProductItemGroup(){
            this.activate_processing();
            let product_item_group_is_color_image = 'IMG';
            if(this.product_item_group.product_item_group_color == undefined){
                product_item_group_is_color_image = 'IMG';
            }else{
                product_item_group_is_color_image = 'COL';
            }

            //set only color if defined
            if(this.product_item_group.product_item_group_color_new != undefined){
                product_item_group_is_color_image = 'COL';
                this.product_item_group.product_item_group_color = this.product_item_group.product_item_group_color_new; //a new one
                this.product_item_group.product_item_group_image = 0; //set image to 0
            }else{
                product_item_group_is_color_image = 'IMG';
                this.product_item_group.product_item_group_color = "Nill"; //set color to nill
            }
            var credentials = {
                product_item_group_product: this.product.product_id,
                product_item_group_name: this.product_item_group.product_item_group_name || "Type",
                product_item_group_is_color_image: product_item_group_is_color_image,
                product_item_group_color: this.product_item_group.product_item_group_color || "Nill",
                product_item_group_image: this.product_item_group.product_item_group_image || 0,
            }


           let navi = this.$router;
            if(credentials.product_item_group_name != undefined) {
                service.editProductItemGroup(this, this.product_item_group.product_item_group_id, credentials).then(response => {
                    if(response.body.status == 200) {
                        //this.product_item_group = response.body.data;

                        this.product.product_item_groups = response.body.data;

                        this.deactivate_processing();
                        this.product_details = {};
                    }else{
                        this.deactivate_processing();
                        this.product_details = {};
                    }
                }).catch((err) => {
                        if(err) {
                        // toastr.warning("Something went wrong", 'Warning!'); 
                           // console.log(err)
                           this.data_processing_message = 'Update failed, Something went wrong';
                           this.deactivate_processing();
                        }
                    })
                }else {
                    //toastr.error('Kindly fill all fields', 'Warning!');
                    this.data_processing_message = 'Kindly fill all fields';
                    this.deactivate_processing();
                }
        },

        restockProductItem(){
            this.activate_processing();
            //quick check for product item
            let set_product_item = 0;
            if(this.product_item.product_item_actual_price != 0){
                set_product_item = this.product_item.product_item_actual_price;
            }else{
                set_product_item = this.product_item.product_item_price;
            }
            var credentials = {
                product_item: this.product_item,
                product_item_id: this.product_item.product_item_id,
                product_item_quantity_restock: this.product_item.product_item_quantity_restock || 100
            }
    
            let navi = this.$router;
            if(credentials.product_item_quantity_restock != undefined) {
                service.restockProductItem(this, this.product_item.product_item_id, credentials).then(response => {
                    if(response.body.status == 200) {
                        this.product_item = response.body.data;
                        this.deactivate_processing();
                        this.product_details = {};
                    }
                }).catch((err) => {
                        if(err) {
                        // toastr.warning("Something went wrong", 'Warning!'); 
                           // console.log(err)
                           this.data_processing_message = "Update failed, Something went wrong";
                           this.deactivate_processing();
                        }
                    })
            }else {
                //toastr.error('Kindly fill all fields', 'Warning!');
                this.data_processing_message = 'Kindly fill all fields';
                this.deactivate_processing();
            }
        },

        removeProduct(){
            this.activate_processing();
            var payload = {
                product_id: this.product.product_id
            }
            let navi = this.$router;
            service.removeProduct(this,this.product.product_id,payload).then(response => {
                if(response.body.status == 200) {
                    location.reload(true)
                    // this.deactivate_processing();
                }
            }).catch((err) => {
                if(err) {
                    location.reload(true)
                }
            })
            
        },

        removeProductItem(){
            this.activate_processing();
            var payload = {
                product_id: this.product.product_id,
                product_item_id: this.product_item.product_item_id
            }
            let navi = this.$router;
            service.removeProductItem(this,this.product_item.product_item_id,payload).then(response => {
                if(response.body.status == 200) {
                    if(response.body.no_product){
                        this.redir(this.$route.params.id); //go to sellpoint
                    }
                    this.product.product_item_groups = response.body.data;
                   // location.reload(true)
                    //this.product.product_item = response.body.data;
                    //maually delete from array
                    //product_item_group.product_items.splice(this.product_item.product_item_id, 1 );
                    this.deactivate_processing();
                    this.removeItemPanel = false;
                }
            }).catch((err) => {
                if(err) {
                    //console.log(err)
                    this.deactivate_processing();
                }
            })
            
        },

        removeProductItemGroup(){
            this.activate_processing();
            var payload = {
                product_id: this.product.product_id,
                product_item_group_id: this.product_item_group.product_item_group_id
            }
            let navi = this.$router;
            service.removeProductItemGroup(this,this.product_item_group.product_item_group_id,payload).then(response => {
                if(response.body.status == 200) {
                    if(response.body.no_product){
                        this.redir(this.$route.params.id); //go to sellpoint
                    }
                    this.product.product_item_groups = response.body.data;
                    this.deactivate_processing();
                    this.removeItemGroupPanel = false;
                }
            }).catch((err) => {
                if(err) {
                    //console.log(err)
                    this.deactivate_processing();
                }
            })
            
        },

        setProductDelivery(){
            this.activate_processing();
            var payload = {
                product_id: this.product.product_id,
                product_delivery_details: this.product.product_delivery_returns
            }
            service.setProductDelivery(this, 1, payload).then(function(data) {
                if(data.body.status == 200) {
                    this.product_details = {}
                }
                this.deactivate_processing();
            }).catch((err) => {
                //log it
                this.product_details = {}
                this.deactivate_processing();
            })
        },

        setProductShippingFeeStatus(){
            this.set_shipping_fee_status_track = true;
            this.activate_processing();
            var payload = {
                product_id: this.product.product_id,
                product_set_shipping_fee_status: this.product_set_shipping_fee_status,
            }
            service.setProductShippingFeeStatus(this, payload).then(function(data) {
                // if(data.body.status == 200) {
                    this.product.product_set_shipping_fee_status = this.product_set_shipping_fee_status;
                    this.set_shipping_fee_status_track = false;
                    this.deactivate_processing();
                // }
            }).catch((err) => { 
                //log it
            })
        },

        setProductDeliveryOption(){
            this.activate_processing();
            var payload = {
                business_id: this.sellpoint.business_id,
                business_product_id: this.product.product_id,
                business_product_delivery_fee: this.delivery_option.product_delivery_fee || 0,
                business_delivery_option_id: this.delivery_option.business_delivery_option_id
            }
            if(payload.business_product_delivery_option_price == 0){
                toastr.warning("Delivery Charge not Added", 'Warning!');
            }else{
                if((payload.business_product_delivery_option != 0)){
                    service.setProductDeliveryOption(this, payload).then(function(data) {
                    if((data.body.status == 200) || (data.body.status == 201)) {
                       // toastr.success("Sellpoint Delivery Details edited",'Success!');
                        // this.product.product_delivery_options = data.body.data;
                        this.product.product_business_delivery_options = data.body.data;
                        this.delivery_option.edit_set = false;
                        this.product_details = {};
                        //this.delivery_option = {};
                        this.deactivate_processing();
                    }else{
                        this.deactivate_processing();
                    }
                    }).catch((err) => {
                        //log it
                        //this.delivery_option = {};
                        this.delivery_option.edit_set = false;
                        this.product_details = {};
                        this.deactivate_processing();
                    })
                }else{
                    //toastr.warning("Select a delivery option", 'Warning!');
                    this.deactivate_processing();
                }
            }
        },

        //set settings
        setProductSettings(payload){
            this.activate_processing();
            service.editProductSettings(this, payload.product_id, payload).then(response => {
                if(response.body.status == 200) {
                    this.products = response.body.data;
                }
                this.deactivate_processing();
            }).catch((err) => {
                if(err) {
                   this.data_processing_message = "Something went wrong";
                    this.deactivate_processing();
                }
            })
        },

        setAddToAddonProducts(product){
            //check if exist
            if(!(this.set_products_as_addons.includes(product.product_id))){ //is not in array
                this.set_products_as_addons.push(product.product_id); //add to addons
            }else{
                //remove
                const index = this.set_products_as_addons.indexOf(product.product_id);
                if (index > -1) { // only splice array when item is found
                    this.set_products_as_addons.splice(index, 1); // 2nd parameter means remove one item only
                }
            }
        },

        setProductsAddon(){
            for(let product of this.set_products_as_addons){
                var payload = {
                    business: this.sellpoint.business_id,
                    product_id: product,
                    product_is_addon: 1, //shows isset as a param for server check not neccsssarily the value itself
                }
                this.setProductSettings(payload);
            }
            this.set_products_as_addons = []; //re-ini
        },

        setAddToAvailableProducts(product){
            //check if exist
            if(!(this.set_products_as_available.includes(product.product_id))){ //is not in array
                this.set_products_as_available.push(product.product_id); //add to available
            }else{
                //remove
                const index = this.set_products_as_available.indexOf(product.product_id);
                if (index > -1) { // only splice array when item is found
                    this.set_products_as_available.splice(index, 1); // 2nd parameter means remove one item only
                }
            }
        },

        setProductsAvailability(){
            for(let product of this.set_products_as_available){
                var payload = {
                    business: this.sellpoint.business_id,
                    product_id: product,
                    product_is_available: 1, //shows isset as a param for server check not neccsssarily the value itself
                }
                this.setProductSettings(payload);
            }
            this.set_products_as_available = []; //re-ini
        },

        getGeneralGoods(){
            service.getGeneralGoods(this).then(response => {
                if(response.body.status == 200) {
                    this.general_goods = response.body.data;
                }
            }).catch((err) => {
                //console.log(err) //possibly a load payment error
            })
        },

        getGeneralGoodsCategoryProducts(){
            service.getGeneralGoodsCategoryProducts(this,this.general_goods_category.category_id).then(response => {
                this.general_goods_category_products = response.body.data;
            }).catch((err) => {
                //console.log(err) //possibly a load payment error
            })
        },

        //---./product-settings---------/

        //---order---settings-------/
        getOrderDetails(attr){
            var payload = {
                order_ref: attr.ref,
                order_module: attr.module,
                order_module_id: attr.module_id,
            }
            if(payload.order_ref != ''){
                service.getOrderDetails(this, payload).then(function(data) {
                    if(data.body.status == 200) {
                        //
                        this.order = data.body.data[0];
                        this.getOrderChart();
                        this.getOrderAdditionals();
                    }
                    this.action_loading = false;
                }).catch((err) => {})
            }
        },

        getOrderChart(){
            service.getMapOrderChart(this, this.order.order_id).then(response => {
                if(response.body.status == 200) {
                    this.order_chart = response.body.data_chart;
                }
            }).catch((err) => {
                //console.log(err) //possibly a load payment error
            })
        },

        checkOrderChart(param,value){
            let found = false;
            if(param == 'status'){
                for(let item of this.order_chart){
                    if(item.order_status_id == value){
                        found = true;
                    }
                }
            }
            return found;
        },

        getOrderAdditionals(){
            var payload = {
                data_order: this.order.order_id
            }
            service.getOrderAdditionals(this, payload).then(response => {
                if(response.body.status == 200) {
                    this.order_additionals = response.body.data;
                }
            }).catch((err) => {
                //console.log(err) //possibly a load payment error
            })
        },

        getAppBusinessOrders(){
            service.getAppBusinessOrders(this, this.sellpoint.business_id).then(response => {
                if(response.body.status == 200) {
                    this.sellpoint_orders = response.body.data;
                    this.sellpoint.orders = response.body.data;
                    //
                    this.setOrderedItems(this.sellpoint_orders);
                    // this.componentOrdersKey++;
                    // console.log(this.sellpoint.orders)
                }
                this.componentKey++;
                this.loading = false;
            }).catch((err) => {
                //console.log(err) //possibly a load payment error
            })
        },

        setOrderedItems(orders){
            //
            for(let order of orders){
                //loop through items
                for(let order_item of order.order_items){
                    //if(!(item_set.includes(item.product_item_id))){
                    let item = this.set_ordered_items.find(item => item.product_item_id === order_item.product_item_id);
                    if(!item){ //add
                        //some sets
                        order_item.set_order_quantity = Number(order_item.order_item_quantity);
                        //
                        this.set_ordered_items.push(order_item);
                        //
                        if((order.order_status_id == 2) && (order.order_is_today == 1)){console.log(822);
                            console.log(order)
                            //paid //today
                            this.total_sales_today += Number(order_item.order_item_total);
                        }
                    }else{ //exists
                        const index = this.set_ordered_items.findIndex(item => item.product_item_id === order_item.product_item_id);
                        if(index > 0){
                            this.set_ordered_items[index].set_order_quantity += Number(item.order_item_quantity);
                            //
                            if((order.order_status_id == 2) && (order.order_is_today == 1)){console.log(822);
                                console.log(order)
                                //paid //today
                                this.total_sales_today += Number(order_item.order_item_total);
                            }
                        }
                    }
                    
                    
                }
            }
        },

        getAppBusinessOrdersPendingPayments(){
            service.getAppBusinessOrdersPendingPayments(this, 3, this.sellpoint.business_id).then(response => {
                if(response.body.status == 200) {
                    this.sellpoint_pending_orders = response.body.data;
                }
                this.componentKey++;
                this.loading = false;
            }).catch((err) => {
                //console.log(err) //possibly a load payment error
            })
        },

        setPendingOrdersPayment(payment,order_index){
            this.set_order_pending_payment_data = "ord"+order_index;
            //settings
            let payment_orders_data = payment.data; //the actual payment orders
            let payment_amount_to_pay = payment.payment_data.payment_pending_amount_to_pay;
            let payment_ref =  payment.payment_data.payment_ref;
            let payment_details = payment.payment_data.payment_service;
            let payment_service_module = payment.payment_service_module;
            let payment_service_module_id = payment.payment_service_module_id;
            let payment_pending_amount_to_pay_by = payment.payment_data.payment_pending_amount_to_pay_by;
            //prepare orders data in payment
            
            //prep order settins
            let set_subaccounts = [];
            for(let order of payment.data){
                for(let pay_stl of payment.payment_data.pay_settlements){
                    //agents
                    if(payment_pending_amount_to_pay_by == 1){ //seller is paying //add agents's payment settlement
                        if(pay_stl.payment_stl_type == 22){
                            var sub_account_0 = {
                                id: order.business_agent_bank_ravepay_subaccount_id, // This assumes you have setup your commission on the dashboard.
                                transaction_charge: (pay_stl.payment_stl_amount),
                                transaction_charge_type: "flat_subaccount"
                            }
                            set_subaccounts.push(sub_account_0);
                        }
                    }
                    //commissions //ref commissions
                    if(pay_stl.payment_stl_type == 23){
                        var sub_account_01 = {
                            id: service.spcomms_subaccount_id, // This assumes you have setup your commission on the dashboard.
                            transaction_charge: (pay_stl.payment_stl_amount),
                            transaction_charge_type: "flat_subaccount"
                        }
                        set_subaccounts.push(sub_account_01);
                    }
                    //seller business
                    if(payment_pending_amount_to_pay_by == 2){ //agent is paying //add seller's payment settlement
                        if(pay_stl.payment_stl_type == 25){
                            var sub_account_02 = {
                                id: service.spcomms_subaccount_id, // This assumes you have setup your commission on the dashboard.
                                transaction_charge: (pay_stl.payment_stl_amount),
                                transaction_charge_type: "flat_subaccount"
                            }
                            set_subaccounts.push(sub_account_02);
                        }
                    }
                    //delivery company
                    if(pay_stl.payment_stl_type == 26){
                        var sub_account_03 = {
                            id: service.spcomms_subaccount_id, // This assumes you have setup your commission on the dashboard.
                            transaction_charge: (pay_stl.payment_stl_amount),
                            transaction_charge_type: "flat_subaccount"
                        }
                        set_subaccounts.push(sub_account_03);
                    }
                }
            }
            //..//prep order settings
            //...set sub accounts
            // this.show_empty_fields = false; //redo
            let payment_data = {};
            if((this.user.user_email == undefined) || (this.user.user_phone == undefined) || (this.user.user_email == "") || (this.user.user_phone == "")){
                this.show_empty_fields = true;
            }else{
                payment_data = {
                    payer_name: this.user.user_name,
                    payer_email: this.user.user_email,
                    payer_phone: this.user.user_phone,
                    payment_total_amount: payment_amount_to_pay,
                    payment_currency: "NGN", //default //can change from form
                    // pay_payment_ref: this.broker_request.broker_request_ref+Math.floor(Math.random() * 5),
                    payment_ref: payment_ref,
                    payment_details: payment_details,
                    payment_processing_fee_status:4, //buyer pays
                    payment_processing_fee: 0, //not set
                    payment_processing_fee_transaction_type:0, //not set
                    payment_transaction_type: 3, //pending order confirmation payment
                    // pay_transaction_module_id: 0,
                    payment_service_module: payment_service_module,
                    payment_service_module_id: payment_service_module_id,
                    payment_data_index: 0, //default
                    payment_data_route: "account", //account page
                    payment_service_business:0, //not set
                    payment_service_type:"single", //recheck
                    payment_service_payment_data:payment.payment_data, //payment_data
                    // payment_services:payment_orders_data, //actual service
                    payment_sub_accounts: set_subaccounts, 
                    payment_fees_account_balance:this.sellpoint.business_processing_fee_balance,
                    payment_meta: [],
                    payment_modes_accepted: [1,5], //1-Auto payments //5--Payment/ProcessingFee Payment
                }
                //add-on to payment data
                payment_data.payment_service_payment_data.payment_services = payment_orders_data;
                this.show_empty_fields = false;
            }
            this.set_pending_payment_data = payment_data;
        },

        setOrderCustomOrderDetailsUpdate(order){
            var payload = {
                order: order,
                order_status: "custom_set_track",
                order_set_track_status: 35, //pending payment update
                order_set_product_price: this.order.order_set_product_price || 0,
                order_set_shipping_cost: this.order.order_set_shipping_cost || 0,
                order_set_total_cost: this.order.order_set_total_cost || 0,
                order_set_delivery_info: this.order.order_set_delivery_info || '',
                order_set_bank_id: this.sellpoint.business_bank_details.bank_id || 0,
                order_set_bank_name: this.sellpoint.business_bank_details.bank_name || '',
                order_set_bank_account_name: this.sellpoint.business_bank_details.bank_account_name || '',
                order_set_bank_account_no: this.sellpoint.business_bank_details.bank_account_number || 0,
                //
                order_track_module: 8, //orders
                order_track_module_id: order.order_id,
                order_track_module_status: 35,
                order_track_action_by_module: 3, //business
                order_track_action_by_module_id: this.sellpoint.business_id,
                order_current_user: this.user.user_id || 0, //userid
            }
            //
            this.updateOrderSet(payload);
        },

        setOrderCustomConfirmPaymentUpdate(order){
            var payload = {
                order: order,
                order_status: "custom_set_track_confirm_payment",
                order_payment_seller_confirmation: 1,
                //
                order_track_module: 8, //orders
                order_track_module_id: order.order_id,
                order_track_module_status: 2, //paid
                order_track_action_by_module: 3, //business
                order_track_action_by_module_id: this.sellpoint.business_id,
                order_current_user: this.user.user_id || 0, //userid
            }
            //
            this.updateOrderSet(payload);
        },

        setOrderCustomUpdates(order,status,action_by_module){
            var payload = {
                order: order,
                order_status: status,
                //
                order_track_module: 8, //orders
                order_track_module_id: order.order_id,
                order_track_module_status: 0, 
                order_track_action_by_module: 0, 
                order_track_action_by_module_id: 0,
                order_current_user: this.user.user_id || 0, //userid
            }
            //
            if(action_by_module == 1){
                payload.order_track_action_by_module = 1; //user
                payload.order_track_action_by_module_id = this.user.user_id;
            }else if(action_by_module == 3){
                payload.order_track_action_by_module = 3; //business
                payload.order_track_action_by_module_id = this.sellpoint.business_id;
            }
            //
            if(status=="delivered"){
                payload.order_track_module_status = 18; //delivered
            }
            // if(status=="received"){
            //     payload.order_track_module_status = 21; //received
            // }
            if(status=="closed"){
                payload.order_track_module_status = 33; //delivered
            }
            if(status == "custom_set_track_make_payment"){
                payload.order_track_module_status = 20; //pending payment confirmation
            }
            if(status == "custom_set_track_confirm_payment"){
                payload.order_payment_seller_confirmation = 1;
                payload.order_track_module_status = 2; //payment confirmed
            }
            //
            if((payload.order_track_action_by_module > 0) && (payload.order_track_module_status > 0)){
                this.updateOrderSet(payload);
            }
        },

        updateOrderPaymentXX(order) {
            var payload = {
                 payment_orders: order,
                 payment_update_type:"manualUpdateConfirmation",
                 payment_service_mode:4,//manualUpdateConfirmation
                 //extrcts
                 payment_service_user_id:0,
                 
             }
             let navi = this.$router;
             service.updatePayment(this, payload).then(data => {
                 if(data.body.status == 200) {
                     //return order id if one and navigate with it to orders
                     this.data_processing_message = "Order Confirmed"
                     this.order = data.body.data;
                 }else {
                    this.data_processing_message = "Sorry, could not update payment";
                 }
             }).catch((err) => {
                 if(err) {
                    // console.log(err)
                    this.data_processing_message = "Sorry, could not process information";
                 }
             })
             
        },

        updatePendingOrdersPayment(payment){
            let payment_service_payment_data = payment.payment_data;
            payment_service_payment_data.payment_details = payment.payment_data.payment_service; //recheck
            payment_service_payment_data.payment_services = payment.data;

            var payload = {
                payment_update_type:"manualUpdateConfirmation",
                payment_service_mode:4,//manualUpdateConfirmation
                payment_received_from: payment.payment_data.payment_set_to_receive_from,//1-agent//2-buyer
                payment_service_payment_data:payment_service_payment_data,
                payment_service_type:"multiple", //recheck
                //extrcts
                payment_service_user_id:0,
                 
            }
             let navi = this.$router;
             service.updatePayment(this, payload).then(data => {
                 if(data.body.data_pending_pay_status == 200) {
                     //return order id if one and navigate with it to orders
                     this.data_processing_message = "Payments Confirmed"
                     this.sellpoint_pending_orders = data.body.data_pending_pay_data.data;
                     this.getAppBusinessTransactions(); //recall
                 }else {
                    this.data_processing_message = "Sorry, could not update payment";
                 }
             }).catch((err) => {
                 if(err) {
                    // console.log(err)
                    this.data_processing_message = "Sorry, could not process information";
                 }
             })
             
        },

        updateOrders(order,status) {
            var payload = {
                order: order,
                order_status:status,
            }
            let navi = this.$router;
            service.updateOrders(this, payload).then(data => {
                if(data.body.status == 200) {
                    //return order id if one and navigate with it to orders
                    this.data_processing_message = "Order Updated";
                    // console.log("0here");
                    // console.log(data.body.data);
                    this.order = data.body.data;
                }else {
                    this.data_processing_message = "Sorry, could not update payment";
                }
            }).catch((err) => {
                if(err) {
                    // console.log(err)
                    this.data_processing_message = "Sorry, could not process information";
                }
            })
        },

        updateOrderSet(payload) {
            this.activate_processing();
            let navi = this.$router;
            service.updateOrders(this, payload).then(data => {
                if(data.body.status == 200) {
                    //return order id if one and navigate with it to orders
                    this.data_processing_message = "Order Updated";
                    this.order = data.body.data;
                    //
                    this.getOrderChart();
                }else {
                    this.data_processing_message = "Sorry, could not update payment";
                }
                this.deactivate_processing();
            }).catch((err) => {
                if(err) {
                    // console.log(err)
                    this.data_processing_message = "Sorry, could not process information";
                }
            })
        },

        uploadFlexiPaymentReceipt(data,data_ref,status){
            if(status == 'transferred') {
                //add image
                this.imageForm.append("data_id", data_ref);
                this.imageForm.append("data_type","third_party_payment_receipt");
                service.uploadDataPhoto(this, this.imageForm).then(data => {
                    if(data.body.status == 200){
                        this.flexi_active_payment_status = 1; //done
                        //this.deactivate_processing();
                        this.getOrderChart();
                        this.resetImageUpload();
                    }else{
                        this.data_processing_message = service.upload_media_error_msg;
                    }
                });
            }
        },

        //for uploads
        onFileChangeNewPhoto(e,data_type) {
            let files = e.target.files || e.dataTransfer.files;
            if (files.length)
            {   
                this.file_info = files;
                let formData = new FormData();
                formData.append('photo', files[0]); 
                this.imageForm = formData;
                this.file_data_type = data_type;
            }  
            //set preview image
            document.getElementById('prImagePreview').src = window.URL.createObjectURL(files[0])
        },

        resetImageUpload(){
            this.file_info = []; document.getElementById('prImagePreview').src ='';
        },
        //-../----orders

        setAddDeliveryOptions(option){
            let store_locations = [];
            let set_item = {
                state: option.state,
                city:  option.city || 0,
                delivery_option_price: option.delivery_option_price || 0,
            }
            
            //check if added before
            if(Object.keys(this.business_delivery_locations).length == 0){
                store_locations.push(set_item);
                this.business_delivery_locations = store_locations;
              // this.business_delivery_locations.push(option);
            }else{
                let locations = this.business_delivery_locations;
                let store_locations = [];
                //
                //prep data
                for(let location of locations){console.log(262);console.log(location.state)
                    let set_location = {
                        state: location.state,
                        city: location.city || 0,
                        delivery_option_price: location.delivery_option_price || 0,
                    }
                    store_locations.push(set_location);
                    //new add
                    if(option.state != location.state){
                        store_locations.push(set_item);
                    }else{//same state
                        if(option.city != location.city){
                           store_locations.push(set_item);
                        }
                    }
                    
                }
                //re-assign
                this.business_delivery_locations = store_locations;
                //
                this.componentDeliveryKey++;
            }
        },

        setAddProductAsAddon(product){
            this.activate_processing();
            //
            //set product
            var credentials = {
                product_name: product.product_name,
                product_is_product_or_service: this.is_product_service || 'P',
                product_category_is_set: this.category.business_category_id || 0,
                product_business: this.sellpoint.business_id || 0,
                product_description: product.product_description || "nill",
                product_item_price: product.product_item_price || product.product_price,
                product_item_weight: product.product_item_weight || 1,
                product_item_quantity: product.product_item_quantity || 100,
                product_is_subscribed_to: product.product_is_subscribed_to || 0,
                product_service_offers: this.service_offers,
            }
            
            let navi = this.$router;
            let can_submit = true;
            if(can_submit && ((credentials.product_name != undefined) && (credentials.product_item_price > 0))) {
                service.addProduct(this, credentials).then(function(data) {
                    if(data.body.status == 201) {
                        product = data.body.data;
                        this.data_success_message = "Processing, please wait ...";
                        //--add images
                        this.setAddProductMedia(product);
                        //add product as addon
                        this.setAddToProductAddons(product);
                        this.addToProductAddons();
                        //
                        let self = this;
                        setTimeout(function(){
                            self.deactivate_processing();
                            //location.reload(true);
                        },1800)
                    }
                })
            }
        },

        setAddProductOrderOptions(detail){ 
            //set id for aid splice
            detail.set_id = (this.product_set_details.length + 1);
            //
            detail.type = 69; //product_order_options
            detail.title = "";
            detail.detail = "Contains - "+detail.set_name;
            this.product_set_details.push(detail);
            
            // let item = this.product_set_details.find(item => item.set_id === detail.set_id);
            // if(!item){ //add
            //     this.product_set_details.push(detail);
            // }else{
            //     console.log(this.product_set_details);
            // }
            //
            this.set_detail = {};
        },

        removeProductOrderOptions(detail){
            //remove
            const index = this.product_set_details.findIndex(p => detail.set_id === p.set_id)
            this.product_set_details.splice(index, 1);
        },

        setAddOrderProductItemsOptions(option){ 
            //set id for aid splice
            option.id = (this.product_set_items.length + 1);
            //
            this.product_set_items.push(option);
            //
            this.product_item = {}; //refresh
        },

        removeOrderProductItemsOptions(option){
            //remove
            const index = this.product_set_items.findIndex(p => option.set_id === p.set_id)
            this.product_set_items.splice(index, 1);
        },

        createOrder(){
            this.activate_processing();
            //setts
            let order_addons = [];
            //--user details
            let order_business_user_details = {
                user_id: this.user.user_id || 0,
                user_name: this.user.user_name || '',
                user_email: this.user.user_email || '',
                user_phone: this.user.user_phone || '',
            }

            //--business details
            let order_business_details = {
                business_id: this.sellpoint.business_id || 0,
                business_name: this.sellpoint.business_name || '',
                business_phone: this.sellpoint.business_phone || '',
                business_email: this.sellpoint.business_email || '',
                business_market_category: this.sellpoint.business_market_category || 0,
                business_category_id: this.sellpoint.business_category_id || 1,
            }

            //--item details
            let order_item = {
                product_name: this.product.product_name || '',
                product_category: this.product.product_category || 0,
                product_price: this.product.product_price || 0,
                product_description: this.product.product_description || '',

                //product_images
                //product_addons")
                //product_items")
            }
            
            //--other-settings
            if(this.product.set_product_addons && (Object.keys(this.product.set_product_addons).length > 0)){
                order_addons = this.product.set_product_addons; //save here
                console.log(1644);console.log(order_addons);
            }
            
            var payload = {
                order_business_user_details: order_business_user_details,
                order_business_details: order_business_details,
                order_item: order_item
            }

            //
            service.createOrder(this, payload).then(data => {
                if(data.body.status == 201) {
                    this.data_processing_message = "Order Created";
                    //
                    let data_set = data.body.data[0];
                    //---set product
                    this.product = data_set.data_product_details;
                    //re-sets
                    this.product.set_product_addons = order_addons;
                    console.log(this.product.set_product_addons)
                    //---set user
                    this.user = data_set.data_user_details;
                    localforage.setItem(service.udb_name, this.user).then(function (value) {}).catch(function(err) {
                        console.log(err)
                    });
                    //this.$store.dispatch('account/setUserData',this.user.user_id);

                    //---set business
                    this.sellpoint = data_set.data_business_details;
                    localforage.setItem(service.bdb_name, this.sellpoint).then(function (value) {
                        //console.log(89005)
                    }).catch(function(err) {
                        console.log(err)
                    });
                    //this.$store.dispatch('account/setBusiness',this.sellpoint);

                    //--add images
                    this.setAddProductMedia(this.product);
                    //--add addons
                    //this.addToProductAddons();

                    // other settings
                    //---product-items
                    if((Object.keys(this.sellpoint).length > 0) && (this.product_set_items).length > 0){
                        //
                        for(let item of this.product_set_items){
                            //sett
                            this.product_details.addProductItemToGroup = true;
                            this.product.product_item_price = item.amount;
                            this.product.product_item_service_tag = item.name;
                            //
                            this.addProductItem();
                        }
                    }
                    //---./product-items

                    //---if has product_set_details
                    if((Object.keys(this.sellpoint).length > 0) && (this.product_set_details).length > 0){
                        //
                        this.addProductDetails(this.product);
                    }
                    //---./if has product_set_details
                    
                    //take some time before redirect
                    if((Object.keys(this.product).length > 0) && (this.product.product_ref != '')){
                        let self = this;
                        setTimeout(function(){
                            self.$router.push('/set/order/'+this.product.product_ref)
                        },1800)
                    }
                }
            }).catch((err) => {})
            
        },

        setOrderQuantity(type,data_set,action,product_index,product_item,product_item_index){
            if(type == 0){ //main product item
                if(action == 'add'){
                    this.product_item.product_item_order_quantity++;
                }else if(action == 'sub'){
                    this.product_item.product_item_order_quantity--;
                }
                product_item = this.product_item;
            }else if(type == 1){ //items
                //set quantity
                if(action == 'add'){
                    if(data_set == 1){//update for product
                        this.products[product_index].product_items[product_item_index].product_item_order_quantity++;
                    }else if(data_set == 2){
                        this.set_order_list[product_item_index].product_item_order_quantity++;
                    }else if(data_set == 3){
                        this.set_order_addons[product_index].product_items[product_item_index].product_item_order_quantity++;
                    }
                }else if(action == 'sub'){
                    if(data_set == 1){//update for product
                        this.products[product_index].product_items[product_item_index].product_item_order_quantity--;
                    }else if(data_set == 2){
                        this.set_order_list[product_item_index].product_item_order_quantity--;
                    }else if(data_set == 3){
                        this.set_order_addons[product_index].product_items[product_item_index].product_item_order_quantity--;
                    }
                }
                //check if already in order items
                let item = this.set_order_data.order_items.find(item => item.product_item_id === product_item.product_item_id);
                if(!item){ //add
                    if(data_set == 1){//update for product
                        this.setAddOrderItems(data_set,this.products[product_index].product_items[product_item_index],product_index,product_item_index);
                    }else if(data_set == 2){
                        this.setAddOrderItems(data_set,this.set_order_list[product_item_index],product_index,product_item_index);
                    }else if(data_set == 3){
                        this.setAddOrderItems(data_set,this.set_order_addons[product_index].product_items[product_item_index],product_index,product_item_index);
                    }
                }
                //..//check
                //
                if(data_set == 1){//update for product
                    product_item =this.products[product_index].product_items[product_item_index];
                }else if(data_set == 2){
                    product_item = this.set_order_list[product_item_index];
                }else if(data_set == 3){
                    product_item =this.set_order_addons[product_index].product_items[product_item_index];
                }
            }
            //
            if(product_item.product_item_order_quantity <= 0){
                product_item.product_item_order_quantity = 1; //reset
            }
            //
            if(product_item.product_item_order_quantity > 0){
                this.setOrderCost();
            }

            //this.componentKey++;
        },

        setOrderDeliveryLocation(location){
            if(this.set_order_data.order_delivery_option && Object.keys(this.set_order_data.order_delivery_option).length > 0){
                let option = this.set_order_data.order_delivery_option;
                this.set_order_data.order_total_amount -= Number(option.business_delivery_option_price);
                this.set_order_data.order_delivery_option = {}; //reset
                this.set_order_data.order_delivery_option = location;
                if(location.business_delivery_option_price && (location.business_delivery_option_price > 0)){
                    this.set_order_data.order_total_amount += Number(location.business_delivery_option_price);
                }
            }else{
                this.set_order_data.order_delivery_option = location;
                if(location.business_delivery_option_price && (location.business_delivery_option_price > 0)){
                    this.set_order_data.order_total_amount += Number(location.business_delivery_option_price);
                }
            }
            //
            this.set_order_total_amount = this.set_order_data.order_total_amount;
        },

        checkOrderProductAddons(add_product){
            //check if exists
            let in_arr = false;
            if(Object.keys(this.set_order_product_addons).length > 0){
                let product = this.set_order_product_addons.find(product => product.product_id === add_product.product_id);
                if(product){
                    in_arr = true;
                }
            }
            return in_arr;
        },

        checkOrderItems(item){
            //check if exists
            let in_arr = false;
            if(this.set_order_data.order_items && (Object.keys(this.set_order_data.order_items).length > 0)){
                let product_item = this.set_order_data.order_items.find(product_item => product_item.product_item_id === item.product_item_id);
                if(product_item){
                    in_arr = true;
                }
            }
            return in_arr;
        },

        checkProductOrderItems(product){console.log(345);console.log(undefined)
            let count= 0;
            for(let set_item of product.product_items){
                //remove item if exists
                var product_item = this.set_order_data.order_items.find(product_item => product_item.product_item_id === set_item.product_item_id);
                if(product_item){
                    count++;
                }
            }
            if(count > 0){
                return true;
            }else{
                return false;
            }
        },

        setOrderProductAddons(add_product){
            if(Object.keys(this.set_order_product_addons).length == 0){
                this.set_order_product_addons.push(add_product);
                this.set_order_data.order_total_amount += Number(add_product.product_items[0].product_item_price);
                console.log(this.set_order_product_addons);
                console.log(this.set_order_data.order_total_amount)
            }else{
                //check if exists
                let product = this.set_order_product_addons.find(product => product.product_id === add_product.product_id);
                if(!product){
                    this.set_order_product_addons.push(add_product); //add to addons
                    this.set_order_data.order_total_amount += Number(add_product.product_items[0].product_item_price);
                }else{
                    //remove
                    const index = this.set_order_product_addons.findIndex(p => product.product_id === p.product_id)
                    this.set_order_product_addons.splice(index, 1);
                    this.set_order_data.order_total_amount -= Number(product.product_items[0].product_item_price);
                }
            }
            this.set_order_total_amount = this.set_order_data.order_total_amount;
        },

        setOrderProductItem(data_set,new_product_item,product_index,product_item_index){
            /* ---- for picking only one item in a product
            //loop through product and remove all matching items
            // for(let set_item of this.products[product_index].product_items){
            //     //remove item if exists
            //     var product_item = this.set_order_data.order_items.find(product_item => product_item.product_item_id === set_item.product_item_id);
            //     if(product_item){
            //         const index = this.set_order_data.order_items.findIndex(p => product_item.product_item_id === p.product_item_id)
            //         this.set_order_data.order_items.splice(index, 1);
            //         this.set_order_data.order_total_amount -= (Number(product_item.product_item_price) * product_item.product_item_order_quantity);
            //         this.products[product_index].product_items[index].product_item_order_quantity = 1; //reset //1-default
            //     }
            // }
            -----one item per product-----*/
            //
            this.set_order_list = this.set_order_data.order_items;
            //add this new one
            this.setAddOrderItems(data_set,new_product_item,product_index,product_item_index);
            //
            this.componentKey++;
        },

        setRemoveOrderProductItems(product_index){
            //loop through product and remove all matching items
            for(let set_item of this.products[product_index].product_items){
                //remove item if exists
                var product_item = this.set_order_data.order_items.find(product_item => product_item.product_item_id === set_item.product_item_id);
                if(product_item){
                    const index = this.set_order_data.order_items.findIndex(p => product_item.product_item_id === p.product_item_id)
                    this.set_order_data.order_items.splice(index, 1);
                    this.set_order_data.order_total_amount -= (Number(product_item.product_item_price) * product_item.product_item_order_quantity);
                    this.products[product_index].product_items[index].product_item_order_quantity = 1; //reset //1-default
                }
            }
            //
            this.set_order_list = this.set_order_data.order_items;
        },

        setAddOrderItems(data_set,item,product_index,product_item_index){
            this.product_item = item; //recheck...//helps for independent order qty reset/set
            //check if exists
            var product_item = {};
            if(this.set_order_data.order_items && (Object.keys(this.set_order_data.order_items).length > 0)){
                product_item = this.set_order_data.order_items.find(product_item => product_item.product_item_id === item.product_item_id);
                
                //
                if((product_item == undefined)){
                    //setts
                    item.product_index = product_index;
                    //./setts
                    this.set_order_data.order_items.push(item); //add to items
                    this.set_order_data.order_total_amount += (Number(item.product_item_price) * item.product_item_order_quantity);
                }else{
                    //remove
                    const index = this.set_order_data.order_items.findIndex(p => product_item.product_item_id === p.product_item_id)
                    this.set_order_data.order_items.splice(index, 1);
                    this.set_order_data.order_total_amount -= (Number(product_item.product_item_price) * product_item.product_item_order_quantity);
                    
                    //
                    if(data_set == 1){//update for product
                        this.products[product_index].product_items[product_item_index].product_item_order_quantity = 1; //reset //1-default
                    }else if(data_set == 2){
                        this.set_order_list[product_item_index].product_item_order_quantity = 1; //reset //1-default
                    }else if(data_set == 3){
                        this.set_order_addons[product_index].product_items[product_item_index].product_item_order_quantity = 1; //reset //1-default
                    }
                    
                }
            }else{
                //no items yet
                this.set_order_data.order_items.push(item); //add to items
                this.set_order_data.order_total_amount = (Number(item.product_item_price) * item.product_item_order_quantity);
            }
            
            //
            this.set_order_total_amount = this.set_order_data.order_total_amount;
            this.set_order_list = this.set_order_data.order_items;
        },

        setItemProductOrderOptions(option,option_index,item,item_index){
            //get state
            let option_status = this.set_order_list[item_index].product_order_options[option_index].set_status;
            if(option_status == 1){
                this.set_order_list[item_index].product_order_options[option_index].set_status = 0;
                //
                this.set_order_list[item_index].product_order_options[option_index].set_details = "Don't add "+option.product_info_set_name;
            }else if(option_status == 0){
                this.set_order_list[item_index].product_order_options[option_index].set_status = 1;
                this.set_order_list[item_index].product_order_options[option_index].set_details = "";
            }
            this.componentKey++;
        },

        processMakeOrderXX(){
            //set order items
            let order_items = [];
            this.product_item.product_name = this.product.product_name;
            this.product_item.product_item_order_quantity = 1; //default
            order_items.push(this.product_item);
            //
            for(let product_index in this.product.product_addons){
                //let product = this.product.product_addons[product_index];
                //let product_item = product.product_items[0];
                //product_item.product_name = product.product_name;
                this.product.product_addons[product_index].product_items[0].product_item_order_quantity = 1; //default
                //order_items.push(product_item);
            }
            //
            this.set_order_data.order_items = order_items;

        },

        setOrderCost(){
            let order_total_amount = 0;

            //calc order item cost
            for(let product_index in this.set_order_data.order_items){
                let item = this.set_order_data.order_items[product_index];
                //
                var item_order_cost = (Number(item.product_item_price) * item.product_item_order_quantity);
                order_total_amount += item_order_cost;
            }

            //calc delivery cost
            if(this.set_order_data.order_delivery_option && (Object.keys(this.set_order_data.order_delivery_option).length > 0)){
                let location = this.set_order_data.order_delivery_option;
                if(location.business_delivery_option_price && (location.business_delivery_option_price > 0)){
                    order_total_amount += Number(location.business_delivery_option_price);
                }
            }
            //
            this.set_order_data.order_total_amount = order_total_amount;
            this.set_order_total_amount = this.set_order_data.order_total_amount;
        },

        setMakeOrder(mode){
            this.data_processing_messages = {}; //reset
            let process_order = false;
            if(mode > 0){
                if(this.user.user_id && (this.user.user_id > 0)){
                    process_order = true;
                }else{
                    this.set_order_data.order_user_details = {};
                    var payload = {
                        data_user_name: this.user.user_name || '',
                        data_user_email: this.user.user_email || '',
                        data_user_phone: this.user.user_phone || '',
                        data_user_password: (this.user.user_name+this.user.user_email+this.user.user_phone),
                    }
                    this.set_order_data.order_user_details = payload;
                    process_order = true;

                    if(payload.data_user_name == ''){
                        this.data_processing_messages.mode_err = "Name is empty, please provide.";
                        process_order = false;
                    }
                    if((payload.data_user_email == '') && (payload.data_user_phone == '')){
                        this.data_processing_messages.mode_err = "Please provide email address or phone number.";
                        process_order = false;
                    }
                    if(mode == 1){
                        if(payload.data_user_email == ''){
                            this.data_processing_messages.mode_err = "Please provide email address for payment processing";
                            process_order = false;
                        }
                    }
                }
                //check mode
                if(mode == 1){
                    if(this.user.user_email == ''){
                        this.data_processing_messages.mode_err = "Please provide email address for payment processing";
                        process_order = false;
                    }
                }
                //
                if(process_order){
                    this.makeOrder(mode);
                }
            }else{
                this.data_processing_messages.mode_err = "Please select how you would like to pay";
            }
        },

        makeOrder(mode){
            let set_order_mode = 1; //use 1 to siml user is loggedIn, so as to user order-user_id feature
            // let order_items = [];
            // //
            // this.set_order_data.order_total_amount = 0;
            // this.set_order_data.order_total_amount += Number(this.product_item.product_item_price);
            // this.set_order_data.order_details = ""
            // order_items.push(this.product_item);
            // //
            // for(let product in this.set_order_product_addons){
            //     this.set_order_data.order_total_amount += Number(product.product_items[0].product_item_price);
            //     order_items.push(product.product_items[0]);
            // }
            // //
            // this.set_order_data.order_items = order_items;
            
            //
           
            //
            //this.set_order_data.order_items = order_items;
            //
            this.set_order_data.order_details = "";
            let set_order_user_details = this.set_order_data.order_user_details;
            let order_items = this.set_order_data.order_items;
            let set_order_delivery_option = 0;//ini
            if(this.set_order_data.order_delivery_option && (this.set_order_data.business_delivery_option_id > 0)){
                set_order_delivery_option = this.set_order_data.order_delivery_option.business_delivery_option_id;
            }
            //
            var payload = {
                order_business: this.sellpoint.business_id,
                order_mode: set_order_mode,
                order_user_id: this.user.user_id,
                order_items: order_items,
                order_delivery_option: set_order_delivery_option || 0,
                order_details: "",
                order_user_details: set_order_user_details,
                //order_on_notify:0,
            }
            //set order items
            service.makeCustomOrder(this, payload).then(response => {
                if(response.body.status == 201) {
                    let data_id = response.body.data_id;
                    let order_data = response.body.data_order_data;
                    let order = order_data.data[0];
                    this.order = order;
                    //set user
                    if(response.body.data_user_details && (Object.keys(response.body.data_user_details).length > 0)){
                        this.user = response.body.data_user_details;
                        localforage.setItem(service.udb_name, this.user).then(function (value) {
                        }).catch(function(err) {
                            console.log(err)
                        });
                    }
                    //move to placed orders
                    this.$router.push('/placed/order/'+this.order.order_no)
                    //../move to place orders

                    // if(mode == 1){
                    //     let payment_data = {
                    //         payment_amount: order_data.data_total_amount,//this.set_order_data.order_total_amount,
                    //         payment_ref: order.order_no,
                    //         payment_payer_name: this.user.user_name,
                    //         payment_payer_email: this.user.user_email,
                    //         payment_payer_phone: this.user.user_phone || '',
                    //     } 
                    //     this.makeOrderPayment(data_id,mode);
                    //     //this.processPaymentRavepay(payment_data,order,mode)
                    // }else if(mode == 4){
                    //     this.makeOrderPayment(data_id,mode);
                    // }
                }
            }).catch((err) => {})
        },

        makeOrderPayment(order_id,mode){
            let payer_id = this.user.user_id;
            //
            var payload = {
                payment_user: payer_id,
                payment_business: this.sellpoint.business_id,
                payment_by_module: 1,
                payment_by_module_id: payer_id, 
                payment_to_module: 3,//business
                payment_to_module_id: this.sellpoint.business_id,
                payment_amount: this.set_order_data.order_total_amount,
                payment_mode: mode, //
                payment_type: 0, //0
                payment_details: this.set_order_data.order_details,
                payment_service_type:  0, //
                payment_service_module: 8, //order
                payment_service_module_id: order_id
            }
            
            //
            if(payload.payment_amount > 0){
                service.makeDirectPayment(this, payload).then(response => {
                    //this.setBackToPage();
                    if(response.body.status == 201) {
                        //make actual payment
                        //this.makeSaleOrderPayment(response.body.data);
                        //
                        this.setMenuTabInnerView('showOrderPaymentConfirmation');
                    }else{}
                }).catch((err) => {
                    //this.setBackToPage();
                })
            }
        },

        processPaymentRavepay(data,order,mode) {console.log(data)
            let self = this;
            //some setts
            let set_subaccounts = [];

            var x = getpaidSetup({
                PBFPubKey: service.ravepay_public_test, //test //devlot
                // PBFPubKey: service.ravepay_public_live_paga, //api public key
                customer_email: "keneinfostream@gmail.com",//self.payment_payer_email, // "mail@gmail.com"
                amount: 3000,//main--data.payment_amount, //order.total_amount,//(Math.round(order.total_amount))//self.total_fee,
                customer_phone: data.payment_payer_phone, //"234099940409"
                currency: "NGN",
                payment_method: "both",
                txref:data.payment_ref,
                subaccounts: set_subaccounts,
                meta: [{
                    metaname: "AFPAY",
                    metavalue: data.payment_payer_name,
                }],
                onclose: function() {
                   
                },
                callback: function(response) {
                    var txref = response.tx.txRef; // collect flwRef returned and pass to a server page to complete status check.
                    var tx_amount = response.tx.amount;
                    if (
                        response.tx.chargeResponseCode == "00" ||
                        response.tx.chargeResponseCode == "0"
                    ) {
                        //
                        //---update payment
                        self.makeOrderPayment(order.order_id,mode);
                        //server validation
                        // let payload =
                        // {
                        //    "SECKEY": service.ravepay_secret_live_paga, //use API secret key
                        //     "txref": txref
                        // };
                        // service.verifyRavePayment(self, payload).then(response => {
                            
                        // }).catch((err) => {
                            
                        // })
                    } else {
                        self.payment_message = "Payment unsuccessfull. please try again or contact us"
                    }
                }
            });
        },

        getOrders(payload){
            if(payload.user_id && (payload.user_id > 0)){
                payload = payload.user_id;
            }
            service.getOrders(this, payload).then(response => {
                if(response.body.status == 200) {
                    this.orders = response.body.data;
                    this.loading = false;
                }
            }).catch((err) => {
                //console.log(err) //possibly a load payment error
            })
        },
        //-----./order---settings-------/

        //---transactions---settings----/
        getAppBusinessTransactions(){
            service.getAppBusinessTransactions(this, this.sellpoint.business_id).then(response => {
                if(response.body.status == 200) {
                    this.sellpoint_transactions.transactions = response.body.data;
                    this.sellpoint_transactions.transactions_total = response.body.data_total;
                    this.sellpoint_transactions.transactions_total_amount = response.body.data_total_amount;
                    this.sellpoint_transactions.transactions_total_today = response.body.data_total_today;
                    this.sellpoint_transactions.transactions_total_today_amount = response.body.data_total_today_amount;
                }
                this.componentKey++;
                this.loading = false;
            }).catch((err) => { })
        },
        //---transactions---settings---/

        //---customers---settings----/
        getAppBusinessCustomers(){
            service.getAppBusinessCustomers(this, this.sellpoint.business_id).then(response => {
                if(response.body.status == 200) {
                    this.customers = response.body.data;
                }
            }).catch((err) => { })
        },
        //---customers---settings---/
        
        //----user--market---circle--settings---/
        getAppMarketCircle(){
            service.getAppMarketCircle(this, this.user.user_id).then(response => {
                if(response.body.status == 200) {
                    this.market_circle = response.body.data;
                }
            }).catch((err) => { })
        },
        //----user--market---circle--settings---/

        //----user--comm---/
        //getAppTribe
        getAppGroup(ref){
            //set activity
            this.activity.activity_module_action_type = 9; //get user group
            //--set activity payload
            let data_payload = {
                data_group_ref: ref, 
                data_user_id: this.user.user_id
            }
            this.activity.activity_module_data = data_payload;

            //call activity
            this.getActivity();
            //get data
            let self = this;
            setTimeout(function(){
                localforage.getItem("activity_data_store", function(err, value) { //quick with the callback version
                    if(value != undefined) {
                        self.group = value;
                        self.componentKey++;
                        self.loading = false;
                    }else{}
                });
            },1000)
        
        },

        getAppGroups(){
            //set activity
            this.activity.activity_module_action_type = 8; //get user groups
            //--set activity payload
            let data_payload = {
                data_id: this.user.user_id, 
            }
            this.activity.activity_module_data = data_payload;

            //call activity
            this.getActivity();
            //get data
            let self = this;
            setTimeout(function(){
                localforage.getItem("activity_data_store", function(err, value) { //quick with the callback version
                    if(value != undefined) {
                        self.groups = value;
                        self.componentKey++;
                        self.loading = false;
                    }else{}
                });
            },2000)
        
        },

        setTribe(){
            if(Object.keys(this.groups).length == 1){
                this.group = this.groups[0];
                this.view_group_members = true;
            }
        },

        //search and more
        searchMember(){
            //set activity
            this.activity.activity_module_action_type = 10; //get user group
            //--set activity payload
            let data_payload = {
                data_username: this.search_member.username, 
            }
            this.activity.activity_module_data = data_payload;

            //call activity
            this.getActivity();
            //get data
            let self = this;
            setTimeout(function(){
                localforage.getItem("activity_data_store", function(err, value) { //quick with the callback version
                    if(value != undefined) {
                        self.display_members = value;
                        self.setMenuComponent('showDisplayMembers');
                        self.loading = false;
                    }else{}
                });
            },2000)
        },
        //../search and more
        
        setAddMemberToGroup(member){
            this.group_member.group = this.group.group_id,
            this.group_member.member_type = member.data_type,
            this.group_member.member_module = member.data_module,
            this.group_member.member_id = member.data_id,
            //
            this.addMembersToGroup();
        },
        //----user--com--/

        //----subscribers---/
        getAppSubscribers(){
            var payload = {
                sub_type: 1,
                subscribe_to_module: 3,//business
                subscribe_to_module_id: this.sellpoint.business_id,
            }
            service.getAppSubscriptions(this, payload).then(response => {
                if(response.body.status == 200) {
                    this.subscribers = response.body.data;
                    if(this.subscribers.length > 0){
                        this.set_sub_view = "subscribers";
                    }
                }
            }).catch((err) => { })
        },
        //----subscribers---/

        //----subscriptions---/
        getAppSubscriptions(){
            var payload = {
                sub_type: 2,
                subscriber_module: 1, //users
                subscriber_module_id: this.user.user_id,
            }
            service.getAppSubscriptions(this, payload).then(response => {
                if(response.body.status == 200) {
                    this.subscriptions = response.body.data;
                }
            }).catch((err) => { })
        },

        updateSubscription(sub_account,sub){
            this.activate_processing();
            //set in local storage
            localStorage.setItem("product_sub",sub.subscription_ref);
            this.$router.push(sub_account.subscribe_to_username);
        },
        //----subscriptions---/

        //--business-app-subscription
        getAppBusinessSubscription(){
            var payload = {
                sub_type: 2, //subscribed to
                subscriber_module: 3,//business
                subscriber_module_id: this.sellpoint.business_id,
            }
            service.getAppSubscriptions(this, payload).then(response => {
                if(response.body.status == 200) {
                    this.business_app_subscription = response.body.data[0];
                   //get the subscription service offering
                    this.getAppBusinessSubscriptionOffers();
                }
            }).catch((err) => { })
        },

        getAppBusinessSubscriptionOffers(){
            //get the subscribed product_item_id of the current subscription
            let item_id = 0; let app_id = 0;
            // if(Object.keys(this.business_app_subscription).length > 0){
                app_id = this.business_app_subscription.subscription_module_id;
                item_id = this.business_app_subscription.subscription_active_subscription.subscription_product_service;
                if(item_id && (item_id > 0)){
                    var payload = {
                        subscriber_module: 3,//business
                        subscriber_module_id: this.sellpoint.business_id,
                        subscribed_to_business: app_id,
                        subscribed_to_product_service: item_id,
                        subscribed_to_service_offers: [5,6], //nos-products,posts
                    }
                    service.getAppSubscriptionOffers(this, payload).then(response => {
                        if(response.body.status == 200) {
                            //dispatch
                            let rdata = response.body.data;
                            this.$store.dispatch('account/setSellpointAppSubscriptionOffers',rdata);
                            let self = this;
                            // setTimeout(function(){
                            //     self.business_app_subscription_offers = response.body.data;
                            // }, 5000);
                            //set
                            this.business_app_subscription_offers = response.body.data;
                            // for(let offer of this.business_app_subscription_offers){
                            //     if(offer.service_offer == 5){
                            //         this.subscription_offer.products = offer;
                            //     }
                            //     if(offer.service_offer == 6){
                            //         this.subscription_offer.posts = offer;
                            //     }
                            // }
                        }else{}
                    }).catch((err) => { })
                }
            //}
        },


        //--------posts-----xposts------settings------/
        setNewPost(post_type,post_type_name){
            this.post = {}; //refresh
            this.post.post_products = []; //initialise
            this.post.selected_post_products = []; //initialise //for hold
            this.post.post_temp_id = Math.random(); //for temp purposes
            this.post.post_type = post_type;
            this.post.post_type_name = post_type_name;
            this.setMenuComponent('newBusinessPosts',this.sellpoint,'');
        },
        

        getAppBusinessPosts(){ //2 business
            service.getXPosts(this, 2, this.sellpoint.business_id,0,50).then(response => {
                if(response.body.status == 200) {
                    this.posts = response.body.data;
                }
            }).catch((err) => { })
        },

        setAttachProductToPost(category){
            this.category = category;
            this.getBusinessCategoryProducts();
            this.setMenuTabInnerView('viewProducts');
            this.attachProductsComponentKey++;
        },

        attachProductToPost(product){
            if(product.is_attached_to_post == this.post.post_temp_id){ //use as check for now
                //remove from post_products array
                product.is_attached_to_post = 0;
                const indexa = this.post.post_products.findIndex(p => p === product.product_id); //best removal
                this.post.post_products.splice(indexa, 1);
                const indexm = this.post.selected_post_products.findIndex(p => p.product_id === product.product_id); //best removal
                this.post.selected_post_products.splice(indexm, 1);
            }else{
                product.is_attached_to_post = this.post.post_temp_id;
                this.post.post_products.push(product.product_id);
                this.post.selected_post_products.push(product);
            }
            
            this.attachProductsComponentKey++;
        },

        setAddGroupPost(){
            //get group type
            //get the poster type
            //get the poster type id
            if(this.group.group_posting_as_module == 3){
                this.post.post_point_type = 2; //business
            }else if(this.group.group_posting_as_module == 1){
                this.post.post_point_type = 3; //user
            }
            this.post.post_point_type = this.group.group_posting_as_module;
            this.post.post_point = this.group.group_posting_as_module_id;
            this.post.post_group = this.group.group_id || 0;
            //this.user.user_id,
            this.post.post_type = 2; //default post
            //
            this.post.post_products = [];
            //
            this.addNewPost();
        },

        addNewPostXX(){
            this.activate_processing();
            //some checks
            if(this.post.post_products.length > 0){this.post_has_products = 1;}else{this.post_has_products = 0;}
            var payload = {
                post_point_type: 2, //business
                post_point: this.sellpoint.business_id,
                post_type: this.post.post_type,
                post_parent: 0,
                post_title: this.post.post_title || "nil",
                post_post: this.post.post_details || "nil",
                post_start_date: this.post.post_start_date || "",
                post_end_date: this.post.post_end_date || "",
                post_product: this.post.post_product || 0,
                post_has_products: this.post_has_products || 0,
                post_products: this.post.post_products || [],
            }
          
            let navi = this.$router;
            if((payload.gallery_post_details != undefined) || (payload.gallery_post_details || 'nil')) {
                service.addXPosts(this, payload).then(function(data) {
                    if(data.body.status == 201) {
                        this.data_processing_message = "Post Created";
                        //log user in
                        // this.post = data.body.data; //dont use for now //to avoid oerriding pre settings
                        this.posts = data.body.data_posts;
                           
                        //add image //images //media  //multilple uploads loops
                        let uploads_count = 0;
                        if(this.imagesFormArray.length > 0){
                            for(let imageForm of this.imagesFormArray){
                                imageForm.append("data_id", this.post.post_id);
                                imageForm.append("data_type","post_media");
                                service.uploadDataPhoto(this, imageForm).then(data => {
                                    if(data.body.status == 200){
                                        uploads_count++;
                                        if(uploads_count == this.imagesFormArray.length){
                                            this.setMenuTabView('business','setBusinessPosts',this.sellpoint,'');
                                            this.setMenuComponent('',this.sellpoint,'')
                                            this.deactivate_processing();
                                        }
                                    }
                                }).catch((err) => {
                                    this.data_processing_message =  "Media upload may have a problem";
                                    this.deactivate_processing();
                                })
                            }
                        }else{
                            this.setMenuTabView('business','setBusinessPosts',this.sellpoint,'');
                            this.setMenuComponent('',this.sellpoint,'');
                            this.deactivate_processing();
                        }
                    }
                }).catch((err) => {
                    this.data_processing_message =  "Something went wrong";
                    this.deactivate_processing();
                })
            }else {
                this.data_processing_message = 'Kindly fill all fields';
                this.deactivate_processing();
            }
        },

        addNewPostNotification(){
            this.activate_processing();
            //some checks
            //img config
            let notification_has_image = 0;
            let notification_image_module = 0;
            let notification_image_module_id = 0;
            let notification_image_col = "";
            if(this.post.post_media && (this.post.post_media.length > 0)){
                notification_has_image = 1;
                notification_image_module = 18; //post media
                notification_image_module_id = this.post.post_media[0].post_media_id;
                notification_image_col = "psm_media";
            }else if(this.post.post_products && (this.post.post_products.length > 0)){
                notification_has_image = 1;
                notification_image_module = 17; //product media
                notification_image_module_id = this.post.post_products[0].product_images[0].product_image_id;
                notification_image_col = "pim_image";
            }

            var payload = {
                notification_custom_header: this.post.post_title,
                notification_custom_message: this.post.post_notification, //business
                notification_custom_url: "posts/"+this.post.post_url_name,
                notification_cta: 4, //New Update
                notification_has_image: notification_has_image,
                notification_image_module: notification_image_module,
                notification_image_module_id: notification_image_module_id,
                notification_image_col: notification_image_col, 
                notification_type: 3, //custom
                notification_module: 6, //posts
                notification_module_id: this.post.post_id,
                market_business: service.apiToken,
                notify_user_id: 0,
                notify_following: 1,
                business_id: this.sellpoint.business_id,
            }
          
            let navi = this.$router;
            if((payload.post_notification != undefined) || (payload.post_notification != '')) {
                service.addNotifications(this, payload).then(function(data) {
                    if(data.body.status == 201) {
                        this.data_processing_message = "Notification Added";
                        // this.posts = data.body.data_posts;
                        this.deactivate_processing();
                        this.setMenuTabInnerView('');
                    }
                }).catch((err) => {
                    this.data_processing_message =  "Something went wrong";
                    this.deactivate_processing();
                })
            }else {
                this.data_processing_message = 'Kindly fill all fields';
                this.deactivate_processing();
            }
        },

        //--------./posts-----xposts------settings------/

        //----groups-----//
        createGroup(){
            this.activate_processing();
            var payload = {
                group_module: 0,
                group_module_id: 0,
                group_name: this.group.group_name,
                group_description: this.group.group_description,
                group_type: this.group.group_type,
                group_created_by: this.user.user_id,
            }
          
            let navi = this.$router;
            if((payload.group_name != undefined) || (payload.group_name != '') && (payload.group_created_by != undefined) || (payload.group_created_by != 0)) {
                service.createNewGroup(this, payload).then(function(data) {
                    if(data.body.status == 201) {
                        this.data_processing_message = "Group Created";
                        //this.groups = data.body.data;
                        this.getAppGroups(); //call here
                        this.deactivate_processing();
                        this.setMenuComponent('')
                    }
                }).catch((err) => {
                    this.data_processing_message =  "Something went wrong";
                    this.deactivate_processing();
                })
            }else {
                this.data_processing_message = 'Kindly fill all fields';
                this.deactivate_processing();
            }
        },
        
        //group members
        addMembersToGroup(){
            let payload_arr = [];
            var payload = {
                member_group: this.group_member.group || 0,
                member_group_module: this.group_member.group_module || 0, //used to get group id if group was not specified
                member_group_module_id: this.group_member.group_module_id || 0,
                member_type: this.group_member.member_type || 0,
                member_module: this.group_member.member_module || 1,
                member_id: this.group_member.member_id || 0,
            }
            payload_arr.push(payload);
            this.addNewGroupMembers(payload_arr); // func from PostsCo
        },
        //--/groups------//

        //---lookbook-settings---------/
        addPostToGallery(){
            this.disable_btn = true;
            //this.business.agree = true;
            var credentials = {
                gallery_new_group: false,
                gallery_post_group: this.gallery.gallery_posts_group_id, 
                gallery_post_caption: this.post.post_caption || "nill",
                gallery_post_details: this.post.post_details,
            }
          
            let navi = this.$router;
            if(credentials.gallery_post_details != undefined) {
                service.addGallery(this, credentials).then(function(data) {
                    if(data.body.status == 201) {
                        toastr.success("Post Created", 'Success!');
                        //log user in
                        this.post = data.body.data;
                        
                        //add image
                        //let result = data.body.data;
                        this.imageForm.append("data_id", this.post.post_id);
                        this.imageForm.append("data_type","gallery_media");
                        service.uploadDataPhoto(this, this.imageForm).then(data => {
                        if(data.body.status == 200){
                            //this.product.product_image = data.body.data;
                            // location.reload(true);
                           // this.product_info = true;
                           this.setGallery();
                           this.gallery = data.body.data_gallery;
                           this.addNewPost = false;
                           this.edit_mode = false;
                            //this.product_url = "/"+this.$route.params.id+"/"+this.product.product_url_name;
                        }
                        }).catch((err) => {
                                if(err) {
                                // log it
                                // console.log(err)
                                }
                            toastr.warning("Something went wrong.", 'Warning!');
                        })

                        //navi.push("/"+this.$route.params.id+"/"+this.product.product_url_name); //changed for now, info on banner

                        
                    }
                }).catch((err) => {
                    if(err) {
                        toastr.warning("Something went wrong", 'Warning!'); 
                       // console.log(err)
                        this.disable_btn = false;
                    }
                })
            }else {
                toastr.error('Kindly fill all fields', 'Warning!');
                this.disable_btn = false;
            }
        },

        editLookbook(){
            this.activate_processing();
            //this.business.agree = true;
            var credentials = {
                gallery_group_name: this.lookbook.gallery_posts_group_name,
                gallery_group_description:this.lookbook.gallery_posts_group_text,
                gallery_group_point: this.sellpoint.business_id,
            }
          
            let navi = this.$router;
            if(credentials.gallery_group_name != undefined) {
                service.editGallery(this, this.lookbook.gallery_posts_group_id, credentials).then(function(data) {
                    if(data.body.status == 200) {
                        this.data_processing_message = "Lookbook Edited";
                        //log user in
                       // this.gallery = data.body.data;
                       //reset lookbook
                        this.deactivate_processing();
                        this.lookbook_details = {};

                    }else{
                    this.deactivate_processing();
                    this.editGalleryPanel = false;
                   }
                }).catch((err) => {
                    if(err) {
                       this.data_processing_message = "Something went wrong"; 
                       // console.log(err)
                       this.deactivate_processing();
                       this.lookbook_details = {};
                    }
                })
            }else {
                this.data_processing_message = 'Kindly fill all fields';
                this.disable_btn = false;
            }
        },

        deleteLookbook(){
            this.activate_processing();
            let navi = this.$router;
            service.deleteGallery(this, this.lookbook.gallery_posts_group_id).then(function(data) {
                if(data.body.status == 200) {
                   //return to sellpoint
                   //location.replace('/'+this.$route.params.id); //go to sellpoint
                  // reset data
                }else{
                    this.data_processing_message = "Something went wrong"; 
                    this.deactivate_processing();
                    this.lookbook_details = {};
                }
            }).catch((err) => {
                if(err) {
                    this.deactivate_processing();
                    this.lookbook_details = {};
                    this.data_processing_message = "Something went wrong";
                   // console.log(err)
                    // this.disable_btn = false;
                }
            })
        },

        
        editLookbookPost(){
            this.activate_processing();
            //this.business.agree = true;
            var credentials = {
                gallery_post_caption: this.lookbook_post.gallery_post_caption,
                gallery_post_details:this.lookbook_post.gallery_post_details,
                gallery_post_group: this.lookbook.gallery_posts_group_id,
            }
          
            let navi = this.$router;
            if(credentials.gallery_post_caption != undefined) {
                service.editGalleryPost(this, this.lookbook_post.gallery_post_id, credentials).then(function(data) {
                    if(data.body.status == 200) {
                        this.data_processing_message = "Lookbook Post Edited";
                        //log user in
                       // this.gallery = data.body.data;
                        this.deactivate_processing();
                        this.lookbook_details = {};
                        this.lookbook = data.body.data; //refresh data
                   }else{
                    this.deactivate_processing();
                    this.lookbook_details = {};
                   }
                }).catch((err) => {
                    if(err) {
                        this.data_processing_message = "Something went wrong"; 
                       // console.log(err)
                       this.deactivate_processing();
                       this.lookbook_details = {};
                    }
                })
            }else {
                this.data_processing_message = 'Kindly fill all fields';
                this.deactivate_processing();
            }
        },

        deleteLookbookPost(){
            this.activate_processing();
            let navi = this.$router;
            service.deleteGalleryPost(this, this.lookbook_post.gallery_post_id).then(function(data) {
                if(data.body.status == 200) {
                    this.lookbook = data.body.data; //refresh data
                    this.resetComponentData("lookbook");
                    this.deactivate_processing();
                    this.lookbook_details = {};
                }else{
                    this.data_processing_message = "Something went wrong"; 
                    this.deactivate_processing();
                    this.lookbook_details = {};
                }
            }).catch((err) => {
                if(err) {
                    this.deactivate_processing();
                    this.data_processing_message = "Something went wrong"; 
                    this.lookbook_details = {};
                }
            })
        },

        deletePostImage(image){
            this.activate_processing();
            var payload = {
                data_type: "gallery_media",
            }
            service.deleteImages(this, image, payload).then(function(data) {
                if(data.body.status == 200) {
                    this.deactivate_processing();
                }
            }).catch((err) => {})
        },
        //---./lookbook-settings---------/

        //invoicing and co
        isItemInList(item){
            for(let it of this.invoice_added_items){
                if(it.product_item_id == item.product_item_id){
                    return true;
                }
            }
        },

        addItemsToInvoice(item,product_data){
            //set items product data
            let set_data = {
                product_id: product_data.product_id,
                product_name: product_data.product_name,
                product_images: product_data.product_images,
            }
            item.product_data = set_data;
            item.order_item_order_quantity = 1; //default-set
            //ist add in
            if(this.invoice_added_items.length == 0){
                this.invoice_added_items.push(item);
            }else{
                let in_arr = false;
                for(let it of this.invoice_added_items){
                    if(it.product_item_id == item.product_item_id){
                        //this.invoice_added_items.push(item.product_item_id);
                        in_arr = true;
                    }
                }
                //
                if(!in_arr){
                    this.invoice_added_items.push(item);
                }
            }
        },

        removeItemsFromInvoice(item){
            let count = 0;
            for(let it of this.invoice_added_items){
                if(it.product_item_id == item.product_item_id){
                    this.invoice_added_items.splice(count, 1);
                }
                count++;
            }
        },

        //generate payment orders
        generatePaymentOrders(){
            let order_items = [];
            let order_amount = 0;

            //prep data
            for(let item of this.invoice_added_items){
                let set_item = {
                    order_item_module: 8,//order
                    order_item_module_id: item.product_item_id,
                    order_item_amount:item.product_item_price,
                    order_item_order_quantity:item.order_item_order_quantity,
                    order_module:4,//products
                    order_module_id: item.product_data.product_id,
                }
                order_amount = (order_amount + Number(item.product_item_price));
                //
                order_items.push(set_item);
            }
            
            //
            // let item = {
            //     order_item_module: 8,//order
            //     order_item_module_id: 718,
            //     order_item_amount:2800,
            //     order_item_order_quantity:1,
            // }
            // let item2 = {
            //     order_item_module: 8,//order
            //     order_item_module_id: 719,
            //     order_item_amount:2200,
            //     order_item_order_quantity:1,
            // }
            
            // order_items.push(item2)
            //
            if((this.sellpoint.business_id > 0) && (order_items.length > 0)){
                var payload = {
                    order_business:this.sellpoint.business_id,
                    order_module:3,//businesses
                    order_module_id: this.sellpoint.business_id,
                    order_amount:order_amount,
                    order_items:order_items,
                }
                service.generatePaymentOrder(this, payload).then(response => {
                    if(response.body.status == 201) {console.log('song-gg')
                        console.log(response.body)
                    }
                }).catch((err) => {})
            }
           
        },

        //uploads
        onFileChangePrep(e) {
            let files = e.target.files || e.dataTransfer.files;
            if (files.length)
            {   
                this.file_info = files;
                let formData = new FormData();
                formData.append('photo', files[0]); 
                this.imageForm = formData;
            }   
        
        },

        onFileChangeMultiplePrep(e) {
            let files = e.target.files || e.dataTransfer.files;
            if (files.length > 0)
            {   
                this.files_info = files;
                for(let file of files){
                    let formData = new FormData();
                    formData.append('photo', file); 
                    this.imagesFormArray.push(formData);
                }
            } 
        },

        onFileChange(e,type,data_id) {
            this.resetMessages(); //reset
            this.product_details = {}; //hack
            this.product_details.uploading_image = true;
            this.activate_processing();
            let files = e.target.files || e.dataTransfer.files;
            if (files.length)
            {
                let formData = new FormData();
                formData.append('photo', files[0]);
                formData.append('data_id', data_id);
                formData.append('data_type', type);  
                // formData.append('data_id', this.product_item.product_item_id);
                // formData.append('data_type', "product_items");   

                this.imageForm = formData;
                // if(!this.product_details.uploading_image){ //hack for disable double request
                    service.uploadDataPhoto(this, formData).then(data => {
                        if(data.body.status == 200){
                            if(type == "business_category"){
                                this.category.business_category_image = data.body.data;
                            }
                            // if(type == "product_item"){
                            //     this.product_item.product_item_image = data.body.data;
                            // }
                            if(type == "products"){
                                this.getProductImages();
                                if(this.product_details.editProductItemGroup){ //ie product_item_group edit going on
                                    this.product_item_group.product_item_group_image = data.body.data_id;
                                }
                            }
                            
                            if(type == "product_information"){
                                this.getProductInformation();
                            }

                            
                            this.deactivate_processing();
                            
                        }else{
                            this.data_processing_message = service.upload_media_error_msg;
                            this.deactivate_processing();
                        }
                        this.product_details.uploading_image = false;
                    }).catch((err) => {
                        this.data_processing_message = service.upload_media_error_msg;
                        this.deactivate_processing();
                        this.product_details.uploading_image = false;
                    })
                }
            // }   
                
        },

        //producta
        onFileChangeNewProduct(e) {
            let files = e.target.files || e.dataTransfer.files;
            if (files.length)
            {   
                this.file_info = files;
                let formData = new FormData();
                formData.append('photo', files[0]); 
                this.imageForm = formData;
            } 
            
            //set preview image
            document.getElementById('prImagePreview').src = window.URL.createObjectURL(files[0])
        
        },

        //productitems
        onFileChangeProductItems(e,type,data_id) {
            this.activate_processing();
            let files = e.target.files || e.dataTransfer.files;
            if (files.length)
            {
                let formData = new FormData();
                formData.append('photo', files[0]);
                formData.append('data_id', data_id);
                formData.append('data_type', type);  
                this.imageForm = formData;
                service.uploadDataPhoto(this, formData).then(data => {
                    if(data.body.status == 200){
                        if(type == "products"){
                            this.product.product_item_group_image = data.body.data_id;
                            // this.data_media_error_message = "";
                            this.getProductImages();
                        }
                    }
                }).catch((err) => {
                    if(err) {
                        // log it
                    }
                })
                //if uploading takes time continue with reload
                this.data_media_error_message = service.media_upload_timeout_msg;
                let self = this;
                setTimeout(function(){  self.data_media_error_message; }, 65000); //wait for 1min and timeout
                setTimeout(function(){  
                    // location.reload(true); 
                    self.data_media_error_message = "";
                }, 95000); //wait for 1min and timeout
            }   
                
        },

        ///process payments paystack
        //connect to a payment gateway
        processPayment() {
            //some onboarding
            this.data_processing_message = "Preparing Payment Information";
            //test data
            let data_test = false;
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            let email_test = re.test(String(this.app_orders.payer_email).toLowerCase());
            var re_phone = /^\d{4}\d{3}\d{4}$/;
            let phone_test = re_phone.test(String(this.app_orders.payer_phone).toLowerCase());
            // if((email_test == false) || (this.app_orders.payer_name == " ") || (phone_test == false)){
            if((email_test == false) || (this.app_orders.payer_name == " ")){
                data_test = false;
                this.data_error_message = "Please add an email to your account profile";
                this.deactivate_processing();
            }else{
                data_test = true;
                this.data_error_message = "";
            }
            if(data_test){
                 //process online payment
                    let obj = this;
                    //this.amount_paid = data.plan_amount;
                    var handler = PaystackPop.setup({
                    // key: 'pk_live_64fe633bf8a53b0346ef8a44f54dc41cc0aa9f8b',
                    key: 'pk_test_1b578e2fe82975a4ec8a79e5d1a387c953fd2c3e',
                    Name: this.app_orders.payer_name,
                    // email: data.plan_user_email || "admin@sellpoints.ng",
                    email: this.app_orders.payer_email,
                    amount:  (Math.round(this.app_orders.pay_amount * 100)),//(data.plan_amount * 100), //in kobo
                    ref: this.app_orders.pay_ref,
                    metadata: {
                        custom_fields: [
                           {
                                display_name: "Service",
                                variable_name: "service_type",
                                value: this.app_orders.pay_service_details
                            }
                            
                        ]
                    },
                    
                    callback: function(response){
                        obj.updatePayment(response.trxref); 
                    },
                    onClose: function(){
                        alert('window closed');
                    }
                    });
                    handler.openIframe();
                }

        },

        // update payments
        updatePayment(payment_ref) {
            //after validation
            //
            this.postBusinessProcessingFeeTransaction(payment_ref);
        },

        //integrated servies
        getRavepayBanks(){
            service.getRavepayBanks(this).then(response => {
                this.ravepay_bank_list = response.data.data.Banks;
            })
        },

        getIntegratedServices(){
            //rave pay bank list
            //OFFWKD--offline-not-working-offline
            // service.getRavepayBanks().then(response => {
            //     this.ravepay_bank_list = response.data.data.Banks;
            // })
            //OFFWKD
        },

        //reco products
        getRecommendedProducts(){
            service.getRecommendedProducts(this,this.user.user_id).then(response => {
                this.reco_products = response.body.data;;
            })
        },

        //--activities
        sendInboundMessages(type){
            //set payload
            var payload = {
                contact_type: type, //eg 54, //join market tribe request //53 //to appy to create your own market trybe
                contact_from_module: 1, //user
                contact_from_module_id: this.user.user_id,
            }
          
            let navi = this.$router;
            let set_payload = {};
            if((payload.contact_from_module_id != 0)) {
                set_payload = payload;
            }
            
            //set activity
            if(Object.keys(set_payload).length > 0){
                this.activity.activity_module_action_type = 6;
                //--set activity payload
                let data_payload = {
                    data_id: this.group.ref_code, 
                }
                this.activity.activity_module_data = data_payload;

                //call activity
                this.getActivity();
            }
        },


        //---------------html-cards
        getProductsCard(){
            return(`<div class="card col-xs-6 card-col-2" v-for="(product,index) in products" style="margin-bottom: 0.8em;"> 
              <a @click="postChatObject(product)" style="text-decoration: none; color:inherit; cursor: pointer;">
                <!-- <span class="card-thumb-up-left"><i class="fa fa-shopping-bag"></i></span> -->
                <div class="card-col-img" style="margin-bottom: 0.8em; border-left: #f5f5f5 solid 0.35em; border-radius: 4px;">
                  <img v-if="product.product_images[0]" :src="product.product_images[0].product_image" class="img-responsive">
                  <img v-else src="/static/assets/images/dummy-image.png">
                </div>
                <div class="card-col-details" style="display:block;">
                  <p style="font-size:13px; text-align: center;">{{product.product_name}}<br>
                    <span v-if="product.product_items[0]" class="sp-app-default-color">₦{{product.product_items[0].product_item_price_f}}</span>
                  </p>
                </div>
              </a>
            </div>`);
        
        },

        getProductCard(){
            if((this.product.product_images[0] != undefined) && (this.product.product_items[0] != undefined)){
                return (
                    // "<span class='plain-bold'>Producfftvv:</span> "+ this.product.product_name
                    `<div class='card card-01 timeline-user-card'> 
                        <div class="card-left">
                            <div class="card-avatar-square">
                            <img v-if="`+this.product.product_images[0]+`" src="`+this.product.product_images[0].product_image+`">
                            <img v-else src="/static/assets/images/dummy-image.png">
                            </div>
                        </div>
                        <div class="card-right">
                            <div class="card-arm-line">
                            <p>`+this.product.product_name+`<br>
                            <span v-if="`+this.product.product_items[0]+`">₦`+this.product.product_items[0].product_item_price_f+ ` - ` + `₦`+this.product.product_items[0].product_item_price_f+
                            `</span>
                            </p>

                            </div>
                    </div>`
                );
            }else{
                return (
                    `<div class='card card-label'> 
                        <div class="card-label-left">
                            <div class="card-avatar-square">
                            <img src="/static/assets/images/dummy-image.png">
                            </div>
                          </div>
                          <div class="card-label-right">
                            <div class="card-arm-line">
                              <p>`+this.product.product_name+`</p>
                         </div>
                    </div>`
                );
            }

        },


        //----------------html-cards

        //--------fix-headers

        setPageHeaders(){
            // When the user scrolls the page, execute myFunction
            window.onscroll = function() {
                // Get the header
                var stick_header = document.getElementById("pageStickyHeader");
                if((stick_header != this.undefined) || (stick_header != null)){
                    var main_stick_header = document.getElementById("mainStickyHeader");
                    var head_arrow_back = document.getElementById("headTagBack");
                    // Get the offset position of the navbar
                    var sticky = stick_header.offsetTop;
        
                    // Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
                    if (window.pageYOffset > sticky) {
                        main_stick_header.classList.add("header-main-unfix");
                        stick_header.classList.add("header-sticky-after-2");
                        // head_arrow_back.classList.add("element-display-block");
                        stick_header.style.marginTop = "1em"; //add more margin to help set
                        head_arrow_back.style.display = "block";
                        head_arrow_back.style.marginLeft = "-1em";
                        head_arrow_back.style.marginTop = "0.6em";
                    } else {
                        stick_header.classList.remove("header-sticky-after-2");
                        main_stick_header.classList.add("header-main-refix");
                        // head_arrow_back.classList.add("element-display-none");
                        head_arrow_back.style.display = "none";
                    }
                }
            };
        },

        unsetPageHeaders(){
            window.onscroll = function() {
                // Get the header
                var stick_header = document.getElementById("pageStickyHeader");
                var main_stick_header = document.getElementById("mainStickyHeader");
                var head_arrow_back = document.getElementById("headTagBack");
                // Get the offset position of the navbar
                // var sticky = stick_header.offsetTop;
    
                //    stick_header.classList.remove("header-sticky-after-2");
                   main_stick_header.classList.add("header-main-refix");
                   main_stick_header.classList.add("header-sticky");
                //    head_arrow_back.style.display = "none";
        
            };
        },
    


        //--------fix-headers
        /*-------------------------Adminboarding--------------------------------------*/

        //utilities
        getUtilities(){
            service.getUtilities(this).then(response => {
                this.data_call_to_actions = response.body.data_call_to_actions;
                this.data_components_services = response.body.data_components_services;
            }).catch((err) => {
                if(err) {
                    // log it
                }
            })
        },

        setSom(){
            this.menu_link = {};
        },

        //
        getUserAppData(){
            //get folders
            service.getFolders(this,1,this.user.user_id).then(response => {
                let folders = response.body.data;
                let self = this;
                for(let folder of folders){
                    //start grouping
                    //..saved shops
                    if(folder.folder_type == 9){
                        for(let item of folder.folder_items){
                            self.saved_shops.push(item.folder_item_module_data);
                        }
                    }
                    //..//saved shops
                }
            }).catch((err) => {
                if(err) {
                    // log it
                }
            })
            
        },

        getUsersDetails(attr,set_data,request_type){

            // //return user
            // this.data_user.name = 'Okey Uwah';
            // this.data_user.email = 'okeyuwah2000@yahoo.com';
            // this.data_user.phone = '09023445677';
            
            var payload = {
                search_name: attr,
            }
            
            if(payload.search_name != ''){
                service.searchForUser(this, payload).then(function(data) {
                    if(data.body.status == 200) {
                        //return user
                        let user_data = data.body.data;
                        //
                        this.data_user.name = 'Okey Uwah';
                        this.data_user.email = 'okeyuwah2000@yahoo.com';
                        this.data_user.phone = '09023445677';

                        //set settings
                        if(request_type == "get_customer_details_for_invoice_request"){
                            this.setMenuTabView('','selectItemsForInvoice');
                        }

                    }else if(data.body.status == 404) {
                        this.data_error_message = "Could not find any matching Customer , please check the data you entered and try again"
                    }
                }).catch((err) => {})
            }

        },
    
        setAppBusinessSubscriptionOffersXX(service_offer){
            let offer_set = this.$store.getters['account/getSellpointAppSubscriptionOffers'];
            this.business_app_subscription_offers = offer_set;
            for(let offer of this.business_app_subscription_offers){
                if(offer.service_offer == service_offer){
                   return offer;
                }
            }
        },
        //../businesss subs

        //---new funcs

        //setters
        setGetAppBusiness(business_username,set_redir){console.log('song-0010')
            service.getAppBusinessByUserName(this,business_username).then(response => {
                if(response.body.status == 200){console.log('song-0011')
                    let payload = response.body.data;
                    this.$store.dispatch('account/setBusiness',payload);
                    this.componentKey++;
                    //redir
                    if(set_redir == 1){
                        //this.$router.push("/account/business");
                        //check if an active dynamic request was sent here 
                        let self = this;
                        localforage.getItem(self.getService.adr_db_name, function(err, value) { //quick with the callback version
                            if((value != undefined) && (value.link != "/account")) {console.log(5988+value.link);
                                self.$router.push(value.link);
                            }else {console.log(6988);
                                self.$router.push("/account/business");
                            }
                        });
                    }else{
                        location.reload(true);
                    }
                    //this.$router.push("/account/business");
                }
            }).catch((err) => {})
        },

        storeSetBusiness(business_username,set_type){
            let load = false;
            let set_business_username = business_username;
            //this.$store.dispatch('account/setBusiness',business_username);
            if(set_type == 1){ console.log('song-006')
                //get this particular requeste
                // var payload = {
                //     username:business_username,
                //     redir:'/account/business',
                // }
                // this.$store.dispatch('account/setBusiness',payload);
                load = true;
                this.setGetAppBusiness(set_business_username,1);
            }else{console.log('song--008')
                //check if a business is in store first //pick default //first business in array
                let self = this;
                localforage.getItem('xvue', function(err, value) { //quick with the callback version
                    if(value != undefined) {console.log('song-009')
                        let current_sellpoint =  value.account.store_sellpoint.store_sellpointData;
                        if((!current_sellpoint) || (current_sellpoint == undefined)){
                            //assign first one in the sellpoints array
                            let sellpoints = self.$store.getters['account/getUserBusinesses'];
                            if(Object.keys(sellpoints).length > 0){
                                set_business_username = sellpoints[0].business_username;
                            }
                            //
                            load = true;
                            self.setGetAppBusiness(set_business_username,2);
                        }else{
                            //set_business_username = current_sellpoint.business_username;
                            //redir//a business is already in store
                           //--- self.$router.push("/account/business");
                        }
                    }else{
                        //redir//to account please
                        self.$router.push("/account");
                    }
                });
            }

            //
        },

        //loaders
        loadUser(){
            let self = this;
            localforage.getItem('xvue', function(err, value) { //quick with the callback version
                if(value != undefined) {
                    self.user = value.account.store_sellpoint.store_user;
                }else{}
            });
        },

        loadBusiness(){
            let self = this;
            localforage.getItem('xvue', function(err, value) { //quick with the callback version
                if(value != undefined) {
                    self.sellpoint = value.account.store_sellpoint.store_sellpointData;
                }else{}
            });
        },
        
        loadCategories(){
            let self = this;
            localforage.getItem('xvue', function(err, value) { //quick with the callback version
                if(value != undefined) {
                    //store_sellpoint.store_categories
                    // self.categories = value.account.store_sellpoint.store_categories;
                    self.categories = value.account.store_sellpoint.store_sellpointData.business_categories;
                    //self.categories = value.account.store_sellpoint.business_categories;
                    self.sellpoint.business_categories = value.account.store_sellpoint.store_categories;
                }else{}    
                self.loading = false;
            });
        },

        loadCategory(){
            let self = this;
            localforage.getItem('xvue', function(err, value) { //quick with the callback version
                if(value != undefined) {
                    self.category = value.account.store_sellpoint.store_category;
                }else{}
            });
        },

        loadProducts(){
            let self = this;
            self.loading = true;
            localforage.getItem('xvue', function(err, value) { //quick with the callback version
                if(value != undefined) {
                    self.products = value.account.store_sellpoint.store_products;
                    //self.loading = false;
                }else{} 
                self.loading = false;
            });
        },

        //---main account load base
        loadAccountBase(){
            this.loading = true;
            let self = this;
            this.user = this.$store.getters['account/getUser'];
            //console.log(899); console.log(this.user)
            if((this.user == undefined) || (Object.keys(this.user).length == 0)){
                localforage.getItem(service.udb_name, function(err, value) { //quick with the callback version
                    if(value != undefined) {
                        self.user = value;
                        //special case for profile
                        self.loadSetUser(self.user.user_id);
                        //../special case for profile
                        self.loading = false;
                    }else {
                        //check if an active dynamic request was sent here 
                        let request_data = {};
                        localforage.getItem(service.adr_db_name, function(err, value) { //quick with the callback version
                            if(value != undefined) {
                                request_data = value;
                            }else {
                                //else create new one
                                var request_data = {
                                    "name": "Account", //use route component name
                                    "link": "/account",
                                    "dir": "/account",
                                    "src": "/account",
                                    "msg": "Login to manage your account",
                                    "track": 1, //created//started
                                }
                            }
                            //activate dynamic request
                            localforage.setItem(service.adr_db_name, request_data).then(function (value) {
                            }).catch(function(err) {});
                            //then redirect to login
                            self.$router.push('/login');
                        });
                        //self.$router.push('/login');
                    }
                });
            }else{
                //user exist in store
                if(Object.keys(this.user).length > 0){
                    this.loading = false;
                    this.loadSetUserDetails();
                }else{
                    this.$router.push('/login');
                }
            }
        },

        loadSetUser(user_id){
            this.$store.dispatch('account/setUserData',user_id);
            //wait and call getUSer
            // this.getUser();
            let self = this;console.log('song-00')
            setTimeout(function(){ 
                //self.loadGetUser(); 
                if(self.user.user_id > 0){console.log('song--01')
                    self.loadSetUserBusinesses();
                }
            }, 3000); //wait for 3sec 
        },

        loadGetUserXX(){
            //this.user = this.$store.getters['account/getUser'];
            // if((this.user.user_email != undefined) && (this.user.user_id > 0)){
            if(this.loadSetUser){
                if(this.user.user_id > 0){
                    this.loadSetUserBusinesses();
                }else{}
            }
        },

        loadSetUserDetails(){
            //user businesses
            this.loadSetUserBusinesses();
        },

        loadSetUserBusinesses(){
            if(this.user.user_id > 0){
                this.$store.dispatch('account/userAccountBusinesses',this.user.user_id);
                let self = this;console.log('song-003')
                setTimeout(function(){ self.loadGetUserBusinesses(); }, 3000); //wait for 3sec 
            }
        },

        loadGetUserBusinesses(){console.log('song-004')
            //get sps
            //this.sellpoints = this.$store.getters['account/getUserBusinesses'];
            // //assign 1
            // if((this.sellpoints != null) && (Object.keys(this.sellpoints).length > 0)){console.log('song--005')
            //     this.storeSetBusiness('',0); //0-use 0 here in a case a business exist in store
            //     this.loading = false
            // }
            let self = this;
            localforage.getItem('xvue', function(err, value) { //quick with the callback version
                if(value != undefined) {console.log('song-004-a')
                    self.sellpoints = value.account.store_sellpoints;
                    if((self.sellpoints != null) && (Object.keys(self.sellpoints).length > 0)){console.log('song--005')
                        self.storeSetBusiness('',0); //0-use 0 here in a case a business exist in store
                        self.loading = false
                    }
                }else{
                    console.log('song-004-b') 
                    location.reload(true); //test-use for now //relod case of data lag
                }
            })
        },
        //---./main account load

        //.//loaders
    },

    created: function(){ 
        //set some default calls
        this.getStates();
        this.getUtilities();
        this.getCategories();
        // this.getAppDeliveryPartners();
        // this.getBusinessMarketGroups();
        //
        this.is_product_service = "product";

    }

}


// WEBPACK FOOTER //
// ./src/pages/Account/Resources/commonfunctions.js